export default {
  quickActions: 'ການດຳເນີນການດ່ວນ',
  servers: {
    name: 'ເຊີບເວີ',
    auto: 'ອັດຕະໂນມັດ',
    vietnam: 'ຫວຽດນາມ',
    singapore: 'ສິງກະໂປ',
    main: 'ຫຼັກ',
    reserve: 'ສຳຮອງ'
  },
  boss: 'ເຈົ້າຂອງຮ້ານ',
  cart: 'ກະຕ່າ',
  line: 'ແຖວ',
  gotit: 'ເຂົ້າໃຈແລ້ວ',
  timezone: 'ເຂດເວລາ',
  timezoneHint: 'ການອັບເດດເຂດເວລາອາດເຮັດໃຫ້ຂໍ້ມູນລາຍງານປ່ຽນແປງ',
  download: 'ດາວໂຫຼດ',
  collapse: 'ຫຍໍ້',
  expand: 'ຂະຫຍາຍ',
  salesman: 'ພະນັກງານຂາຍ',
  sort: 'ຈັດລຳດັບ',
  appNotAvailable: 'ແອັບນີ້ຍັງບໍ່ພ້ອມໃຊ້. ກະລຸນາລອງໃໝ່ພາຍຫຼັງ!',
  getStart: 'ເລີ່ມຕົ້ນ',
  itemPerPage: 'ຈຳນວນຕໍ່ໜ້າ',
  takeAway: 'ຫໍ່ກັບບ້ານ',
  printBill: 'ພິມໃບບິນ',
  barcodeText: 'ລະຫັດ (ຕົວອັກສອນ)',
  now: 'ດຽວນີ້',
  hour: 'ຊົ່ວໂມງ',
  minutes: 'ນາທີ',
  second: 'ວິນາທີ',
  limitFeatureForFree: 'ຟັງຊັນນີ້ມີໃນເວີຊັນພຣີມຽມເທົ່ານັ້ນ. ກະລຸນາອັບເກຣດເພື່ອໃຊ້!',
  orderIsPaying: 'ອໍເດີກຳລັງຊຳລະເງິນ',
  canUpdateOrder: 'ທ່ານແນ່ໃຈບໍວ່າຈະຍົກເລີກ? ການປ່ຽນແປງຈະບໍ່ຖືກອັບເດດ!',
  charge: 'ຄິດເງິນ',
  checkout: 'ຄິດເງິນ',
  commingSoon: 'ຍັງບໍ່ພ້ອມໃຊ້',
  upcoming: 'ກຳລັງຈະມາ',
  notActive: 'ຍັງບໍ່ເປີດໃຊ້',
  hidden: 'ເຊື່ອງແລ້ວ',
  content: 'ເນື້ອຫາ',
  close: 'ປິດ',
  showing: 'ກຳລັງສະແດງ',
  addShortCut: 'ເພີ່ມທາງລັດ',
  billUIChoice: 'ເລືອກໜ້າຕາໃບບິນ',
  qrUIChoice: 'ເລືອກໜ້າຕາ QR',
  devicePermissionDenied: 'ທ່ານຕ້ອງອະນຸຍາດເພື່ອໃຫ້ແອັບເຮັດຟັງຊັນນີ້!',
  permissionNotifyInfo: 'ທ່ານຕ້ອງອະນຸຍາດແຈ້ງເຕືອນເພື່ອໃຫ້ຟັງຊັນນີ້ເຮັດວຽກ!',
  oldVersion: 'ເວີຊັນເກົ່າ',
  changeText: 'ປ່ຽນ',
  value: 'ຄ່າ',
  confirmDelete: 'ທ່ານແນ່ໃຈບໍວ່າຈະລຶບລາຍການນີ້?',
  choiceProductUnitConvertWarning: 'ກະລຸນາເລືອກຫົວໜ່ວຍຂອງສິນຄ້າ',
  deprecated: 'ກຳລັງຈະເລີກໃຊ້',
  saving: 'ກຳລັງບັນທຶກ',
  active: 'ເປີດໃຊ້',
  featureUnderDev: 'ຟັງຊັນນີ້ກຳລັງພັດທະນາ. ກະລຸນາກັບມາໃໝ່ພາຍຫຼັງ!!',
  spending: 'ລາຍຈ່າຍ',
  overview: 'ພາບລວມ',
  recommend: 'ແນະນຳ',
  savePdf: 'ບັນທຶກ PDF',
  bankQR: 'QR ບັນຊີທະນາຄານ',
  quantityInvalid: 'ຈຳນວນບໍ່ຖືກຕ້ອງ',
  returnToHome: 'ກັບໄປໜ້າຫຼັກ',
  forever: 'ຕະຫຼອດຊີວິດ',
  expired: 'ໝົດອາຍຸ',
  expiredShort: 'ໝົດອາຍຸ',
  barcodeTable: 'ຕາຕະລາງບາໂຄດສິນຄ້າ',
  price: 'ລາຄາ',
  copied: 'ສຳເນົາແລ້ວ!',
  autoGen: 'ສ້າງອັດຕະໂນມັດ',
  check: 'ກວດສອບ',
  signature: 'ລາຍເຊັນ',
  permission: 'ສິດອະນຸຍາດ',
  staffLogin: 'ພະນັກງານເຂົ້າລະບົບ',
  staffSale: 'ພະນັກງານຂາຍ',
  updateInfo: 'ອັບເດດຂໍ້ມູນ',
  staffPermission: {
    title: 'ສິດອະນຸຍາດຂອງພະນັກງານ',
    detail: 'ກຳນົດສິດໃຫ້ພະນັກງານໃຊ້ງານໂດຍກົງໃນ WEB/APP ຈັດການ. App ສຳລັບພະນັກງານອາດບໍ່ມີບາງຟັງຊັນເຫຼົ່ານີ້',
    allOrderType: 'ອໍເດີຂາຍ, ນຳເຂົ້າ, ສົ່ງຄືນ',
    showRevenue: 'ສະແດງກຳໄລໃນອໍເດີ',
    financial: 'ໃບຮັບເງິນ ແລະ ໃບຈ່າຍເງິນ',
    showAllCustomer: 'ສະແດງລູກຄ້າທັງໝົດ',
    showAllCustomerDetail: 'ເຂົ້າເຖິງລູກຄ້າທັງໝົດທີ່ບໍ່ໄດ້ສ້າງໂດຍພະນັກງານຄົນນີ້',
    editPrice: 'ອະນຸຍາດໃຫ້ແກ້ໄຂລາຄາຂາຍ',
    editPriceDetail: 'ອະນຸຍາດໃຫ້ພະນັກງານແກ້ໄຂລາຄາຂາຍລະຫວ່າງຂາຍ. ຖ້າບໍ່, ສິນຄ້າຈະຖືກຂາຍຕາມລາຄາປີກ.',
    showAllOrder: 'ສະແດງອໍເດີທັງໝົດ',
    showAllOrderDetail: 'ສະແດງອໍເດີທັງໝົດຂອງຜູ້ຈັດການ ແລະ ພະນັກງານຄົນອື່ນ',
    canViewFinancialStats: 'ເບິ່ງກະແສເງິນສົດ',
    canViewFinancialStatsDetail: 'ອະນຸຍາດໃຫ້ພະນັກງານເບິ່ງລາຍງານກະແສເງິນສົດຂອງຕົນເອງ',
    canViewDebtStats: 'ເບິ່ງໜີ້ສິນ',
    canViewDebtStatsDetail: 'ເບິ່ງໜີ້ສິນຂອງຮ້ານທັງໝົດ',
    canViewWarehouseStats: 'ເບິ່ງລາຍງານສາງສິນຄ້າ',
    canViewWarehouseStatsDetail: 'ເບິ່ງລາຍງານສະຖານະສາງສິນຄ້າ',
    canViewSalesStats: 'ເບິ່ງລາຍງານຍອດຂາຍ',
    canViewSalesStatsDetail: 'ເບິ່ງລາຍງານຍອດຂາຍລວມຂອງຮ້ານທັງໝົດ',
    canExportEInvoice: 'ອອກໃບກຳກັບອີເລັກໂທຣນິກ',
    canExportEInvoiceDetail: 'ພະນັກງານສາມາດອອກໃບກຳກັບອີເລັກໂທຣນິກໄດ້',
    roleAndAccess: 'ບົດບາດ ແລະ ການເຂົ້າເຖິງ',
    roleAndAccessSubtitle: 'ຕັ້ງຄ່າບົດບາດ ແລະ ການເຂົ້າເຖິງສາງສິນຄ້າໃຫ້ພະນັກງານ',
    role: 'ບົດບາດ',
    roleManager: 'ຜູ້ຈັດການ',
    roleRegular: 'ພະນັກງານທົ່ວໄປ',
    warehouseAccess: 'ການເຂົ້າເຖິງສາງສິນຄ້າ',
    allWarehouses: 'ສາງສິນຄ້າທັງໝົດ',
    selectWarehouses: 'ເລືອກສາງສິນຄ້າທີ່ເຂົ້າເຖິງໄດ້:',
    warehouseAccessDenied: 'ທ່ານບໍ່ມີສິດເຂົ້າເຖິງສາງສິນຄ້ານີ້',
    managerNote: 'ຜູ້ຈັດການມີສິດທັງໝົດ ຍົກເວັ້ນການອັບເດດບັນຊີຮ້ານ ແລະ ການຈັດການພະນັກງານ.',
    dataOperation: 'ສິດທິການຈັດການຂໍ້ມູນ',
    featuresAndStats: 'ສິດທິການເບິ່ງ ແລະ ຟັງຊັນ'
  },
  renew: 'ຊື້ຕອນນີ້',
  updatedAt: 'ອັບເດດເມື່ອ',
  saveDraft: 'ບັນທຶກຮ່າງ',
  buy: 'ຊື້',
  birthday: 'ວັນເກີດ',
  barcodeNotFound: 'ບໍ່ພົບບາໂຄດນີ້!',
  saved: 'ບັນທຶກແລ້ວ',
  saveImage: 'ບັນທຶກຮູບ',
  next: 'ຕໍ່ໄປ',
  reality: 'ຄວາມເປັນຈິງ',
  difference: 'ສ່ວນຕ່າງ',
  hide: 'ເຊື່ອງ',
  editComponent: 'ແກ້ໄຂສ່ວນປະກອບ',
  amount: 'ຈຳນວນ',
  search: 'ຄົ້ນຫາ',
  simple: 'ງ່າຍ',
  more: 'ເພີ່ມເຕີມ',
  share: 'ແບ່ງປັນ',
  inventoryDelivery: 'ໃບຈ່າຍສາງ',
  type: 'ປະເພດ',
  transactionHistory: 'ປະຫວັດທຸລະກຳ',
  blanceAndDebt: 'ຍອດຄົງເຫຼືອ/ໜີ້ຄ້າງຊຳລະ',
  limitWarning: 'ບັນຊີຂອງທ່ານຖືກຈຳກັດເນື່ອງຈາກມີການຄືນເງິນຊ້ຳໆ. ຖ້າເກີນ 3 ຄັ້ງ, ບັນຊີຈະຖືກລັອກຖາວອນ ແລະ ບໍ່ສາມາດກູ້ຄືນຂໍ້ມູນໄດ້. ຂອບໃຈ!',
  upgradePro: 'ອັບເກຣດ',
  iapSupport: '',
  emptyData: 'ບໍ່ມີຂໍ້ມູນ',
  seemore: 'ເບິ່ງເພີ່ມ',
  version: 'ເວີຊັນ',
  financialIn30days: 'ການເງິນໃນ 30 ມື້ຜ່ານມາ',
  financialInMonth: 'ການເງິນເດືອນນີ້',
  orFastLoginWith: 'ເຂົ້າລະບົບໄວດ້ວຍບັນຊີ Google, Apple',
  fontSize: 'ຂະໜາດຕົວອັກສອນ',
  changeFontSizeWarning: 'ຂະໜາດຕົວອັກສອນຖືກປ່ຽນແລ້ວ. ທ່ານຄວນອອກຈາກແອັບ ແລ້ວເປີດໃໝ່ ເພື່ອໃຫ້ແອັບເຮັດວຽກໄດ້ຢ່າງສະຖຽນ',
  fontSizeList: ['ນ້ອຍຫຼາຍ', 'ນ້ອຍ', 'ປານກາງ', 'ໃຫຍ່', 'ໃຫຍ່ຫຼາຍ', 'ໃຫຍ່ຫຼາຍໆ'],
  contact: 'ຕິດຕໍ່',
  cause: 'ເຫດຜົນ',
  default: 'ຄ່າເລີ່ມຕົ້ນ',
  manager: 'ຜູ້ຈັດການ',
  paymentMethod: 'ວິທີຊຳລະ',
  closeWarning: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການປິດຟັງຊັນນີ້?',
  paymentMethodList: ['ເງິນສົດ', 'ໂອນທະນາຄານ', 'ຕິດໜີ້'],
  printerVideoDemo: 'ວິດີໂອແນະນຳການເຊື່ອມຕໍ່',
  supportWarning: 'ຖ້າຕ້ອງການຄວາມຊ່ວຍເຫຼືອ ກະລຸນາຕິດຕໍ່ຊ່ອງທາງ Facebook ຂອງທີມພັດທະນາ. ຂອບໃຈທີ່ສະໜັບສະໜູນ!',
  offlineWarning: 'ທ່ານກຳລັງໃຊ້ງານແບບອອບລາຍ. ຄວນລົງທະບຽນບັນຊີເພື່ອໃຊ້ງານອອນລາຍ ເພື່ອຫຼີກລ່ຽງການສູນເສຍຂໍ້ມູນ ແລະໃຊ້ຟີເຈີອື່ນໆ ລວມທັງເວີຊັນຄອມພິວເຕີ.',
  updating: 'ກຳລັງອັບເດດ',
  loadingData: 'ກຳລັງກຽມຂໍ້ມູນ',
  loadingHint: 'ລະບົບກຳລັງປະມວນຜົນ, ກະລຸນາລໍຖ້າ...',
  remain: 'ຄົງເຫຼືອ',
  choiceProductTypeWarning: 'ກະລຸນາເລືອກໝວດໝູ່ສິນຄ້າ',
  editProduct: 'ແກ້ໄຂສິນຄ້າ',
  onlyOnlineSupport: 'ຟີເຈີນີ້ຮອງຮັບສະເພາະການໃຊ້ງານອອນລາຍ. ກະລຸນາເຂົ້າສູ່ບັນຊີເພື່ອໃຊ້ຟີເຈີນີ້!',
  createBy: 'ສ້າງໂດຍ',
  userName: 'ຊື່ຜູ້ໃຊ້',
  fullName: 'ຊື່ເຕັມ',
  webVersion: 'ເວີຊັນເວັບ (PC)',
  webVersionBackup: 'ລິ້ງສຳຮອງ',
  syncingProgress: 'ກຳລັງຊິງຂໍ້ມູນ. ກະລຸນາລໍຖ້າ 1 - 15 ນາທີ. ພວກເຮົາຈະສົ່ງອີເມວໃຫ້ທ່ານເມື່ອຂະບວນການສຳເລັດ',
  bulkDelete: 'ລຶບຫຼາຍລາຍການ',
  sync: 'ຊິງຂໍ້ມູນ',
  offline: 'ອອບລາຍ',
  offlineNotSupport: 'ຮອງຮັບອອນລາຍເທົ່ານັ້ນ',
  warning: 'ຄຳເຕືອນ',
  back: 'ກັບຄືນ',
  yes: 'ແມ່ນ',
  no: 'ບໍ່',
  refresh: 'ໂຫຼດໃໝ່',
  home: 'ໜ້າຫຼັກ',
  quantity: 'ຈຳນວນ',
  tryAgain: 'ລອງໃໝ່',
  language: 'ພາສາ',
  theme: 'ຮູບແບບ',
  dark: 'ມືດ',
  light: 'ສະຫວ່າງ',
  total: 'ລວມ',
  totalMoney: 'ຍອດເງິນລວມ',
  paid: 'ຊຳລະແລ້ວ',
  totalDebit: 'ໜີ້ລວມ',
  totalOldDebit: 'ໜີ້ເກົ່າ',
  totalReminder: 'ຍອດຄົງເຫຼືອລວມ',
  totalOldReminder: 'ຍອດຄົງເຫຼືອເກົ່າ',
  oldPrint: 'ພິມໃບບິນ (ງ່າຍ)',
  debit: 'ຍັງຄ້າງ',
  remainder: 'ເຫຼືອ',
  arrears: 'ຄ້າງຊຳລະ',
  status: 'ສະຖານະ',
  add: 'ເພີ່ມ',
  create: 'ສ້າງໃໝ່',
  save: 'ບັນທຶກ',
  print: 'ພິມ',
  export: 'ສົ່ງອອກໃບບິນ',
  copy: 'ສຳເນົາ',
  edit: 'ແກ້ໄຂ',
  delete: 'ລຶບ',
  update: 'ອັບເດດ',
  updateStatus: 'ອັບເດດສະຖານະ',
  day: 'ມື້',
  month: 'ເດືອນ',
  year: 'ປີ',
  from: 'ຈາກ',
  to: 'ເຖິງ',
  fromDate: 'ແຕ່ວັນທີ',
  toDate: 'ເຖິງວັນທີ',
  choiceImage: 'ເລືອກຮູບ',
  exist: 'ມີແລ້ວ',
  invalidParams: 'ກະລຸນາປ້ອນຂໍ້ມູນທີ່ຈຳເປັນໃຫ້ຄົບ',
  success: 'ສຳເລັດ',
  fail: 'ລົ້ມເຫຼວ',
  all: 'ທັງໝົດ',
  complete: 'ສຳເລັດ',
  pending: 'ລໍຖ້າ',
  canceled: 'ຍົກເລີກແລ້ວ',
  cancel: 'ຍົກເລີກ',
  ok: 'ຕົກລົງ',
  or: 'ຫຼື',
  choice: 'ເລືອກ',
  confirm: 'ຢືນຢັນ',
  confirmExitApp: 'ທ່ານຕ້ອງການອອກຈາກແອັບບໍ?',
  time: 'ເວລາ',
  notFound: 'ບໍ່ພົບຂໍ້ມູນ. ກະລຸນາລອງໃໝ່!',
  createdAt: 'ວັນທີສ້າງ',
  none: 'ບໍ່ມີ',
  detail: 'ລາຍລະອຽດ',
  filter: 'ກັ່ນຕອງ',
  filterByTim: 'ກອງຕາມວັນທີ',
  note: 'ໝາຍເຫດ',
  trial: 'ທົດລອງ',
  option: 'ຕົວເລືອກ',
  notify: 'ແຈ້ງເຕືອນ',
  understand: 'ເຂົ້າໃຈແລ້ວ',
  exportToExcel: 'ສົ່ງອອກ Excel',
  multiHidden: 'ເຊື່ອງຫຼາຍລາຍການ',
  multiActive: 'ເປີດໃຊ້ງານຫຼາຍລາຍການ',
  hiddenList: 'ລາຍການທີ່ຖືກເຊື່ອງ',
  showList: 'ລາຍການທີ່ເປີດໃຊ້ງານ',
  importDataFromExcel: 'ນຳເຂົ້າຈາກ Excel',
  describe: 'ຄຳອະທິບາຍສິນຄ້າ',
  addImage: 'ເພີ່ມຮູບ',
  limitUpload: 'ສູງສຸດ 5 ຮູບຕໍ່ສິນຄ້າ',
  sorryText:
    'ສະບາຍດີ!\n ມື້ວານນີ້ທີມພັດທະນາໄດ້ປ່ອຍອັບເດດໃໝ່. ເນື່ອງຈາກຂະບວນການທົດສອບບໍ່ຮອບຄອບ ຈຶ່ງເຮັດໃຫ້ຈຳນວນສິນຄ້າໃນສາງຫາຍໄປທັງໝົດ. ທີມພັດທະນາຂໍອະໄພຢ່າງສູງຕໍ່ເລື່ອງນີ້. ກະລຸນາໃສ່ຈຳນວນຄືນໃນລາຍລະອຽດສິນຄ້າ 😢 . ຂໍອະໄພທຸກທ່ານ! ຫວັງວ່າທ່ານຈະເຂົ້າໃຈ!',
  limitFeature: {
    intro: 'ທ່ານສາມາດທົດລອງໃຊ້ໄດ້ຟຣີ ແລະຈ່າຍເມື່ອຈຳເປັນຕ້ອງໃຊ້ແທ້ໆ',
    free: 'ເວີຊັນຟຣີ',
    pro: 'ເວີຊັນພຣີມຽມ (ຊຳລະເງິນ)',
    title: 'ທ່ານຕ້ອງຊື້ເວີຊັນພຣີມຽມເພື່ອໃຊ້ຟີເຈີນີ້',
    package: 'ແພັກເກດພຣີມຽມ',
    packageOther: 'ແພັກເກດບໍລິການອື່ນໆ',
    features: [
      'ບໍ່ມີໂຄສະນາ',
      'ສ້າງສິນຄ້າໄດ້ບໍ່ຈຳກັດ (ເວີຊັນຟຣີຈຳກັດ 100 ສິນຄ້າ)',
      'ຄຳສັ່ງຊື້ບໍ່ຈຳກັດ',
      'ພິມ ຫຼືອອກໃບແຈ້ງໜີ້ໄດ້ບໍ່ຈຳກັດ',
      'ຟີເຈີພິມບາໂຄດສິນຄ້າ (ໃນເວີຊັນເວັບ)',
      'ຟີເຈີສະສົມແຕ້ມໃຫ້ລູກຄ້າ',
      'ຟີເຈີຄັດລອກຄຳສັ່ງຊື້',
      'ຟີເຈີເພີ່ມຄ່າທຳນຽມທີ່ຮ້ານຄ້າຕ້ອງຈ່າຍ',
      'ຟີເຈີຄືນສິນຄ້າ',
      'ຟີເຈີເຊື່ອງສິນຄ້າເກົ່າ',
      'ຟີເຈີຈັດປະເພດສິນຄ້າ (ຕົວຢ່າງ: ກາງເກງຢີນມີຂະໜາດ M, L, XL)',
      'ຟີເຈີນຳເຂົ້າ ແລະສົ່ງອອກຂໍ້ມູນເປັນໄຟລ໌ Excel',
      'ຟີເຈີເພີ່ມໃບຮັບເງິນ ແລະໃບຈ່າຍເງິນ',
      'ຟີເຈີເພີ່ມໃບໜີ້ເກົ່າໃຫ້ລູກຄ້າ',
      'ຟີເຈີສ້າງໃບຈັດສົ່ງ',
      'ຟີເຈີສ້າງ QR ເພື່ອຊຳລະເງິນຄຳສັ່ງຊື້ໂດຍກົງ',
      'ຟີເຈີເມນູສະບັບຮ່າງ, ສ້າງເມນູສະບັບຮ່າງເມື່ອບໍ່ມີການເຊື່ອມຕໍ່ເຄືອຂ່າຍ',
      'ໃຊ້ງານເວີຊັນເວັບ (Desktop) ໄດ້ບໍ່ຈຳກັດ'
    ],
    freeFeatures: [
      'ມີການສະແດງໂຄສະນາ',
      'ຈຳກັດ 100 ສິນຄ້າ',
      'ຈຳກັດ 2.000 ຄຳສັ່ງຊື້',
      'ຈຳກັດຟີເຈີເຊື່ອງສິນຄ້າເກົ່າ',
      'ຈຳກັດຟີເຈີເກັບຄ່າທຳນຽມເພີ່ມຂອງຮ້ານຄ້າ',
      'ຈຳກັດຟີເຈີຮັບຄືນສິນຄ້າ',
      'ຈຳກັດຟີເຈີພິມບາໂຄດ',
      'ຈຳກັດຟີເຈີສະສົມຄະແນນລູກຄ້າ',
      'ຈຳກັດຟີເຈີຈັດໝວດໝູ່ສິນຄ້າ',
      'ຈຳກັດການພິມ ຫຼື ສົ່ງອອກໃບແຈ້ງໜີ້',
      'ຈຳກັດການສົ່ງອອກເປັນ Excel',
      'ຈຳກັດຟີເຈີເພີ່ມໃບຮັບເງິນ ແລະ ໃບຈ່າຍເງິນ',
      'ຈຳກັດຟີເຈີເພີ່ມໃບບັນທຶກໜີ້',
      'ຈຳກັດການນຳເຂົ້າສິນຄ້າ ແລະ ລູກຄ້າຈາກໄຟລ໌ Excel',
      'ຈຳກັດການສ້າງໃບຈັດສົ່ງ',
      'ຈຳກັດຟີເຈີເມນູສະບັບຮ່າງ',
      'ຈຳກັດຟີເຈີສ້າງ QR ຊຳລະເງິນ',
      'ໃຊ້ເວີຊັນເວັບຟຣີ 3 ເດືອນ'
    ]
  },
  syncDetail: {
    text1: 'ຊິງຄ໌ຂໍ້ມູນຈາກອຸປະກອນຂອງທ່ານໄປບັນຊີຂອງທ່ານ. ຂະບວນການນີ້ຕ້ອງເຮັດພຽງຄັ້ງດຽວ. ',
    text2: 'ແຕ່ລະບັນຊີສາມາດຊິງຄ໌ສຳເລັດໄດ້ພຽງຄັ້ງດຽວ',
    text3: 'ຟັງຊັນນີ້ຍັງຢູ່ໃນຂັ້ນທົດລອງ. ຖ້າພົບຂໍ້ຜິດພາດ ກະລຸນາແຈ້ງນັກພັດທະນາເພື່ອຮັບການຊ່ວຍເຫຼືອໂດຍໄວ. ',
    start: 'ເລີ່ມຊິງຄ໌',
    feedback: 'ສົ່ງຄຳຕິຊົມໃຫ້ນັກພັດທະນາ',
    sendErrorData: 'ສົ່ງຂໍ້ມູນຂໍ້ຜິດພາດ',
    sure: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການຊິງຄ໌ຂໍ້ມູນກັບບັນຊີນີ້?',
    syncedError: 'ບັນຊີນີ້ຖືກລັອກແລ້ວ',
    syncedAlert: 'ບັນຊີຂອງທ່ານຍັງບໍ່ມີຂໍ້ມູນອອຟໄລນ໌. ຕ້ອງການຊິງຄ໌ຕອນນີ້ບໍ? '
  },
  account: {
    systemSmartSubtitle: 'ລະບົບການຄຸ້ມຄອງການຂາຍອັດສະລິຍະ',
    switch: 'ສະຫຼັບບັນຊີ',
    switchConfirm: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການສະຫຼັບໄປບັນຊີ %s?',
    switchDeleteConfirm: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການລຶບເຊດຊັນການເຂົ້າລະບົບຂອງບັນຊີ %s?',
    requiredInfo: 'ກະລຸນາປ້ອນຂໍ້ມູນທີ່ຈຳເປັນໃຫ້ຄົບ',
    enterCodeRequired: 'ກະລຸນາປ້ອນລະຫັດຢືນຢັນ',
    enterPasswordRequired: 'ກະລຸນາປ້ອນລະຫັດຜ່ານທັງສອງຊ່ອງ',
    passwordNotMatch: 'ລະຫັດຜ່ານທັງສອງບໍ່ກົງກັນ',
    loginSubtitle: 'ຍິນດີຕ້ອນຮັບກັບມາສູ່ແພລດຟອມຂອງພວກເຮົາ!',
    registerSubtitle: 'ເຂົ້າຮ່ວມກັບພວກເຮົາມື້ນີ້ ແລະ ມາຄົ້ນຫາກັນ!',
    noAccountYet: 'ຍັງບໍ່ມີບັນຊີ?',
    alreadyHaveAccount: 'ມີບັນຊີແລ້ວບໍ?',
    forgotPasswordStepEmail: 'ປ້ອນອີເມວຂອງທ່ານເພື່ອເລີ່ມການກູ້ຄືນລະຫັດຜ່ານ.',
    forgotPasswordStepCode: 'ກະລຸນາປ້ອນລະຫັດຢືນຢັນ 6 ຫຼັກທີ່ສົ່ງໄປຫາອີເມວຂອງທ່ານ.',
    forgotPasswordStepPassword: 'ໃຊ້ລະຫັດຜ່ານທີ່ປອດໄພເພື່ອປົກປ້ອງບັນຊີຂອງທ່ານ.',
    backToLogin: 'ກັບໄປໜ້າເຂົ້າລະບົບ',
    sendCodeSuccess: 'ພວກເຮົາໄດ້ສົ່ງອີເມວທີ່ມີລະຫັດແລ້ວ. ກະລຸນາກວດອີເມວຂອງທ່ານເພື່ອເບິ່ງລະຫັດຢືນຢັນ',
    errorCode: 'ລະຫັດຢືນຢັນບໍ່ຖືກຕ້ອງ',
    codeExpired: 'ລະຫັດຢືນຢັນໝົດອາຍຸແລ້ວ.',
    forgotPassword: 'ລືມລະຫັດຜ່ານ',
    enterEmail: 'ປ້ອນອີເມວ',
    enterCode: 'ປ້ອນລະຫັດຢືນຢັນ',
    sendCode: 'ສົ່ງລະຫັດຢືນຢັນ',
    submitCode: 'ຢືນຢັນ',
    changePassword: 'ປ່ຽນລະຫັດຜ່ານ',
    newPassword: 'ລະຫັດຜ່ານໃໝ່',
    renewPassword: 'ຕັ້ງລະຫັດຜ່ານໃໝ່',
    password: 'ລະຫັດຜ່ານ',
    repassword: 'ປ້ອນລະຫັດຜ່ານອີກຄັ້ງ',
    register: 'ລົງທະບຽນ',
    inputSoShort: 'ຊື່ຜູ້ໃຊ້ ຫຼື ລະຫັດຜ່ານສັ້ນເກີນໄປ',
    repassWrong: 'ລະຫັດຜ່ານທີ່ປ້ອນຊ້ຳບໍ່ຖືກຕ້ອງ',
    emailExist: 'ອີເມວນີ້ມີຢູ່ແລ້ວ',
    logout: 'ອອກຈາກລະບົບ',
    login: 'ເຂົ້າລະບົບ',
    offlineMode: 'ໃຊ້ງານອອບລາຍ',
    offlineModeWarning: 'ເມື່ອໃຊ້ແບບອອບລາຍ, ຂໍ້ມູນຈະຖືກບັນທຶກໄວ້ໃນອຸປະກອນຂອງທ່ານ. ທ່ານຕ້ອງເຂົ້າລະບົບກ່ອນປ່ຽນໄປໃຊ້ອຸປະກອນອື່ນ ເພື່ອບໍ່ໃຫ້ຂໍ້ມູນສູນຫາຍ',
    offlineDeprecated:
      'ນັບແຕ່ວັນທີ 13/3/2025. ແອັບນີ້ບໍ່ຮອງຮັບການໃຊ້ງານແບບອອບລາຍອີກຕໍ່ໄປ.\nເພື່ອໃຊ້ງານແບບອອບລາຍໄດ້ຟຣີ. ກະລຸນາດາວໂຫຼດແອັບ aSeller Offline (ແອັບມີໄອຄອນສີສົ້ມ).\nຂອບໃຈ!',
    logoutConfirmMessage: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການອອກຈາກບັນຊີນີ້?',
    notFoundEmail: 'ບໍ່ພົບບັນຊີທີ່ໃຊ້ອີເມວນີ້',
    errorPassword: 'ລະຫັດຜ່ານບໍ່ຖືກຕ້ອງ',
    emailInvalid: 'ຮູບແບບອີເມວບໍ່ຖືກຕ້ອງ',
    loginWithoutEmail: 'ເຂົ້າລະບົບໂດຍບໍ່ໃຊ້ອີເມວ',
    loginWithoutEmailError: 'ຜິດພາດ ບໍ່ສາມາດສ້າງລະຫັດອຸປະກອນໄດ້. ກະລຸນາຕິດຕໍ່ຝ່າຍຊ່ວຍເຫຼືອເພື່ອຂໍຄຳແນະນຳ!',
    titleRequest: 'ພວກເຮົາໄດ້ຮັບຄຳຂໍເພື່ອປ່ຽນລະຫັດຜ່ານທີ່ຜູກກັບອີເມວນີ້.',
    enterCodeEmail: 'ປ້ອນລະຫັດຢືນຢັນທີ່ສົ່ງໄປຫາອີເມວຂອງທ່ານ. ຖ້າບໍ່ພົບ, ກະລຸນາກວດໂຟນເດີສະແປມ ຫຼື ຈົດໝາຍຂີ້ເຫຍື້ອໃນໂປຣແກຣມອີເມວຂອງທ່ານ.'
  },
  schedule: {
    title: 'ການຈັດການຕາຕະລາງ',
    add: 'ເພີ່ມຕາຕະລາງ',
    requiredInfo: 'ກະລຸນາປ້ອນຂໍ້ມູນທີ່ຈຳເປັນໃຫ້ຄົບຖ້ວນ',
    updateError: 'ອັບເດດຕາຕະລາງບໍ່ສຳເລັດ',
    createError: 'ສ້າງຕາຕະລາງບໍ່ສຳເລັດ',
    updateSuccess: 'ອັບເດດຕາຕະລາງສຳເລັດແລ້ວ',
    createSuccess: 'ສ້າງຕາຕະລາງໃໝ່ສຳເລັດແລ້ວ',
    deleteError: 'ລຶບຕາຕະລາງບໍ່ສຳເລັດ',
    deleteSuccess: 'ລຶບຕາຕະລາງສຳເລັດແລ້ວ',
    pending: 'ລໍຖ້າດຳເນີນການ',
    completed: 'ສຳເລັດແລ້ວ',
    name: 'ຊື່',
    value: 'ຄ່າ',
    time: 'ເວລາ',
    status: 'ສະຖານະ',
    action: 'ການດຳເນີນການ',
    edit: 'ແກ້ໄຂ',
    editTitle: 'ແກ້ໄຂຕາຕະລາງ',
    createTitle: 'ສ້າງຕາຕະລາງໃໝ່',
    namePlaceholder: 'ປ້ອນຊື່ຕາຕະລາງ',
    valuePlaceholder: 'ປ້ອນຄ່າ',
    deleteTitle: 'ລຶບຕາຕະລາງ',
    deleteConfirm: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການລຶບຕາຕະລາງນີ້?'
  },
  statitical: {
    costOfCapital: 'ຕົ້ນທຶນ',
    chart: 'ແຜນພູມ',
    title: 'ລາຍງານ ແລະ ການວິເຄາະ',
    debtBook: 'ປື້ມບັນຊີໜີ້',
    sale: 'ຍອດຂາຍ',
    revenue1: 'ລາຍຮັບ',
    revenue: 'ກຳໄລ',
    capital: 'ທຶນ',
    profit: 'ກຳໄລ',
    saleToday: 'ມື້ນີ້',
    expense: 'ລາຍຈ່າຍ',
    returnOrderTitle: 'ສະຖິຕິການຄືນສິນຄ້າ',
    sale7Days: '7 ມື້',
    sale30Days: '30 ມື້',
    chart7Days: 'ແຜນພູມ 7 ມື້ຫຼ້າສຸດ',
    saleTitle: 'ສະຖິຕິຍອດຂາຍ',
    revenueTitle: 'ສະຖິຕິກຳໄລ',
    orderTitle: 'ສະຖິຕິໃບບິນຂາຍ',
    order: 'ໃບບິນຂາຍ',
    stock: 'ສະຖິຕິສິນຄ້າຄົງຄັງ',
    quantityOfInventory: 'ຈຳນວນສິນຄ້າຄົງຄັງຕາມຫົວໜ່ວຍ',
    quantityOfInventoryByCategory: 'ສິນຄ້າຄົງຄັງຕາມໝວດໝູ່',
    inventoryCapital: 'ທຶນສິນຄ້າຄົງຄັງ',
    inventoryCapitalDetail: '(ອີງຕາມລາຄານຳເຂົ້າປັດຈຸບັນ)',
    quantityOfInventoryProduct: 'ສິນຄ້າທີ່ມີໃນສາງຫຼາຍທີ່ສຸດ',
    saleOfStaff: 'ຍອດຂາຍຂອງພະນັກງານ',
    choiceToView: 'ກະລຸນາເລືອກປະເພດລາຍງານ ແລະ ເວລາ ເພື່ອເບິ່ງຂໍ້ມູນລະອຽດເພີ່ມເຕີມ',
    choiceType: 'ປະເພດລາຍງານ',
    oldStaticWarning: 'ລາຍງານໄດ້ອັບເດດຂໍ້ມູນຕາມເຂດເວລາຂອງທ່ານແລ້ວ.'
  },
  menu: {
    category: 'ໝວດໝູ່',
    statitical: 'ລາຍງານ & ສະຖິຕິ',
    oldStatitical: 'ສະຖິຕິ (ເກົ່າ)',
    version: 'ເວີຊັນ',
    other: 'ອື່ນໆ',
    setting: 'ຕັ້ງຄ່າ',
    orderReturn: 'ຄືນສິນຄ້າ',
    shortcut: 'ທາງລັດ',
    account: 'ບັນຊີ',
    feedback: 'ຄຳຕິຊົມ & ແນະນຳ',
    share: 'ແບ່ງປັນແອັບນີ້ໃຫ້ໝູ່',
    reportBug: 'ສົ່ງຂໍ້ມູນເພື່ອລາຍງານຂໍ້ຜິດພາດ',
    reportLogBug: 'ສົ່ງບັນທຶກເພື່ອລາຍງານຂໍ້ຜິດພາດ',
    policy: 'ນະໂຍບາຍຄວາມລັບ',
    term: 'ເງື່ອນໄຂການໃຊ້',
    editProfile: 'ອັບເດດຂໍ້ມູນ',
    editProfileDetail: 'ອັບເດດຂໍ້ມູນຮ້ານໃຫ້ສະແດງຄົບຖ້ວນໃນໃບເກັບເງິນ.',
    support: 'ຊ່ວຍເຫຼືອ'
  },
  settingForStaff: {
    branchHint: 'ລາຍການນີ້ສຳລັບທຸລະກິດຄາເຟ ແລະ ຮ້ານອາຫານເທົ່ານັ້ນ',
    title: 'ການຕັ້ງຄ່າຮ້ານ',
    staff: 'ພະນັກງານ',
    staffApp: 'ແອັບສຳລັບພະນັກງານ',
    branch: 'ພື້ນທີ່',
    cafe: 'ຄາເຟ ແລະ ຮ້ານອາຫານ',
    passForStaff: 'ລະຫັດຜ່ານພະນັກງານ',
    passForStaffDetail: 'ລະຫັດຜ່ານພິເສດສຳລັບໃຫ້ພະນັກງານເຂົ້າລະບົບໃນແອັບຂາຍ. ຢ່າໃຫ້ຊ້ຳກັບລະຫັດຫຼັກ',
    mainBranch: 'ຫຼັກ',
    addBranch: 'ເພີ່ມພື້ນທີ່',
    editBranch: 'ແກ້ໄຂພື້ນທີ່',
    addStaff: 'ເພີ່ມພະນັກງານ',
    editStaff: 'ແກ້ໄຂພະນັກງານ',
    table: 'ໂຕະ',
    branchName: 'ພື້ນທີ່',
    branchTable: 'ຈຳນວນໂຕະ',
    staffs: 'ຈັດການພະນັກງານ',
    emailExist: 'ອີເມວນີ້ມີຢູ່ແລ້ວ',
    staffsDetail: 'ແຕ່ລະຮ້ານຈະໄດ້ໃຊ້ຟຣີ 1 ເດືອນສຳລັບພະນັກງານຄົນທຳອິດ',
    addStaffSubtitle: 'ສ້າງບັນຊີພະນັກງານໃໝ່',
    editStaffSubtitle: 'ອັບເດດບັນຊີພະນັກງານ',
    accountInfo: 'ຂໍ້ມູນບັນຊີ',
    personalInfo: 'ຂໍ້ມູນສ່ວນຕົວ',
    placeholderUserName: 'ຊື່ຜູ້ໃຊ້...',
    placeholderPasswordEdit: 'ປະໄວ້ວ່າງຖ້າບໍ່ປ່ຽນ',
    placeholderPassword: 'ລະຫັດຜ່ານ...',
    placeholderFullName: 'ຊື່ເຕັມ...',
    placeholderPhone: 'ເບີໂທ...',
    placeholderAddress: 'ທີ່ຢູ່...',
    placeholderNote: 'ໝາຍເຫດກ່ຽວກັບພະນັກງານ...',
    emptyStaff: 'ຍັງບໍ່ມີພະນັກງານ.',
    upgradeStaff: 'ຕໍ່ອາຍຸ',
    appForStaffIntro: 'ແອັບລາຍຊື່ພະນັກງານ ພະນັກງານຂອງທ່ານສາມາດໃຊ້ແອັບນີ້ເພື່ອສ້າງອໍເດີໄດ້. ທ່ານຕ້ອງສ້າງບັນຊີພະນັກງານເພື່ອໃຊ້ງານ. ຂໍ້ມູນຈະຖືກຊິງຄ໌ໄປຍັງບັນຊີຫຼັກຂອງທ່ານ.',
    shopType: 'ປະເພດທຸລະກິດ',
    grocery: 'ຮ້ານຂອງຊຳ, ຊູເປີມາເກັດ',
    appForStaff: ['aSeller for Staff'],
    appForStaffDetail: ['ເໝາະສຳລັບຮ້ານອາຫານ, ຄາເຟ, ຮ້ານຊາ, ຮ້ານຂອງຊຳ, ຮ້ານຄ້າປີກ...'],
    shopTypeDetail: 'ເລືອກປະເພດທຸລະກິດໃຫ້ຖືກຕ້ອງ ເພື່ອໃຊ້ໜ້າຈໍທີ່ເໝາະສົມໃນແອັບຂາຍສຳລັບພະນັກງານ',
    showCustomer: 'ສະແດງລູກຄ້າໃຫ້ພະນັກງານເຫັນ',
    showCustomerDetail: 'ສະແດງລາຍຊື່ລູກຄ້າໃນແອັບພະນັກງານ',
    customerShowMode: ['ສະແດງທັງໝົດ', 'ສະແດງສະເພາະລູກຄ້າຂອງພະນັກງານ', 'ບໍ່ສະແດງ'],
    upgradeStaffContact: '',
    service: 'ບໍລິການ',
    serviceDetail: 'ຮ້ານຄ້າ, ຄາເຟ, ຊານົມ, ຮ້ານອາຫານ...',
    retail: 'ຂາຍດ່ວນ',
    retailDetail: 'ຮ້ານຂາຍຂອງຊຳ, ຊູເປີມາເກັດ...',
    showStatistial: 'ສະແດງຍອດຂາຍລາຍອາທິດ',
    showStatistialDetail: 'ອະນຸຍາດໃຫ້ພະນັກງານເບິ່ງຍອດຂາຍໃນ 7 ມື້ຫຼ້າສຸດ',
    uiForStaft: 'ໜ້າຈໍຂາຍສຳລັບພະນັກງານ',
    uiForStaftDetail: 'ເລືອກໜ້າຈໍທີ່ເໝາະສົມເພື່ອຄວາມສະດວກຂອງພະນັກງານ',
    typeCafe: 'ມີລາຍການໂຕະເພື່ອໃຫ້ເບິ່ງໄດ້ສະດວກ. ເໝາະກັບຮູບແບບທຸລະກິດຮ້ານອາຫານ, ບາ, ຮ້ານຄ້າ, ຄາເຟ, ຮ້ານຊາ...',
    typeRetail: 'ໜ້າຈໍໃຊ້ງ່າຍ. ເໝາະສຳລັບຂາຍຍ່ອຍ ແລະ ຂາຍສົ່ງ, ຕ້ອງການແຕ່ໜ້າຈໍທີ່ງ່າຍແຕ່ໃຊ້ງານໄດ້ດີ.',
    typeSalesCounter: 'ໜ້າຈໍເຄົາເຕີ. ເໝາະສຳລັບພະນັກງານເຄົາເຕີ, ມືອາຊີບ ແລະ ມີປະສິດທິພາບ',
    counter: 'ເຄົາເຕີ',
    stockEnabled: 'ສະແດງສິນຄ້າຄົງຄັງໃຫ້ພະນັກງານເຫັນ',
    stockEnabledDetail: 'ສະແດງສິນຄ້າຄົງຄັງ ແລະ ຍອດຂາຍໃນແອັບພະນັກງານ',
    productList: 'ລາຍການສິນຄ້າ',
    productListDetail: 'ກຳນົດລາຍການສິນຄ້າໃຫ້ສະແດງສຳລັບພະນັກງານແຕ່ລະຄົນ',
    tableManager: 'ອໍເດີຕາມໂຕະ'
  },
  prefix: {
    title: 'ຄຳນຳໜ້າ',
    detail: 'ຊຸດຕົວອັກສອນທີ່ປາກົດກ່ອນລະຫັດຂອງອໍເດີ, ສິນຄ້າ,... ເຊັ່ນ ລະຫັດອໍເດີ: HD123'
  },
  setting: {
    advanced: 'ຂັ້ນສູງ',
    customerCanRegister: 'ອະນຸຍາດໃຫ້ລູກຄ້າລົງທະບຽນບັນຊີ',
    customerCanRegisterDetail: 'ລູກຄ້າສາມາດລົງທະບຽນບັນຊີໄດ້ເອງ. ລູກຄ້າສາມາດຕິດຕາມອໍເດີ ແລະ ໃບແຈ້ງໜີ້ຂອງຕົນໄດ້.',
    vote: 'ໃຫ້ຄະແນນແອັບນີ້!',
    about: 'ກ່ຽວກັບ',
    title: 'ຕັ້ງຄ່າທົ່ວໄປ',
    help: 'ຕ້ອງການຄວາມຊ່ວຍເຫຼືອບໍ?',
    currency: 'ສະກຸນເງິນ',
    timeFormat: 'ຮູບແບບວັນທີ',
    oddNumber: 'ສະແດງເລກທົດສະນິຍົມ',
    oddNumberEx: 'ຕົວຢ່າງ $100.15, 0.5KG...',
    sync: 'ຊິງຂໍ້ມູນແລ້ວ',
    login: 'ເຂົ້າລະບົບ',
    logout: 'ອອກຈາກລະບົບ',
    notSignin: 'ຍັງບໍ່ເຂົ້າລະບົບ',
    syncIntro: 'ເຂົ້າລະບົບບັນຊີ Google ເພື່ອສຳຮອງຂໍ້ມູນ ໃຫ້ຂໍ້ມູນປອດໄພ ແລະ ຍ້າຍໄດ້',
    syncNow: 'ສຳຮອງຕອນນີ້',
    lastSync: 'ສຳຮອງຂໍ້ມູນຫຼ້າສຸດເມື່ອ',
    restore: 'ກູ້ຄືນ',
    requireLogin: 'ທ່ານຕ້ອງເຂົ້າລະບົບບັນຊີ Google ເພື່ອໃຊ້ຟັງຊັນນີ້',
    syncNotFound: 'ບໍ່ພົບຂໍ້ມູນສຳຮອງ',
    confirmSync: 'ຂໍ້ມູນໃນເຊີບເວີຈະຖືກຂຽນທັບ. ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການສຳຮອງຂໍ້ມູນ?',
    confirmRestore: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການກູ້ຄືນຂໍ້ມູນ? ຂໍ້ມູນປັດຈຸບັນຈະຖືກຂຽນທັບ',
    loginExpired: 'ເຊດຊັນເຂົ້າລະບົບໝົດອາຍຸ. ກະລຸນາເຂົ້າລະບົບອີກຄັ້ງ!',
    autoBackup: 'ສຳຮອງຂໍ້ມູນອັດຕະໂນມັດ',
    googleAccountConnect: 'ບັນຊີ Google ຂອງທ່ານ',
    on: 'ເປີດ',
    off: 'ປິດ',
    googleLogoutConfirm: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການອອກຈາກບັນຊີ Google ນີ້?',
    print: 'ເຊື່ອມຕໍ່ເຄື່ອງພິມ',
    printDetail: 'ເລືອກເຄື່ອງພິມ Bluetooth ຂອງທ່ານເພື່ອເຊື່ອມຕໍ່ ແລະພິມໃບແຈ້ງໜີ້ຂອງສິນຄ້າ',
    connectPrinter: 'ເຄື່ອງພິມ',
    invoice: 'ໃບບິນ',
    invoiceHello: 'ຂໍ້ຄວາມຂອບໃຈໃນໃບແຈ້ງໜີ້',
    surchargeText: 'ປ່ຽນຄຳວ່າຄ່າບໍລິການເພີ່ມໃນໃບບິນ',
    invoiceSignature: 'ສະແດງລາຍເຊັນ',
    invoiceDebt: 'ສະແດງໜີ້ຄ້າງຊຳລະ',
    invoiceDebtInfo: 'ສະແດງຍອດຄ້າງຊຳລະໃນລາຍລະອຽດຄຳສັ່ງຊື້, ໃບບິນ, ໃບແຈ້ງໜີ້',
    debt: 'ໜີ້',
    invoiceDebtDetail: 'ລາຍລະອຽດໜີ້',
    invoiceDebtDetailDetail: 'ສະແດງລາຍລະອຽດສິນຄ້າໃນໃບບັນທຶກໜີ້',
    invoiceDiscount: 'ສະແດງສ່ວນຫຼຸດ',
    invoiceHelloDetail: 'ປ່ຽນຂໍ້ຄວາມຂອບໃຈລູກຄ້າຢູ່ດ້ານລຸ່ມໃບແຈ້ງໜີ້',
    warningOutStock: 'ເຕືອນສິນຄ້າໝົດສະຕັອກ',
    warningOutStockDetail: 'ເມື່ອສິນຄ້າໝົດສະຕັອກ ຈະບໍ່ສາມາດເພີ່ມຄຳສັ່ງຊື້ໄດ້',
    warningOutStockMessage: 'ສິນຄ້າຂອງທ່ານໝົດສະຕັອກ. ກະລຸນາເພີ່ມຈຳນວນ ຫຼືປິດຄຳເຕືອນນີ້ໃນການຕັ້ງຄ່າ',
    showRevenue: 'ສະແດງກຳໄລ',
    orderStatus: 'ສະແດງສະຖານະຄຳສັ່ງຊື້',
    orderStatusDetail: 'ສະແດງສະຖານະ "ລໍຖ້າ" ຫຼື "ສຳເລັດ". ຖ້າເປີດໃຊ້ ຈະບໍ່ສາມາດສ້າງໃບຮັບເງິນສຳລັບຄຳສັ່ງຊື້ໄດ້.',
    showHomeRevenue: 'ສະແດງກຳໄລ',
    showHomeChart: 'ສະແດງແຜນພູມ',
    showHomeFinancial: 'ສະແດງການເງິນ',
    showHomeStatistial: 'ສະແດງສະຖິຕິ',
    averageBuyPrice: 'ລາຄານຳເຂົ້າສະເລ່ຍ',
    averageBuyPriceDetail:
      'ລາຄານຳເຂົ້າຈະຖືກຄຳນວນເປັນຄ່າສະເລ່ຍອັດຕະໂນມັດຫຼັງຈາກແຕ່ລະການນຳເຂົ້າ ເພື່ອຄຳນວນກຳໄລໃຫ້ແມ່ນຍຳຂຶ້ນ.\nສູດ = (ມູນຄ່າສິນຄ້າຄົງຄັງປັດຈຸບັນ + ມູນຄ່າສິນຄ້ານຳເຂົ້າໃໝ່)/(ຈຳນວນລວມ)',
    bankInfo: 'ບັນຊີທະນາຄານ',
    vietQRCode: 'QR Code ສຳລັບການຊຳລະເງິນ (ສະເພາະຫວຽດນາມ)',
    vietQRCodeDetail: 'ສະແກນລະຫັດ VietQR ເພື່ອຊຳລະເງິນຢ່າງວ່ອງໄວ. ມີຂໍ້ມູນຈຳນວນເງິນຂອງຄຳສັ່ງຊື້ ແລະເນື້ອຫາການໂອນ.',
    vietQRCodeWarning: 'ກະລຸນາປ້ອນຂໍ້ມູນບັນຊີໃຫ້ຖືກຕ້ອງ. ພວກເຮົາຈະບໍ່ຮັບຜິດຊອບຖ້າທ່ານປ້ອນຂໍ້ມູນຜິດ!',
    bankName: 'ຊື່ທະນາຄານ',
    bankAcc: 'ເລກບັນຊີ',
    bankAccName: 'ຊື່ເຈົ້າຂອງບັນຊີ',
    bankTransferContent: 'ເນື້ອຫາການໂອນ',
    showSurchargeShopPay: 'ສະແດງຄ່າບໍລິການເພີ່ມທີ່ຜູ້ຂາຍຈ່າຍ',
    showSurchargeShopPayDetail: 'ຖ້າບໍ່ເລືອກ ຄ່າບໍລິການເພີ່ມທີ່ຜູ້ຂາຍຈ່າຍຈະບໍ່ສະແດງໃນໃບບິນ ຫຼືໃບແຈ້ງໜີ້',
    debtActive: 'ເປີດໃຊ້ຍອດໜີ້ຄ້າງຊຳລະ',
    debtActiveDetail: 'ເປີດໃຊ້ໜີ້ເພື່ອຕິດຕາມໜີ້ຂອງລູກຄ້າ. ຖ້າທ່ານປິດຟັງຊັນທີ່ກ່ຽວກັບໜີ້ (ເຊັ່ນ: ໃບຮັບເງິນຄຳສັ່ງຊື້, ໃບຮັບເງິນລູກຄ້າ, ປື້ມໜີ້...) ຟັງຊັນເຫຼົ່ານັ້ນຈະບໍ່ເຮັດວຽກ.',
    debtInactiveDetail: 'ຟັງຊັນໜີ້ຖືກປິດໃຊ້ງານແລ້ວ. ເພື່ອເປີດໃຊ້ ກະລຸນາໄປທີ່ "ການຕັ້ງຄ່າ" -> "ການຕັ້ງຄ່າຄຳສັ່ງຊື້" -> "ເປີດໃຊ້ຍອດຄ້າງຊຳລະ"',
    inventoryActive: 'ເປີດໃຊ້ການຕິດຕາມສິນຄ້າຄົງຄັງ',
    inventoryActiveDetail:
      'ຕິດຕາມຈຳນວນສິນຄ້າຄົງຄັງໃນຄັງສິນຄ້າ. ຖ້າປິດໃຊ້ ຟີເຈີທັງໝົດທີ່ກ່ຽວກັບສິນຄ້າຄົງຄັງຈະບໍ່ເຮັດວຽກ.\nຖ້າທ່ານເຮັດທຸລະກິດບໍລິການເຊັ່ນ ຄາເຟ, ຮ້ານອາຫານ... ຄວນປິດຟັງຊັນນີ້ເພື່ອໃຊ້ງານໃຫ້ງ່າຍຂຶ້ນ.',
    inventoryInactiveDetail: 'ຟີເຈີນີ້ບໍ່ເຮັດວຽກເມື່ອການຕິດຕາມສິນຄ້າຄົງຄັງຖືກປິດ. ເພື່ອເປີດໃຊ້ ກະລຸນາໄປທີ່ "ການຕັ້ງຄ່າ" -> "ການຕັ້ງຄ່າສິນຄ້າ" -> "ເປີດໃຊ້ສິນຄ້າຄົງຄັງ".',
    inventoryActiveWarning: 'ຖ້າທ່ານປິດໃຊ້ ຟັງຊັນທັງໝົດທີ່ກ່ຽວກັບສິນຄ້າຄົງຄັງຈະບໍ່ເຮັດວຽກ. ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການປິດໃຊ້?'
  },
  customer: {
    id: 'ລະຫັດ',
    prefix: 'ຄຳນຳໜ້າລະຫັດລູກຄ້າ',
    title: 'ລູກຄ້າ',
    create: 'ເພີ່ມລູກຄ້າ',
    name: 'ຊື່ລູກຄ້າ',
    address: 'ທີ່ຢູ່',
    phone: 'ເບີໂທ',
    email: 'ອີເມວ',
    add: 'ເພີ່ມລູກຄ້າໃໝ່',
    choice: 'ເລືອກລູກຄ້າ',
    invalidPhoneOrAddress: 'ກະລຸນາໃສ່ເບີໂທລະສັບ ຫຼື ທີ່ຢູ່',
    phoneExist: 'ເບີໂທລະສັບນີ້ມີຢູ່ແລ້ວ',
    search: 'ກັ່ນຕອງຕາມລະຫັດ, ຊື່ ຫຼື ເບີໂທລະສັບ',
    free: 'ລູກຄ້າທົ່ວໄປ',
    freeDetail: 'ລູກຄ້າທົ່ວໄປ',
    orderStatistics: 'ສະຖິຕິຄຳສັ່ງຊື້',
    exportDebt: 'ສົ່ງອອກໜີ້ຄ້າງຊຳລະ',
    addDebt: 'ເພີ່ມໜີ້',
    yearOld: 'ປີ',
    countBirthDay: 'ຍັງເຫຼືອ %s ມື້',
    taxCode: 'ລະຫັດພາສີ',
    citizenId: 'ເລກປະຈຳຕົວ',
    exportOrderExcel: 'ສົ່ງອອກລາຍການຄຳສັ່ງຊື້ເປັນ Excel',
    taxCodeHint: 'ສາມາດຄົ້ນຫາອົງກອນດ້ວຍລະຫັດພາສີ',
    purchasedProducts: 'ສິນຄ້າທີ່ຊື້ແລ້ວ',
    createScreen: {
      taxCodeNotFound: 'ບໍ່ພົບຂໍ້ມູນລະຫັດພາສີ',
      avatarLabel: 'ຮູບໂປຣໄຟລ໌',
      contactHint: 'ປ້ອນຂໍ້ມູນດ່ວນຈາກລາຍຊື່ຜູ້ຕິດຕໍ່ ຫຼື ເພີ່ມຮູບໂປຣໄຟລ໌',
      basicInfoTitle: 'ຂໍ້ມູນພື້ນຖານ'
    },
    deleteWarning: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການລຶບລູກຄ້ານີ້? ຄຳສັ່ງຊື້ ແລະ ໃບຮັບເງິນທັງໝົດທີ່ກ່ຽວຂ້ອງກັບລູກຄ້ານີ້ຈະຖືກປ່ຽນເປັນລູກຄ້າທົ່ວໄປ.'
  },
  order: {
    lastPrice: 'ລາຄາຫຼ້າສຸດ',
    lastPriceAuto: 'ໃຊ້ລາຄາຂາຍຫຼ້າສຸດອັດຕະໂນມັດ',
    lastPriceAutoDetail: 'ຄຳສັ່ງຊື້ຂອງລູກຄ້າຈະໃຊ້ລາຄາຂາຍຫຼ້າສຸດຂອງລູກຄ້ານັ້ນແທນລາຄາຂາຍຍ່ອຍ',
    addDisplayInfo: 'ເພີ່ມຂໍ້ມູນສະແດງ',
    editDeadline: 'ໄລຍະເວລາແກ້ໄຂຄຳສັ່ງຊື້',
    editDeadlineDetail: 'ອະນຸຍາດໃຫ້ແກ້ໄຂຄຳສັ່ງຊື້ພາຍໃນຈຳນວນມື້ນີ້ນັບຈາກວັນທີສ້າງຄຳສັ່ງຊື້.',
    editDeadlineExpired: 'ຄຳສັ່ງຊື້ເກີນໄລຍະເວລາແກ້ໄຂແລ້ວ. ກະລຸນາປັບໄລຍະເວລາທີ່ອະນຸຍາດໃຫ້ແກ້ໄຂຄຳສັ່ງຊື້ໃນ "ການຕັ້ງຄ່າ" -> "ການຕັ້ງຄ່າຄຳສັ່ງຊື້".',
    summary: 'ສະຫຼຸບຄຳສັ່ງຊື້',
    id: 'ລະຫັດ',
    prefix: 'ຄຳນຳໜ້າລະຫັດໃບຮັບເງິນຂາຍ',
    title: 'ອໍເດີຂາຍ',
    create: 'ເພີ່ມອໍເດີຂາຍ',
    edit: 'ແກ້ໄຂອໍເດີ',
    detail: 'ລາຍລະອຽດອໍເດີ',
    exportInvoice: 'ໃບບິນຊຳລະເງິນ',
    add: 'ເພີ່ມສິນຄ້າ',
    realPrice: 'ລາຄາຈິງ',
    infoShop: 'ຂໍ້ມູນຮ້ານ',
    invalidCustomer: 'ກະລຸນາເລືອກ ຫຼື ສ້າງລູກຄ້າ',
    invalidProduct: 'ບໍ່ມີສິນຄ້າໃນຄຳສັ່ງຊື້',
    confirmDelete: 'ທ່ານແນ່ໃຈຈະລຶບ % ນີ້ບໍ?',
    search: 'ກັ່ນຕອງຕາມລະຫັດຄຳສັ່ງຊື້, ຊື່ ຫຼື ເບີໂທລະສັບລູກຄ້າ',
    discount: 'ສ່ວນຫຼຸດ',
    discount1: 'ສ່ວນຫຼຸດ',
    inStockNotEnough: 'ຈຳນວນສິນຄ້າໃນສາງບໍ່ພຽງພໍ. ກະລຸນານຳເຂົ້າສິນຄ້າເພີ່ມ ຫຼື ອັບເດດຈຳນວນໃນສາງ.',
    createFailed: 'ສ້າງຄຳສັ່ງຊື້ບໍ່ສຳເລັດ. ກະລຸນາລອງໃໝ່ ຫຼື ສົ່ງຄຳຕິຊົມໃຫ້ທີມພັດທະນາ',
    surcharge: 'ຄ່າເພີ່ມ',
    surchargeDetail: '(ຄ່າສົ່ງ, ພາສີ...)',
    barcodeNotFound: 'ສິນຄ້ານີ້ມີຢູ່ແລ້ວ. ກະລຸນາກວດສອບຊື່ ຫຼື ລະຫັດບາໂຄດ',
    price: 'ລາຄາ',
    customPrice: 'ລາຄາກຳນົດເອງ',
    customPrice1: 'ສ່ວນຫຼຸດເປັນ %',
    orderMoneyUpdated: 'ຍອດເງິນຂອງຄຳສັ່ງຊື້ຖືກອັບເດດໃໝ່ເນື່ອງຈາກລາຄາປ່ຽນແປງ',
    totalProductMoney: 'ຍອດເງິນສິນຄ້າລວມ',
    totalMustPaidMoney: 'ຍອດເງິນທີ່ຕ້ອງຊຳລະລວມ',
    totalPaidMoney: 'ລູກຄ້າຈ່າຍ',
    totalDebtMoney: 'ຍອດໜີ້ຄ້າງຊຳລະລວມ',
    paid: 'ຊຳລະແລ້ວ',
    totalLiabilities: 'ໜີ້ສິນລວມ',
    totalMustPaidMoneyForCustomer: 'ຍອດເງິນທີ່ຕ້ອງຄືນໃຫ້ລູກຄ້າລວມ',
    totalPaidMoneyForCustomer: 'ເງິນທອນໃຫ້ລູກຄ້າ',
    providerRefunds: 'ເງິນຄືນຈາກຜູ້ສະໜອງ',
    providerDebt: 'ໜີ້ທີ່ຄ້າງຈ່າຍໃຫ້ຜູ້ສະໜອງ',
    pointDiscount: 'ຫັກຄະແນນສະສົມ',
    money: 'ຍອດເງິນອໍເດີ',
    statusOffRequire: 'ປິດສະຖານະຄຳສັ່ງຊື້',
    statusOffRequireDetail:
      'ເພື່ອສ້າງໃບຮັບເງິນສຳລັບຄຳສັ່ງຊື້ ທ່ານຕ້ອງປິດສະຖານະຄຳສັ່ງຊື້ ເພາະອາດເຮັດໃຫ້ສັບສົນເລື່ອງຍອດຄ້າງຊຳລະຂອງຄຳສັ່ງຊື້. ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການປິດສະຖານະຄຳສັ່ງຊື້ເພື່ອໃຊ້ຟັງຊັນນີ້?',
    surchargeType2: 'ຜູ້ຂາຍຈ່າຍ',
    surchargeType1: 'ຜູ້ຊື້ຈ່າຍ',
    surchargeTypeHint:
      '- ຜູ້ຊື້ຈ່າຍ: ຈະຖືກລວມໃນຍອດເງິນຄຳສັ່ງຊື້, ລວມໃນລາຍຮັບ, ບໍ່ລວມໃນກຳໄລ.\n- ຜູ້ຂາຍຈ່າຍ: ຈະບໍ່ຖືກລວມໃນຍອດເງິນຄຳສັ່ງຊື້, ຈະສ້າງໃບຈ່າຍເງິນທີ່ກົງກັນເພື່ອບັນທຶກເປັນຄ່າໃຊ້ຈ່າຍຂອງຮ້ານ',
    table: 'ໂຕະ',
    changeTable: 'ປ່ຽນໂຕະ',
    changeTableInput: 'ປ້ອນຈຳນວນໂຕະທີ່ຕ້ອງການປ່ຽນ',
    separate: 'ແຍກ',
    separateDetail: 'ແຍກສິນຄ້າລາຍການດຽວເປັນຫຼາຍແຖວໃນຄຳສັ່ງຂາຍດຽວກັນ.',
    promotionAuto: 'ນຳໃຊ້ໂປຣໂມຊັນອັດຕະໂນມັດ',
    promotionAutoDetail: 'ນຳໃຊ້ໂປຣໂມຊັນທີ່ທ່ານເລືອກຫຼ້າສຸດກັບຄຳສັ່ງຊື້ອັດຕະໂນມັດ',
    emptyProduct: 'ກະລຸນາເພີ່ມສິນຄ້າ',
    draftOrderWarning: 'ໝາຍເຫດ: ນີ້ແມ່ນໃບບິນຊົ່ວຄາວ, ຍັງບໍ່ໄດ້ບັນທຶກໃນຂໍ້ມູນ.',
    draftSaved: 'ບັນທຶກຮ່າງແລ້ວ. ກະລຸນາກວດເບິ່ງລາຍການຮ່າງທີ່ "ໜ້າຫຼັກ"',
    vatDetail: 'ພາສີ (VAT) ຖືກຄຳນວນອັດຕະໂນມັດຈາກ VAT ຂອງສິນຄ້າ',
    productSorting: 'ຈັດລຽງສິນຄ້າໃນຄຳສັ່ງຊື້',
    productSortingDetail: 'ສິນຄ້າທີ່ເພີ່ມພາຍຫຼັງຈະສະແດງຢູ່ທ້າຍລາຍການ. ປິດໃຊ້ງານເພື່ອສະແດງຢູ່ຕົ້ນລາຍການ',
    description: 'ຈັດການ ແລະ ຕິດຕາມທຸກອໍເດີຂາຍຂອງທ່ານ.'
  },
  product: {
    multiStopSale: 'ຢຸດຂາຍຫຼາຍລາຍການ',
    multiSale: 'ເປີດຂາຍສິນຄ້າຫຼາຍລາຍການ',
    stopSale: 'ຢຸດຂາຍ',
    sale: 'ຂາຍ',
    stopSaleList: 'ລາຍການທີ່ຢຸດຂາຍ',
    saleList: 'ລາຍການທີ່ກຳລັງຂາຍ',
    product: 'ສິນຄ້າ',
    id: 'ລະຫັດ',
    prefix: 'ຄຳນຳໜ້າລະຫັດສິນຄ້າ',
    title: 'ສິນຄ້າ',
    create: 'ເພີ່ມສິນຄ້າ',
    add: 'ເພີ່ມສິນຄ້າ',
    choice: 'ເລືອກສິນຄ້າ',
    name: 'ຊື່ສິນຄ້າ',
    priceType: 'ປະເພດລາຄາ',
    price: 'ລາຄາສິນຄ້າ',
    buyPrice: 'ລາຄາທຶນ',
    sellPrice: 'ລາຄາຂາຍ',
    sellPrice1: 'ລາຄາໂປຣໂມຊັນ',
    sellPrice2: 'ລາຄາຂາຍສົ່ງ',
    inStock: 'ສິນຄ້າຄົງຄັງ',
    initStock: 'ຈຳນວນເລີ່ມຕົ້ນ',
    initStockDetail: 'ຈຳນວນສິນຄ້າໃນສາງເລີ່ມຕົ້ນເມື່ອສ້າງສິນຄ້າໃໝ່',
    vatDetail: 'ພາສີຖືກຄຳນວນໃນຄຳສັ່ງຂາຍ',
    vat: 'ພາສີ',
    recent: 'ສິນຄ້າທີ່ເພີ່ມຫຼ້າສຸດ',
    search: 'ກັ່ນຕອງຕາມລະຫັດ, ຊື່',
    sold: 'ຂາຍແລ້ວ',
    outOfStock: 'ສິນຄ້າໝົດ',
    expirationDate: 'ວັນໝົດອາຍຸ',
    enterQuantity: 'ປ້ອນຈຳນວນ',
    barcode: 'ບາໂຄດ',
    exist: 'ສິນຄ້ານີ້ມີຢູ່ແລ້ວ. ກະລຸນາກວດຊື່ ຫຼື ບາໂຄດ.',
    canNotDelete: 'ບໍ່ສາມາດລຶບສິນຄ້ານີ້ໄດ້ ເພາະມີຢູ່ໃນອໍເດີແລ້ວ. ກະລຸນາລຶບອໍເດີກ່ອນ.',
    errorPrice: 'ລາຄາທີ່ທ່ານປ້ອນບໍ່ຖືກຕ້ອງ',
    changeSellPriceWarning: 'ໝາຍເຫດ: ການປ່ຽນລາຄາຂາຍຈະມີຜົນຕໍ່ອໍເດີທີ່ມີຢູ່',
    changeSellPriceWarningDetail: 'ການປ່ຽນລາຄາຈະມີຜົນຕໍ່ອໍເດີທີ່ມີຢູ່, ທ່ານຈະຕ້ອງອັບເດດອໍເດີທີ່ມີສິນຄ້ານີ້. ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການເຮັດແບບນີ້?',
    deleteNumProduct: 'ລຶບສິນຄ້າ %s ລາຍການ',
    hiddenNumProduct: 'ຢຸດຂາຍສິນຄ້າ %s ລາຍການ',
    activeNumProduct: 'ຂາຍສິນຄ້າ %s ລາຍການ',
    deleteNumProductConfirm: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການລຶບສິນຄ້ານີ້ %s ລາຍການ?',
    hiddenNumProductConfirm: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການຢຸດຂາຍສິນຄ້ານີ້ %s ລາຍການ?',
    activeNumProductConfirm: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການຂາຍສິນຄ້ານີ້ %s ລາຍການ?',
    canNotDeleteProduct: 'ທ່ານບໍ່ສາມາດລຶບສິນຄ້າ %s ລາຍການໄດ້ ເພາະມີຢູ່ໃນອໍເດີແລ້ວ',
    barcodeExist: 'ບາໂຄດນີ້ມີຢູ່ກັບສິນຄ້າອື່ນແລ້ວ.',
    combo: 'ຊຸດສິນຄ້າ',
    comboProduct: 'ສິນຄ້າແບບຊຸດ',
    comboRecipe: 'ສູດຊຸດສິນຄ້າ',
    comboRecipeHint: 'ສະຕັອກຂອງຊຸດສິນຄ້າຈະຖືກຫັກຈາກສິນຄ້າຍ່ອຍຂ້າງລຸ່ມ.',
    comboSelectChild: 'ເລືອກສິນຄ້າຍ່ອຍ',
    comboAddChild: 'ເພີ່ມສິນຄ້າຍ່ອຍ',
    comboEmpty: 'ບໍ່ມີສິນຄ້າຍ່ອຍໃນສູດຊຸດສິນຄ້ານີ້',
    comboQuantity: 'ຈຳນວນໃນຊຸດສິນຄ້າ',
    comboAutoBuyPrice: 'ລາຄາຊື້ຖືກຄຳນວນອັດຕະໂນມັດຈາກສູດຊຸດສິນຄ້າ',
    comboDerivedStock: 'ສະຕັອກຖືກຄຳນວນຈາກສິນຄ້າຍ່ອຍ',
    comboTypeLabel: 'ປະເພດສິນຄ້າ',
    comboTypeNormal: 'ສິນຄ້າທົ່ວໄປ',
    comboTypeCombo: 'ສິນຄ້າແບບຊຸດ',
    comboSelectChildWarning: 'ກະລຸນາເລືອກສິນຄ້າຍ່ອຍສຳລັບຊຸດນີ້.',
    comboQuantityWarning: 'ຈຳນວນສິນຄ້າຍ່ອຍຕ້ອງຫຼາຍກວ່າ 0.',
    comboDuplicateChildWarning: 'ສິນຄ້າຍ່ອຍໜຶ່ງລາຍການສາມາດຢູ່ໃນສູດຊຸດສິນຄ້າໄດ້ພຽງຄັ້ງດຽວ.',
    comboChildCannotBeCombo: 'ສິນຄ້າຍ່ອຍໃນຊຸດບໍ່ສາມາດເປັນສິນຄ້າແບບຊຸດອື່ນໄດ້.',
    comboSelfWarning: 'ຊຸດສິນຄ້າບໍ່ສາມາດລວມຕົວມັນເອງໄດ້.',
    comboVariantNotSupported: 'ຊຸດສິນຄ້າຍັງບໍ່ຮອງຮັບຕົວເລືອກ. ກະລຸນາລຶບຕົວເລືອກອອກກ່ອນປ່ຽນເປັນຊຸດສິນຄ້າ.',
    simpleModeCombWarning: 'ກະລຸນາສ້າງສິນຄ້າໃຫ້ຄົບຖ້ວນຈາກລາຍການສິນຄ້າ',
    comboConvertToNormalBuyPriceWarning: 'ກະລຸນາປ້ອນລາຄາຊື້ເມື່ອປ່ຽນຊຸດສິນຄ້າກັບເປັນສິນຄ້າທົ່ວໄປ.',
    syncAmount: 'ປັບສະຕັອກໃຫ້ກົງກັບໃບນຳເຂົ້າສິນຄ້າ',
    syncAmountConfirm: 'ສະຕັອກຂອງສິນຄ້ານີ້ແມ່ນ %s. ທ່ານຕ້ອງການອັບເດດອີກຄັ້ງບໍ?',
    type: 'ຕົວເລືອກ',
    type1: 'ຕົວເລືອກ (ຂະໜາດ, ສີ...)',
    typeHint: 'ຊື່ປະເພດ',
    sku: 'SKU',
    skuExist: 'SKU ນີ້ມີຢູ່ແລ້ວ. ກະລຸນາປ້ອນຄ່າອື່ນ!',
    image: 'ຮູບພາບສິນຄ້າ',
    nameSoShort: 'ຊື່ສິນຄ້າຕ້ອງຍາວກວ່າ 4 ຕົວອັກສອນ',
    nameExist: 'ຊື່ສິນຄ້າມີຢູ່ແລ້ວ',
    canNotCreateUnitConvertWithType: 'ບໍ່ສາມາດສ້າງຫົວໜ່ວຍແປງສຳລັບສິນຄ້າທີ່ມີຕົວເລືອກໄດ້.',
    limitUploadImage: 'ເວີຊັນຟຣີຮອງຮັບແຕ່ 1 ຮູບຕໍ່ສິນຄ້າ. ກະລຸນາອັບເກຣດເພື່ອເພີ່ມຮູບພາບ!',
    limitContentLength: 'ຄຳອະທິບາຍສິນຄ້າຕ້ອງນ້ອຍກວ່າ %s ຕົວອັກສອນ!',
    limitImageOffline: 'ເວີຊັນອອບລາຍຮອງຮັບແຕ່ 1 ຮູບ!',
    importNewFromExcel: 'ນຳເຂົ້າສິນຄ້າໃໝ່',
    importUpdateFromExcel: 'ອັບເດດສິນຄ້າທີ່ມີຢູ່',
    description: 'ຈັດການ ແລະ ຕິດຕາມທຸກສິນຄ້າຂອງທ່ານ.'
  },
  category: {
    id: 'ລະຫັດ',
    prefix: 'ຄຳນຳໜ້າລະຫັດໝວດໝູ່',
    title: 'ໝວດໝູ່ສິນຄ້າ',
    create: 'ເພີ່ມໝວດໝູ່',
    name: 'ຊື່ໝວດໝູ່',
    choice: 'ເລືອກໝວດໝູ່',
    search: 'ກັ່ນຕອງຕາມລະຫັດ, ຊື່ໝວດໝູ່',
    categoryExist: 'ໝວດໝູ່ນີ້ມີຢູ່ແລ້ວ',
    choiceProduct: 'ເລືອກສິນຄ້າເພື່ອເພີ່ມໃສ່ລາຍການຂອງທ່ານ',
    description: 'ຈັດການ ແລະ ຕິດຕາມທຸກໝວດໝູ່ຂອງທ່ານ',
    tips: 'ເຄັດລັບ',
    tip1: 'ໃຊ້ຊື່ໝວດໝູ່ສັ້ນໆ ແລະເຂົ້າໃຈງ່າຍ (ເຊັ່ນ: ເຄື່ອງດື່ມ, ອາຫານຈານດ່ວນ...).',
    tip2: 'ໝວດໝູ່ຊ່ວຍໃນການຈັດປະເພດ ແລະຄົ້ນຫາສິນຄ້າໄດ້ໄວຂຶ້ນ.',
    tip3: 'ທ່ານສາມາດກຳນົດສິນຄ້າໃຫ້ໝວດໝູ່ນີ້ໄດ້ທັນທີຫຼັງສ້າງແລ້ວ.',
    itemsCountDesc: 'ປັດຈຸບັນມີ %s ລາຍການຖືກຈັດໃນໝວດໝູ່ນີ້'
  },
  bestSelling: {
    title: 'ແນວໂນ້ມຜູ້ບໍລິໂພກ',
    subtitle: 'ສິນຄ້າຂາຍດີໃນ 30 ມື້'
  },
  importOrder: {
    id: 'ລະຫັດ',
    prefix: 'ຄຳນຳໜ້າລະຫັດໃບຮັບສິນຄ້າ',
    title: 'ໃບຮັບສິນຄ້າ',
    detail: 'ລາຍລະອຽດໃບຮັບສິນຄ້າ',
    create: 'ສ້າງໃບຮັບສິນຄ້າ',
    edit: 'ອັບເດດໃບຮັບສິນຄ້າ',
    editProductPrice: 'ປ່ຽນລາຄານຳເຂົ້າ',
    editProductPriceWarning: 'ທ່ານຕ້ອງການປ່ຽນລາຄານຳເຂົ້າຂອງສິນຄ້ານີ້ເປັນ %s ບໍ?'
  },
  importReturnOrder: {
    id: 'ລະຫັດຄຳສັ່ງຊື້',
    prefix: 'ຄຳນຳໜ້າລະຫັດຄຳສັ່ງສົ່ງຄືນໃຫ້ຜູ້ສະໜອງ',
    title: 'ຄຳສັ່ງສົ່ງຄືນສິນຄ້ານຳເຂົ້າ',
    detail: 'ລາຍລະອຽດຄຳສັ່ງສົ່ງຄືນສິນຄ້ານຳເຂົ້າ',
    create: 'ເພີ່ມຄຳສັ່ງສົ່ງຄືນສິນຄ້ານຳເຂົ້າ',
    edit: 'ແກ້ໄຂຄຳສັ່ງສົ່ງຄືນສິນຄ້ານຳເຂົ້າ'
  },
  provider: {
    id: 'ລະຫັດຜູ້ສະໜອງ',
    prefix: 'ຄຳນຳໜ້າຜູ້ສະໜອງ',
    title: 'ຜູ້ສະໜອງ',
    create: 'ເພີ່ມຜູ້ສະໜອງ',
    name: 'ຊື່ຜູ້ສະໜອງ',
    choice: 'ເລືອກຜູ້ສະໜອງ',
    search: 'ກັ່ນຕອງຕາມລະຫັດ, ຊື່, ເບີຜູ້ສະໜອງ',
    categoryExist: 'ຊື່ຜູ້ສະໜອງມີຢູ່ແລ້ວ',
    order: 'ຄຳສັ່ງຊື້',
    free: 'ບໍ່ຮູ້ຈັກ',
    deleteWarning: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການລຶບຜູ້ສະໜອງນີ້? ຄຳສັ່ງຊື້ທັງໝົດທີ່ກ່ຽວຂ້ອງກັບຜູ້ສະໜອງນີ້ຈະຖືກປ່ຽນເປັນຜູ້ສະໜອງທີ່ບໍ່ຮູ້ຈັກ.'
  },
  googleDriver: {
    backup: 'ສຳຮອງຂໍ້ມູນ',
    backupToDriver: 'ສຳຮອງຂໍ້ມູນ',
    loginGoogle: 'ທ່ານຕ້ອງເຂົ້າລະບົບບັນຊີ Google ເພື່ອໃຊ້ຟີເຈີນີ້',
    backupSuccess: 'ສຳຮອງຂໍ້ມູນສຳເລັດ',
    backupError: 'ສຳຮອງຂໍ້ມູນລົ້ມເຫຼວ',
    emptyBackup: 'ບໍ່ພົບຂໍ້ມູນສຳຮອງ',
    loadingBackupFile: 'ກຳລັງໂຫຼດຂໍ້ມູນສຳຮອງ',
    backingUp: 'ກຳລັງສຳຮອງຂໍ້ມູນ',
    restore: 'ກູ້ຄືນ',
    restoreFromDriver: 'ກູ້ຄືນ',
    restoreSuccess: 'ກູ້ຄືນຂໍ້ມູນສຳເລັດ',
    restoring: 'ກຳລັງກູ້ຄືນຂໍ້ມູນ',
    resetData: 'ຣີເຊັດຂໍ້ມູນ',
    resetDataDetail: 'ເລີ່ມຕົ້ນຂໍ້ມູນໃໝ່ທັງໝົດ',
    resetDataConfirm: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການລ້າງຂໍ້ມູນທີ່ມີຢູ່?',
    backupErrorCaseInvalidToken: 'ບໍ່ສາມາດສຳຮອງຂໍ້ມູນໄດ້ ເພາະເຊສຊັນບັນຊີ Google ຂອງທ່ານໝົດອາຍຸແລ້ວ. ກະລຸນາເຂົ້າລະບົບ ແລ້ວລອງໃໝ່!',
    confirmReplaceOlderTitle: 'ຢືນຢັນການຂຽນທັບ',
    confirmReplaceOlderDetail: 'ພວກເຮົາພົບຂໍ້ມູນເວີຊັນໃໝ່ກວ່າຢູ່ໃນ Google Driver. ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການສຳຮອງຂໍ້ມູນປັດຈຸບັນຂອງທ່ານ?',
    restoreChoose: 'ເລືອກຂໍ້ມູນທີ່ຕ້ອງການກູ້ຄືນ',
    backupRename: 'ແກ້ໄຂຊື່ທີ່ຈື່ງ່າຍ',
    backupAt: 'ສຳຮອງເມື່ອ'
  },
  staffUpgrade: {
    upgradeForStaff: 'ທ່ານກຳລັງຕໍ່ອາຍຸພະນັກງານ. ຖ້າທ່ານເຄີຍຊຳລະເງິນແລ້ວແຕ່ຍັງບໍ່ໄດ້ອັບເດດ, ກະລຸນາເລືອກກູ້ຄືນການຊຳລະເງິນ.',
    staff1m: 'ຕໍ່ອາຍຸ 1 ເດືອນ',
    staff6m: 'ຕໍ່ອາຍຸ 6 ເດືອນ',
    staff1y: 'ຕໍ່ອາຍຸ 1 ປີ'
  },
  proVersion: {
    pro: 'ແພັກເກດພຣີມຽມ (VIP)',
    proDetail: 'ແພັກເກດພຣີມຽມເປັນແພັກເກດທີ່ໃຊ້ຟີເຈີທັງໝົດຂອງແອັບ (ບໍ່ລວມບັນຊີພະນັກງານ ແລະສາຂາເພີ່ມ). ກະລຸນາກົດ "ປຽບທຽບ Free - Premium" ເພື່ອລາຍລະອຽດເພີ່ມເຕີມ.',
    staffAcc: 'ແພັກເກດບັນຊີພະນັກງານ',
    staffAccDetail: 'ແພັກເກດສຳລັບຮ້ານຄ້າທຸລະກິດທີ່ຕ້ອງການໃຊ້ບັນຊີພະນັກງານ. 1 ເດືອນທຳອິດຟຣີສຳລັບບັນຊີພະນັກງານບັນຊີທຳອິດ. ບັນຊີພະນັກງານໜຶ່ງບັນຊີສາມາດເຂົ້າລະບົບໃນອຸປະກອນໄດ້ບໍ່ຈຳກັດ.',
    warehouseExt: 'ແພັກເກດສາຂາເພີ່ມ',
    warehouseExtDetail: 'ແພັກເກດສາຂາເພີ່ມໃຊ້ກັບສາຂາທີ 2 ເປັນຕົ້ນໄປ. ສາຂາທີ 2 ຈະໃຊ້ຟຣີໄດ້ 1 ເດືອນ.',
    linked: 'ເຊື່ອມຕໍ່ແລ້ວ',
    paymentRecoveryHint: 'ກະລຸນາເລືອກການຊຳລະເງິນຂອງທ່ານເພື່ອກູ້ຄືນສຳລັບບັນຊີນີ້!',
    name: 'ເວີຊັນພຣີມຽມ',
    detail: 'ຊື້ເວີຊັນພຣີມຽມເພື່ອລຶບໂຄສະນາ ແລະໃຊ້ຟີເຈີທັງໝົດຂອງແອັບໄດ້ໂດຍບໍ່ຈຳກັດ',
    removeAds: 'ອັບເກຣດເປັນເວີຊັນພຣີມຽມ',
    removeAdsDetail: 'ຊື້ພຽງຄັ້ງດຽວ, ຖ້າເຄີຍຊື້ແລ້ວສາມາດກູ້ຄືນໄດ້',
    paymentRecovery: 'ກູ້ຄືນການຊຳລະເງິນຂອງທ່ານ',
    paymentRecoveryDetail: 'ກູ້ຄືນການຊຳລະເງິນໄປຍັງເວີຊັນພຣີມຽມ',
    purchaseFailed: 'ຊຳລະເງິນບໍ່ສຳເລັດ! ກະລຸນາລອງໃໝ່.',
    purchaseSuccess: 'ຊຳລະເງິນສຳເລັດ! ຂອບໃຈ!',
    recoveryPaymentSuccess: 'ກູ້ຄືນການຊຳລະເງິນສຳເລັດ!',
    recoveryPaymentUnsuccess: 'ບໍ່ພົບການຊຳລະເງິນຂອງທ່ານ!',
    recoveryIfNeed: 'ຖ້າທ່ານເຄີຍຊຳລະເງິນແລ້ວ, ກະລຸນາເລືອກກູ້ຄືນການຊຳລະເງິນ.',
    cancelIfNeed: 'ຍົກເລີກໄດ້ທຸກເວລາໃນ',
    expireDate: 'ວັນໝົດອາຍຸເຖິງ',
    expired: 'ໝົດອາຍຸແລ້ວ',
    yourPackage: 'ທ່ານກຳລັງໃຊ້ເວີຊັນພຣີມຽມ',
    packageFull: 'ແພັກເກດຕະຫຼອດຊີວິດບໍ່ຈຳກັດ',
    trial: 'ທົດລອງໃຊ້ 7 ມື້',
    trialDetail: 'ໃຊ້ເວີຊັນພຣີມຽມໄດ້ 7 ມື້.\nຫຼັງຈາກໝົດເວລາ ທ່ານຈະກັບໄປໃຊ້ເວີຊັນຟຣີ',
    package1M: 'ແພັກເກດ 1 ເດືອນ',
    package3M: 'ແພັກເກດ 3 ເດືອນ',
    package6M: 'ແພັກເກດ 6 ເດືອນ',
    package1Y: 'ແພັກເກດ 1 ປີ',
    package5Y: 'ແພັກເກດ 5 ປີ',
    package10Y: 'ແພັກເກດ 10 ປີ',
    package1MDetail: 'ໃຊ້ເວີຊັນພຣີມຽມໄດ້ 1 ເດືອນ.\nຈະຕໍ່ອາຍຸອັດຕະໂນມັດເມື່ອໝົດເວລາ',
    package3MDetail: 'ໃຊ້ເວີຊັນພຣີມຽມໄດ້ 3 ເດືອນ.\nຈະຕໍ່ອາຍຸອັດຕະໂນມັດເມື່ອໝົດເວລາ',
    package6MDetail: 'ໃຊ້ເວີຊັນພຣີມຽມໄດ້ 6 ເດືອນ.\nແພັກເກດສາມາດສະສົມເວລາໄດ້ ແລະບໍ່ຕໍ່ອາຍຸອັດຕະໂນມັດ.',
    package1YDetail: 'ໃຊ້ເວີຊັນພຣີມຽມໄດ້ 1 ປີ.\nແພັກເກດສາມາດສະສົມເວລາໄດ້ ແລະບໍ່ຕໍ່ອາຍຸອັດຕະໂນມັດ.',
    package5YDetail: 'ໃຊ້ເວີຊັນພຣີມຽມໄດ້ 5 ປີ.\nແພັກເກດສາມາດສະສົມເວລາໄດ້ ແລະບໍ່ຕໍ່ອາຍຸອັດຕະໂນມັດ.',
    package10YDetail: 'ໃຊ້ເວີຊັນພຣີມຽມໄດ້ 10 ປີ.\nບໍ່ຕໍ່ອາຍຸອັດຕະໂນມັດ',
    packageWarehouse1Y: 'ຂະຫຍາຍສາງເພີ່ມ 1 ປີ',
    packageWarehouse1YDetail: 'ເພີ່ມຮ້ານສາຂາເສີມອີກ 1 ປີ.\nບໍ່ຕໍ່ອາຍຸອັດຕະໂນມັດ',
    packageStaff1Y: 'ພະນັກງານ 1 ປີ',
    packageStaff1YDetail: 'ຕໍ່ອາຍຸບັນຊີພະນັກງານຂອງທ່ານ 1 ປີ.\nບໍ່ຕໍ່ອາຍຸເອງ',
    serviceFee: 'ຄ່າບໍລິການ',
    serviceFeeDetail: 'ໃຊ້ແພັກເກດບໍລິການພຣີມຽມເພື່ອໃຊ້ຟັງຊັນທັງໝົດຂອງແອັບ. ກົດລາຍລະອຽດເພື່ອເບິ່ງຂໍ້ມູນ.',
    packageAutoRenew: 'ແພັກເກດຕໍ່ອາຍຸອັດຕະໂນມັດ',
    packageNonAutoRenew: 'ແພັກເກດບໍ່ຕໍ່ອາຍຸອັດຕະໂນມັດ',
    notFoundPurchase: 'ບໍ່ພົບການຊຳລະເງິນຂອງທ່ານ',
    purchaseLinkedWithOtherAcc: 'ການຊຳລະເງິນນີ້ຖືກຜູກກັບບັນຊີອື່ນແລ້ວ',
    recoverySumary: 'ຖ້າທ່ານເຄີຍຊຳລະເງິນແລ້ວ ແຕ່ຍັງມີໂຄສະນາ ຫຼືຍັງໃຊ້ຟີເຈີຂອງເວີຊັນທີ່ຊຳລະເງິນບໍ່ໄດ້, ກະລຸນາເລືອກກູ້ຄືນການຊຳລະເງິນດ້ານລຸ່ມ',
    recoverySumary1: 'ຖ້າທ່ານກູ້ຄືນການຊຳລະເງິນສຳເລັດແລ້ວ ແຕ່ຍັງມີຂໍ້ຈຳກັດ ຫຼືໂຄສະນາ, ກະລຸນາອອກຈາກແອັບແລ້ວເຂົ້າໃໝ່.',
    purchaseProcessing: 'ການຊຳລະເງິນຍັງກຳລັງດຳເນີນການ, ກະລຸນາລໍຖ້າສັກຄູ່. ຖ້າຊຳລະເງິນສຳເລັດແລ້ວແຕ່ຍັງບໍ່ອັບເດດ, ກະລຸນາກົດກູ້ຄືນການຊຳລະເງິນ.',
    iapInLoading: 'ຍັງບໍ່ພ້ອມ. ກະລຸນາລໍຖ້າສັກຄູ່',
    yourPackageInfo: 'ແພັກເກດຂອງທ່ານ',
    compare: 'ປຽບທຽບ FREE - PREMIUM',
    trialConfirm: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການເປີດໃຊ້ PREMIUM ທົດລອງ 7 ມື້? ເມື່ອແພັກເກດຂອງທ່ານໝົດອາຍຸ ຈະກັບໄປເປັນແພັກເກດ FREE',
    trialActive: 'ເປີດໃຊ້ການທົດລອງ',
    trialActiveDetail: 'ທ່ານກຳລັງໃຊ້ເວີຊັນຟຣີ. ຕ້ອງການເປີດໃຊ້ເວີຊັນພຣີມຽມເປັນເວລາ 7 ມື້ບໍ? ເມື່ອໝົດເວລາ ຈະກັບໄປເປັນເວີຊັນຟຣີ!',
    cancelSubsiOS:
      'ຍົກເລີກການຕໍ່ອາຍຸອັດຕະໂນມັດໃນ iPhone ໃຫ້ເຮັດຕາມຂັ້ນຕອນນີ້.\n    - ເປີດແອັບ Settings ໃນ iPhone.\n    - ແຕະຊື່ຂອງທ່ານ.\n    - ແຕະ Subscriptions.\n    - iPhone ຈະສະແດງເມນູ Subscriptions ໃນ Settings.\n    - ແຕະການສະໝັກໃຊ້ທີ່ຕ້ອງການຈັດການ\n    - ແຕະ Cancel Subscription ',
    cancelSubsAndroid:
      'ຍົກເລີກແພັກເກດໃນໂທລະສັບ Android ໃຫ້ເຮັດຕາມຂັ້ນຕອນນີ້\n    - ໄປທີ່ແອັບ CH Play ໃນໂທລະສັບ Android > ຈາກນັ້ນແຕະໄອຄອນຊື່ Google Account\n    - ເລືອກ ການຊຳລະເງິນ ແລະ ແພັກເກດການສະໝັກໃຊ້\n    - ເລືອກ ແພັກເກດການສະໝັກໃຊ້\n    - ເລືອກແພັກເກດທີ່ຕ້ອງການຍົກເລີກ\n    - ເລືອກ ຍົກເລີກ\n    - ເລືອກ ພາຍຫຼັງ\n    - ເລືອກເຫດຜົນທີ່ຕ້ອງການຍົກເລີກແພັກເກດ\n    - ເລືອກ ຍົກເລີກແພັກເກດການສະໝັກໃຊ້',
    canSubs: 'ຍົກເລີກການຕໍ່ອາຍຸ',
    autoRenewWarning: 'ຍົກເລີກການຕໍ່ອາຍຸ',
    autoRenewWarningDetail: 'ທ່ານກຳລັງໃຊ້ແຜນທີ່ຕໍ່ອາຍຸອັດຕະໂນມັດລາຍເດືອນ. ກະລຸນາຍົກເລີກແຜນນີ້ກ່ອນຊື້ແຜນທີ່ສູງກວ່າ ເພື່ອຫຼີກເວັ້ນການຖືກເກັບເງິນລາຍເດືອນ!'
  },
  upgrade: {
    hasNewVersion: 'ມີເວີຊັນໃໝ່',
    changelog: 'ບັນທຶກການປ່ຽນແປງ',
    upgradeNow: 'ອັບເກຣດ',
    later: 'ພາຍຫຼັງ',
    changeLogs: [
      'ແກ້ໄຂຂໍ້ຜິດພາດຂໍ້ຄວາມບໍ່ຊັດເມື່ອເລືອກຮູບແບບສີເຂັ້ມ',
      'ແກ້ໄຂບັນຫາບັນທຶກໃບຮັບສິນຄ້າບໍ່ໄດ້ໃນບາງອຸປະກອນ',
      'ປັບປຸງໂຄສະນາໃຫ້ເໝາະກັບຮູບແບບສີສະຫວ່າງ ແລະ ສີເຂັ້ມ',
      'ເພີ່ມຟີເຈີສົ່ງໄຟລ໌ລາຍງານຂໍ້ຜິດພາດໃຫ້ນັກພັດທະນາ',
      'ແລະ ແກ້ໄຂບັກນ້ອຍໆອື່ນໆ'
    ]
  },
  profile: {
    title: 'ຂໍ້ມູນສ່ວນຕົວ',
    nameShop: 'ຊື່ຮ້ານ',
    email: 'Email',
    address: 'ທີ່ຢູ່',
    numberPhone: 'ໂທລະສັບ',
    phone: 'ເບີໂທລະສັບ',
    edit: 'ແກ້ໄຂ',
    save: 'ບັນທຶກ',
    bank: 'IBAN',
    placholderBillInfo: 'ຂໍ້ມູນນີ້ຈະສະແດງໃນໃບແຈ້ງໜີ້ (ໂທລະສັບ, ທີ່ຢູ່, ທະນາຄານ...)',
    placholderBank: 'ປ້ອນບັນຊີທະນາຄານ',
    placholderName: 'ປ້ອນຊື່ຮ້ານ',
    profileDetail: 'ອັບເດດຂໍ້ມູນລະບຸຮ້ານ ແລະ ຂໍ້ມູນຕິດຕໍ່.',
    changeAvatar: 'ປ່ຽນຮູບໂປຣໄຟລ໌',
    emailVerified: 'Email ໄດ້ຮັບການຢືນຢັນແລ້ວ ບໍ່ສາມາດປ່ຽນໄດ້.',
    placholderEmail: 'Email ບໍ່ສາມາດປ່ຽນໄດ້',
    placholderAdress: 'ປ້ອນທີ່ຢູ່',
    placholderPhone: 'ປ້ອນເບີໂທລະສັບຂອງທ່ານ',
    avatarEmpty: 'ກະລຸນາເລືອກຮູບພາບ',
    nameEmpty: 'ຊື່ຮ້ານຕ້ອງບໍ່ຫວ່າງ',
    emailEmpty: 'Email ຕ້ອງບໍ່ຫວ່າງ',
    adressEmpty: 'ທີ່ຢູ່ບໍ່ສາມາດປ່ອຍວ່າງໄດ້',
    phoneEmpty: 'ເບີໂທລະສັບບໍ່ສາມາດປ່ອຍວ່າງໄດ້',
    billInfo: 'ຂໍ້ມູນຮ້ານຄ້າ',
    freeAcc: 'ຟຣີ',
    proAcc: 'ພຣີມຽມ'
  },
  invoice: {
    stt: 'ລຳດັບ',
    titleImport: 'ໃບບິນ',
    titleReturn: 'ໃບບິນຄືນສິນຄ້າ',
    title: 'ໃບບິນ',
    code: 'ເລກໃບບິນ:',
    totalPrice: 'ຍອດເງິນ',
    nameClient: 'ລູກຄ້າ',
    order: 'ລະຫັດສິນຄ້າ',
    nameProduct: 'ຊື່ສິນຄ້າ',
    number: 'ຈຳນວນ',
    price: 'ຈຳນວນເງິນລວມ',
    money: 'ລາຄາຕໍ່ໜ່ວຍ',
    unit: 'ໜ່ວຍ',
    buyer: 'ຜູ້ຊື້',
    salesman: 'ພະນັກງານຂາຍ',
    writeFull: '(ເຊັນຊື່, ຂຽນຊື່ເຕັມ)',
    day: 'ວັນທີ',
    month: 'ເດືອນ',
    year: 'ປີ',
    save: 'ບັນທຶກ',
    thanks: 'ຂອບໃຈທີ່ອຸດໜູນ!',
    draft: 'ໃບບິນຊົ່ວຄາວ'
  },
  barcode: {
    title: 'ສະແກນລະຫັດ',
    message: 'ຍ້າຍກ້ອງໄປໃສ່ກອບເພື່ອສະແກນ'
  },
  help: {
    removeAds: 'ຂ້ອຍສາມາດລຶບໂຄສະນາໄດ້ບໍ?',
    removeAdsDetail: 'ທ່ານສາມາດລຶບໂຄສະນາໂດຍຊື້ແພັກເກດລຸ້ນພຣີມຽມ. ທ່ານສາມາດໃຊ້ຟີເຈີສ່ວນໃຫຍ່ຂອງແອັບໄດ້ເຕັມທີ່ໂດຍບໍ່ຕ້ອງຊື້ແພັກເກດ.',
    adsNotDisable: 'ຂ້ອຍຊື້ລຸ້ນພຣີມຽມແລ້ວ ແຕ່ໂຄສະນາຍັງປາກົດຢູ່',
    adsNotDisableDetail:
      '- ໄປທີ່ "ໄອຄອນເມນູມຸມເທິງຊ້າຍ" -> "ລຸ້ນພຣີມຽມ" -> ເລືອກ "ກູ້ຄືນການຊຳລະເງິນ". ເມື່ອມີຂໍ້ຄວາມສີຟ້າປາກົດຂຶ້ນ, ການຊຳລະເງິນຂອງທ່ານຖືກກູ້ຄືນສຳເລັດແລ້ວ. ໂຄສະນາຈະບໍ່ປາກົດອີກ.\n- ຖ້າມີຂໍ້ຄວາມສີແດງປາກົດຂຶ້ນ, ການກູ້ຄືນການຊຳລະເງິນຍັງບໍ່ສຳເລັດ. ກະລຸນາກວດສອບການຊຳລະເງິນຂອງທ່ານອີກຄັ້ງ ຫຼືບັນຊີ iTunes Store ຕ້ອງເປັນບັນຊີດຽວກັນກັບບັນຊີທີ່ຊຳລະເງິນ.\n- ຖ້າທ່ານຊຳລະເງິນສຳເລັດແລ້ວ ແຕ່ບໍ່ສາມາດເປີດໃຊ້ການກູ້ຄືນການຊຳລະເງິນໄດ້, ກະລຸນາຕິດຕໍ່ນັກພັດທະນາຜ່ານອີເມວ: xgitdev@gmail.com ເພື່ອຂໍຄວາມຊ່ວຍເຫຼືອ',
    recoveryData: 'ຂ້ອຍສາມາດສຳຮອງ ຫຼື ໂອນຂໍ້ມູນໄປອຸປະກອນອື່ນໄດ້ບໍ?',
    recoveryDataeDetail:
      'ທ່ານສາມາດລົງທະບຽນບັນຊີ, ຈາກນັ້ນເປີດເມນູແລະເລືອກຊິງຄ໌ຂໍ້ມູນປັດຈຸບັນ, ແລ້ວທ່ານຈະບໍ່ເສຍຂໍ້ມູນອີກ. ຖ້າອຸປະກອນຂອງທ່ານບໍ່ມີຂໍ້ມູນໃດໆ, ທ່ານສາມາດຂ້າມຂັ້ນຕອນຊິງຄ໌ໄດ້.\nໃນອຸປະກອນອື່ນ, ທ່ານພຽງແຕ່ເຂົ້າສູ່ລະບົບດ້ວຍບັນຊີປັດຈຸບັນຂອງທ່ານ ກໍສາມາດໃຊ້ງານໄດ້ຕາມປົກກະຕິ.',
    recoveryDataAuto: 'ສາມາດສຳຮອງຂໍ້ມູນອັດຕະໂນມັດໄດ້ບໍ?',
    recoveryDataeAutoDetail: 'ທ່ານສາມາດໃຊ້ຟີເຈີນີ້ໄດ້ໃນການຕັ້ງຄ່າ. ແຕ່ຟີເຈີນີ້ຈະມີໃນລຸ້ນພຣີມຽມເທົ່ານັ້ນ'
  },
  importFromCSV: {
    textHint: 'ນຳເຂົ້າຂໍ້ມູນຂໍ້ຄວາມຈາກໄຟລ໌ CSV ຂອງທ່ານທີ່ນີ້',
    title: 'ນຳເຂົ້າຈາກໄຟລ໌ csv',
    choiceFile: 'ເລືອກໄຟລ໌',
    intro: 'ກະລຸນາປ້ອນເນື້ອຫາດ້ານລຸ່ມເພື່ອສ້າງຄຳສັ່ງຊື້ຈຳນວນຫຼາຍ. ທ່ານສາມາດເບິ່ງຕົວຢ່າງແລະຄຳແນະນຳໄດ້ທີ່',
    enterText: 'ປ້ອນຂໍ້ຄວາມ',
    newCustomer: 'ລູກຄ້າໃໝ່',
    productInvalid: 'ສິນຄ້າບໍ່ຖືກຕ້ອງ',
    productInvalidMessage: 'ລະຫັດສິນຄ້າບໍ່ຖືກຕ້ອງ. ກະລຸນາກວດສອບລະຫັດຂອງສິນຄ້າທີ່ຖືກເນັ້ນສີແດງ ',
    check: 'ທົດສອບ',
    save: 'ບັນທຶກຄຳສັ່ງຊື້',
    emptyDataMessage: 'ຍັງບໍ່ພົບຄຳສັ່ງຊື້',
    complete: 'ນຳເຂົ້າສຳເລັດແລ້ວ',
    gotIt: 'ເຂົ້າໃຈແລ້ວ',
    here: 'ທີ່ນີ້',
    syntaxIntro1: 'ທ່ານສາມາດເບິ່ງໄຟລ໌ CSV ຕົວຢ່າງໄດ້ທີ່ນີ້.',
    syntaxIntro2: 'ຈາກນັ້ນ ທ່ານຕ້ອງເປີດໄຟລ໌ CSV ຂອງທ່ານເປັນຂໍ້ຄວາມ ແລ້ວຄັດລອກເນື້ອຫາຂອງໄຟລ໌ CSV ໄປວາງໃນກ່ອງປ້ອນຂໍ້ມູນ.',
    syntax: 'ຮູບແບບຄຳສັ່ງ',
    examp: 'ຕົວຢ່າງ',
    syntaxTut: 'ກະລຸນາຈັດຮູບແບບຂໍ້ມູນຕາມຮູບແບບດ້ານລຸ່ມ. ແຕ່ລະຄຳສັ່ງຊື້ແຍກກັນດ້ວຍການຂຶ້ນບັນທັດໃໝ່. ',
    syntaxDetail:
      'ເບີໂທ | ຊື່ລູກຄ້າ | ທີ່ຢູ່, ຄ່າເພີ່ມ, ລະຫັດສິນຄ້າ | ຈຳນວນ | ສ່ວນຫຼຸດ \nເບີໂທ | ຊື່ລູກຄ້າ | ທີ່ຢູ່, ຄ່າເພີ່ມ, ລະຫັດສິນຄ້າ | ຈຳນວນ | ສ່ວນຫຼຸດ, ລະຫັດສິນຄ້າ | ຈຳນວນ | ສ່ວນຫຼຸດ \nເບີໂທ | ຊື່ລູກຄ້າ | ທີ່ຢູ່, ຄ່າເພີ່ມ, ລະຫັດສິນຄ້າ | ຈຳນວນ | ສ່ວນຫຼຸດ, ລະຫັດສິນຄ້າ | ຈຳນວນ | ສ່ວນຫຼຸດ, ລະຫັດສິນຄ້າ | ຈຳນວນ | ສ່ວນຫຼຸດ, ລະຫັດສິນຄ້າ | ຈຳນວນ | ສ່ວນຫຼຸດ',
    syntaxExamp:
      '0123456789 | NGUYEN VAN A | Ha Noi, 10, SP1 | 5 | 0 \n0123456789 | NGUYEN VAN A | Ha Noi, 10, SP1 | 5 | 0, SP2 | 4 | 0 \n0123456789 | NGUYEN VAN A | Ha Noi, 10, SP1 | 5 | 0, SP2 | 4 | 0, SP3 | 4 | 0 '
  },
  bill: {
    name: 'ໃບບິນ',
    title: 'ໃບບິນຊຳລະເງິນ',
    product: 'ສິນຄ້າ',
    day: 'ວັນຂາຍ',
    amount: 'ຈຳນວນ',
    money: 'ຈຳນວນເງິນ',
    totalMoney: 'ຍອດລວມ',
    thanks: 'ຂອບໃຈທີ່ອຸດໜູນ!',
    createBy: 'ຂາຍແບບມືອາຊີບດ້ວຍແອັບ',
    unit: 'ຫົວໜ່ວຍ',
    discount2: 'ສ່ວນຫຼຸດ %',
    discount1: 'ຈຳນວນເງິນສ່ວນຫຼຸດ',
    customImage: 'ຮູບພາບກຳນົດເອງ',
    customText: 'ຂໍ້ຄວາມກຳນົດເອງ',
    moneyText: 'ຈຳນວນເງິນເປັນຕົວໜັງສື'
  },
  printer: {
    name: 'ເຄື່ອງພິມ',
    connected: 'ເຊື່ອມຕໍ່ເຄື່ອງພິມແລ້ວ!',
    title: 'ເຊື່ອມຕໍ່ເຄື່ອງພິມ',
    find: 'ກຳລັງຄົ້ນຫາເຄື່ອງພິມ. ກະລຸນາລໍຖ້າ...!',
    empty: 'ບໍ່ພົບເຄື່ອງພິມ',
    unknow: 'ບໍ່ຮູ້ຈັກ',
    pressToConnect: 'ແຕະເພື່ອເຊື່ອມຕໍ່ ແລະພິມທົດສອບ',
    notConnect: 'ກະລຸນາເຊື່ອມຕໍ່ເຄື່ອງພິມໃນການຕັ້ງຄ່າ.',
    trial: 'ເຫຼືອການທົດລອງ %s',
    trialExpired: 'ທ່ານໃຊ້ສິດພິມທົດສອບໝົດແລ້ວ. ກະລຸນາຊື້ເວີຊັນພຣີມຽມເພື່ອໃຊ້ຟີເຈີນີ້',
    printError: 'ເຄື່ອງພິມຍັງບໍ່ພ້ອມ, ກະລຸນາລອງໃໝ່',
    devicesTested: 'ອຸປະກອນທີ່ທີມພັດທະນາທົດສອບແລ້ວ: xPrinter 58iiH, GOOJPRT PT-210',
    choice: 'ເລືອກເຄື່ອງພິມ',
    require: 'ຮອງຮັບເຄື່ອງພິມໃບບິນຄວາມຮ້ອນທີ່ເຊື່ອມຕໍ່ຜ່ານ USB. ຄອມພິວເຕີຕ້ອງຕິດຕັ້ງໄດຣເວີເຄື່ອງພິມກ່ອນ ຈຶ່ງຈະເຊື່ອມຕໍ່ໄດ້',
    fixOnWindow: 'ແກ້ໄຂບັນຫາເຊື່ອມຕໍ່ບໍ່ໄດ້ໃນ Windows',
    printerDriverType: 'ປະເພດໄດຣເວີການເຊື່ອມຕໍ່',
    printerDriverTypeDetail: 'ເລືອກປະເພດໄດຣເວີເຄື່ອງພິມທີ່ທ່ານຕິດຕັ້ງໃນຄອມພິວເຕີ.',
    printerDriverTypeList: ['ໄດຣເວີເຄື່ອງພິມ (ໄດຣເວີຂອງຍີ່ຫໍ້)', 'ໄດຣເວີ Zadig (ຄຳແນະນຳຂອງ aSeller)'],
    printerSizeDetail: 'ເລືອກຂະໜາດເຈ້ຍພິມຂອງທ່ານ. ຮອງຮັບຂະໜາດເຈ້ຍ A4, A5, 80mm, 58mm',
    choiceDriverTypeWarning: 'ກະລຸນາເລືອກປະເພດໄດຣເວີທີ່ຕິດຕັ້ງແລ້ວ.'
  },
  importFromExcel: {
    textHint: 'ປ້ອນຂໍ້ມູນຂໍ້ຄວາມຈາກໄຟລ໌ Excel ຂອງທ່ານທີ່ນີ້',
    title: 'ນຳເຂົ້າຈາກ Excel',
    choiceFile: 'ເລືອກໄຟລ໌',
    intro: 'ກະລຸນາປ້ອນເນື້ອຫາດ້ານລຸ່ມເພື່ອສ້າງຄຳສັ່ງຊື້ຫຼາຍລາຍການ. ທ່ານສາມາດເບິ່ງຕົວຢ່າງ ແລະຄູ່ມືໄດ້ທີ່',
    introProduct: 'ກະລຸນາເລືອກໄຟລ໌ Excel ເພື່ອນຳເຂົ້າສິນຄ້າໄດ້ຢ່າງໄວ. ກະລຸນາຢ່າເລືອກໄຟລ໌ທີ່ທ່ານສົ່ງອອກຈາກລາຍການສິນຄ້າ ເພາະຮູບແບບໄຟລ໌ບໍ່ຄືກັນ. ທ່ານສາມາດເບິ່ງຕົວຢ່າງ ແລະຄູ່ມືໄດ້ທີ່',
    introProduct1: 'ທ່ານຄວນໃຊ້ເວີຊັນເວັບເພື່ອໃຊ້ງານງ່າຍຂຶ້ນ. ທ່ານຕ້ອງປ້ອນຫົວໜ່ວຍ ແລະໝວດໝູ່ລ່ວງໜ້າ ເພື່ອໃຫ້ລະບົບຮັບຮູ້',
    enterText: 'ປ້ອນຂໍ້ຄວາມ',
    newCustomer: 'ລູກຄ້າໃໝ່',
    productInvalid: 'ສິນຄ້າບໍ່ຖືກຕ້ອງ',
    productInvalidMessage: 'ລະຫັດສິນຄ້າບໍ່ຖືກຕ້ອງ. ກະລຸນາກວດຄືນລະຫັດຂອງລາຍການທີ່ໄຮໄລດ້ວຍສີແດງ',
    check: 'ກວດສອບ',
    save: 'ບັນທຶກສິນຄ້າ %s ລາຍການ',
    emptyDataMessage: 'ບໍ່ພົບສິນຄ້າ',
    complete: 'ນຳເຂົ້າສຳເລັດ',
    gotIt: 'ເຂົ້າໃຈແລ້ວ',
    here: 'ທີ່ນີ້',
    syntaxIntro1:
      'ຄວນນຳເຂົ້າໜ້ອຍກວ່າ 500 ລາຍການຕໍ່ຄັ້ງ. ສາມາດແບ່ງເປັນຫຼາຍໄຟລ໌ເພື່ອນຳເຂົ້າໄດ້. ສິນຄ້າຕ້ອງບໍ່ມີຊື່, ລະຫັດ ຫຼື SKU ຊ້ຳກັນ. ຄວນລຶບຄໍລຳທີ່ບໍ່ຈຳເປັນຕ້ອງປ່ຽນ. ສາມາດເບິ່ງໄຟລ໌ຕົວຢ່າງໄດ້ທີ່ນີ້.',
    syntaxIntro2: 'ຈາກນັ້ນ ຕ້ອງເປີດໄຟລ໌ Excel ເປັນຂໍ້ຄວາມ, ແລ້ວຄັດລອກເນື້ອຫາໃນໄຟລ໌ Excel ແລະວາງລົງໃນຊ່ອງປ້ອນຂໍ້ມູນ.',
    found: 'ພົບສິນຄ້າ %s ລາຍການ',
    demo: 'ໄຟລ໌ຕົວຢ່າງ'
  },
  unit: {
    id: 'ID',
    title: 'ຫົວໜ່ວຍ',
    choice: 'ເລືອກຫົວໜ່ວຍ',
    create: 'ສ້າງຫົວໜ່ວຍໃໝ່',
    name: 'ຊື່ຫົວໜ່ວຍ',
    search: 'ກອງຕາມລະຫັດ, ຊື່ຫົວໜ່ວຍ',
    exist: 'ຊື່ຫົວໜ່ວຍມີຢູ່ແລ້ວ',
    tips: 'ຄຳແນະນຳ',
    tip1: 'ໃຊ້ຫົວໜ່ວຍວັດແທກມາດຕະຖານ (ເຊັ່ນ ອັນ, ແພັກ, ກ່ອງ, ລັງ...).',
    tip2: 'ຫົວໜ່ວຍຊ່ວຍໃຫ້ຈັດການສະຕັອກ ແລະການຂາຍໄດ້ແມ່ນຍຳຂຶ້ນ.',
    tip3: 'ສາມາດຕັ້ງຄ່າການແປງຫົວໜ່ວຍໄດ້ໂດຍກົງໃນລາຍລະອຽດສິນຄ້າ.',
    convert: 'ຫົວໜ່ວຍແປງ',
    addConvert: 'ເພີ່ມຫົວໜ່ວຍແປງ',
    editConvert: 'ແກ້ໄຂຫົວໜ່ວຍແປງ',
    valueConvert: 'ຄ່າທີ່ແປງແລ້ວ',
    invalidValueConvert: 'ຂໍ້ມູນຫົວໜ່ວຍແປງບໍ່ຖືກຕ້ອງ. ກະລຸນາກວດຄືນ!',
    invalidMainUnit: 'ກະລຸນາເລືອກຫົວໜ່ວຍຫຼັກກ່ອນສ້າງຫົວໜ່ວຍແປງ!',
    sameMainUnit: 'ຫົວໜ່ວຍແປງບໍ່ສາມາດເປັນຫົວໜ່ວຍດຽວກັບຫົວໜ່ວຍຫຼັກໄດ້. ກະລຸນາເລືອກຫົວໜ່ວຍອື່ນ!',
    deleteUnitConvert: 'ລຶບຫົວໜ່ວຍແປງ',
    deleteUnitConvertWarning: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການລຶບຫົວໜ່ວຍແປງນີ້? ຫົວໜ່ວຍແປງທີ່ເຄີຍໃຊ້ໃນຄຳສັ່ງຊື້ຂາຍແລ້ວ ບໍ່ສາມາດລຶບໄດ້.',
    choiceMainUnitFirstWarning: 'ກະລຸນາເລືອກຫົວໜ່ວຍວັດແທກຂອງສິນຄ້າກ່ອນສ້າງຫົວໜ່ວຍແປງ.'
  },
  timeFilter: {
    today: 'ມື້ນີ້',
    yesterday: 'ມື້ວານນີ້',
    last7Days: '7 ມື້ຜ່ານມາ',
    last30Days: '30 ມື້ຜ່ານມາ',
    custom: 'ກຳນົດເອງ',
    thisMonth: 'ເດືອນນີ້',
    lastMonth: 'ເດືອນກ່ອນ',
    choiceStartDate: 'ເລີ່ມຕົ້ນ',
    choiceEndDate: 'ສິ້ນສຸດ',
    choiceMonth: 'ເລືອກເດືອນ'
  },
  autoRestoreDb: {
    title: 'ການກູ້ຄືນຂໍ້ມູນ',
    message: 'ພວກເຮົາພົບວ່າບັນຊີຂອງທ່ານມີເວີຊັນຂໍ້ມູນໃໝ່ກວ່າ. ທ່ານຕ້ອງການຊິງກັບຂໍ້ມູນຫຼ້າສຸດນັ້ນບໍ?'
  },
  support: {
    title: 'ສະໜັບສະໜູນສົດ',
    emailSupportDetail: 'ທ່ານຕ້ອງການຕິດຕໍ່ພວກເຮົາ. ກະລຸນາເລືອກວິທີຕິດຕໍ່ດ້ານລຸ່ມນີ້.',
    emailSupport: 'ສົ່ງອີເມວຫານັກພັດທະນາ',
    zaloSupportDetail: 'ຖ້າທ່ານຕ້ອງການການສະໜັບສະໜູນດ່ວນ ເຊັ່ນ ແອັບມີຂໍ້ຜິດພາດ ຫຼື ຄຳຖາມການໃຊ້ງານ. ກະລຸນາເລືອກຮັບສະໜັບສະໜູນຜ່ານ Zalo',
    zaloSupport: 'ສະໜັບສະໜູນຜ່ານກຸ່ມ Zalo'
  },
  customerDebt: {
    title: 'ໜີ້ສິນລວມ',
    total: 'ຍອດຄ້າງຊຳລະລວມ',
    customerDebtStatistial: 'ໜີ້ຕາມລູກຄ້າ',
    beginningBalance: 'ຍອດຍົກມາ',
    beginningDebts: 'ໜີ້ເດບິດຕົ້ນງວດ',
    closingBalance: 'ຍອດຍົກໄປ',
    closingDebts: 'ໜີ້ທ້າຍງວດ',
    showAll: 'ສະແດງກະແສເງິນທັງໝົດ',
    simple: 'ຮຸ່ນແບບງ່າຍ',
    hideProduct: 'ເຊື່ອງສິນຄ້າ',
    timeRange: 'ຊ່ວງເວລາ',
    displayConfig: 'ຕັ້ງຄ່າການສະແດງ',
    debtCheckWarning: '(ກະລຸນາກວດກາ ແລະ ກະທົບຍອດຂໍ້ມູນດ້ານເທິງອີກຄັ້ງ)',
    scanToPay: 'ສະແກນເພື່ອຈ່າຍ',
    scanToPayHint: 'ໃຊ້ແອັບທະນາຄານ ຫຼື ກະເປົາເງິນອີເລັກໂຕຣນິກເພື່ອສະແກນລະຫັດ'
  },
  returnOrder: {
    edit: 'ແກ້ໄຂອໍເດີຄືນສິນຄ້າ',
    create: 'ເພີ່ມອໍເດີຄືນສິນຄ້າ'
  },
  maintenance: {
    title: 'ການບຳລຸງຮັກສາ',
    message: 'ເຊີບເວີຂອງພວກເຮົາກຳລັງບຳລຸງຮັກສາປະມານ %s ນາທີ. ກະລຸນາລອງໃໝ່ພາຍຫຼັງ!!!',
    timeout: 'ຂໍອະໄພ! ເກີດຂໍ້ຜິດພາດ. ກະລຸນາລອງໃໝ່ຫຼັງຈາກບໍ່ກີ່ນາທີ. ຖ້າຍັງໃຊ້ບໍ່ໄດ້ ກະລຸນາຕິດຕໍ່ທີມສະໜັບສະໜູນຂອງພວກເຮົາ!!!',
    messageTimeout: 'ເຊີບເວີຂອງພວກເຮົາຄ່ອນຂ້າງຫຍຸ້ງ! ກະລຸນາລອງດາວໂຫຼດໃໝ່! ຖ້າຍັງໂຫຼດບໍ່ໄດ້ ພັກປະມານ 5 ນາທີແລ້ວລອງໃໝ່!. ຂອບໃຈຫຼາຍ!',
    networkError: 'ຂໍ້ຜິດພາດເຄືອຂ່າຍ',
    networkErrorDetail: 'ສາຍອິນເຕີເນັດມີບັນຫາ. ກະລຸນາກວດ WIFI ຫຼື 4G ອີກຄັ້ງ. ຖ້າຍັງດາວໂຫຼດບໍ່ໄດ້ ກະລຸນາຕິດຕໍ່ພວກເຮົາເພື່ອຂໍຄວາມຊ່ວຍເຫຼືອ! ຂອບໃຈຫຼາຍ!'
  },
  financialBook: {
    debt: 'ໃບບັນທຶກໜີ້',
    createDebt: 'ສ້າງໜີ້',
    title: 'ກະແສເງິນ',
    receipts: 'ໃບຮັບເງິນ',
    paymentVoucher: 'ໃບຈ່າຍເງິນ',
    moneyFromCustomer: 'ເງິນຮັບຈາກລູກຄ້າ',
    moneyForProvider: 'ການຈ່າຍເງິນໃຫ້ຜູ້ສະໜອງ',
    moneyForReturn: 'ເງິນຄືນສຳລັບການຄືນສິນຄ້າ',
    moneyFromReturn: 'ເງິນທີ່ໄດ້ຮັບຈາກການຄືນສິນຄ້າ',
    idAutoGen: 'ລະຫັດອັດຕະໂນມັດ',
    cash: 'ເງິນສົດ',
    bank: 'ທະນາຄານ',
    totalFund: 'ຍອດເງິນລວມ',
    submitter: 'ຜູ້ສ້າງ',
    typeCharge1: 'ປະເພດໃບຮັບເງິນ',
    typeCharge2: 'ປະເພດການຈ່າຍເງິນ',
    receipt: 'ໃບຮັບເງິນສົດ',
    vouchers: 'ໃບຈ່າຍເງິນສົດ',
    fullName: 'ຊື່ເຕັມ',
    submitters: 'ຜູ້ສົ່ງ',
    money: 'ຈຳນວນເງິນ',
    textEmptyFinancial: 'ທ່ານຍັງບໍ່ມີໃບຮັບເງິນ/ໃບຈ່າຍເງິນເທື່ອ.',
    accountBank: 'ບັນຊີຮັບເງິນ',
    nameBank: 'ບັນຊີທະນາຄານ',
    accountNumber: 'ເລກບັນຊີ',
    accountHolder: 'ເຈົ້າຂອງບັນຊີ',
    receiptForOrder: 'ໃບຮັບເງິນສຳລັບຄຳສັ່ງຊື້',
    paymentForOrder: 'ໃບຈ່າຍເງິນສຳລັບຄຳສັ່ງຊື້',
    receiptFromCustomer: 'ໃບຮັບເງິນຈາກລູກຄ້າ',
    receiptAutoGenFor: 'ໃບຮັບເງິນຖືກສ້າງອັດຕະໂນມັດສຳລັບຄຳສັ່ງຊື້',
    paymentForProvider: 'ການຈ່າຍເງິນໃຫ້ຜູ້ສະໜອງ',
    paymentForCustomer: 'ໃບຈ່າຍເງິນສຳລັບລູກຄ້າ',
    paymentVoucherAutoGenFor: 'ໃບຈ່າຍເງິນຖືກສ້າງອັດຕະໂນມັດຈາກຄຳສັ່ງຊື້',
    autoFinancialCanNotEdit: 'ໃບນີ້ຖືກສ້າງອັດຕະໂນມັດ. ກະລຸນາແກ້ໄຂຄຳສັ່ງຊື້ທີ່ກ່ຽວຂ້ອງ',
    createType: 'ສ້າງປະເພດໃໝ່',
    deleteType: 'ລຶບປະເພດ',
    deleteTypeWarning: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການລຶບ %s?',
    exportBill: 'ສົ່ງອອກ',
    deleteBill: 'ລຶບ',
    deleteBillWarning: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການລຶບທຸລະກຳເງິນສົດນີ້?',
    investment: 'ເງິນລົງທຶນ',
    investmentDetail:
      'ທຶນເລີ່ມຕົ້ນແມ່ນຍອດເງິນລວມ (ລາຍຮັບ - ລາຍຈ່າຍ) ທີ່ຄຳນວນຈາກເວລາຂາຍຄັ້ງທຳອິດຈົນເຖິງຕົ້ນງວດ.\nຕົວຢ່າງ: ຖ້າທ່ານເລືອກເດືອນນີ້ ທຶນລົງທຶນແມ່ນຍອດເງິນກ່ອນມື້ທຳອິດຂອງເດືອນ.',
    totalRevenue: 'ລາຍຮັບລວມ',
    totalSpending: 'ລາຍຈ່າຍລວມ',
    totalBlance: 'ຍອດຄົງເຫຼືອລວມ'
  },
  sortType: {
    newest: 'ລ່າສຸດ',
    oldest: 'ເກົ່າສຸດ',
    alphabet: 'ຕາມຕົວອັກສອນ'
  },
  guide: {
    revenue: 'ລາຍຮັບລວມ',
    expenditure: 'ລາຍຈ່າຍລວມ',
    title: 'ຄຳແນະນຳສຳລັບຜູ້ເລີ່ມຕົ້ນ',
    expenseReport: 'ປື້ມບັນຊີການເງິນ',
    product: 'ເພື່ອເລີ່ມຕົ້ນ ໃຫ້ເພີ່ມສິນຄ້າ ຫຼື ບໍລິການທີ່ທ່ານສະເໜີ.',
    customer: 'ການເພີ່ມລູກຄ້າໃໝ່ແມ່ນຂັ້ນຕອນພື້ນຖານເພື່ອສ້າງຂໍ້ມູນລູກຄ້າ ແລະ ຈັດການໜີ້ສິນໃນການຊື້ຂາຍຕໍ່ໄປ.',
    provider: 'ທ່ານຕ້ອງສ້າງຜູ້ສະໜອງເພື່ອຈັດການຂໍ້ມູນທັງໝົດທີ່ກ່ຽວກັບຜູ້ສະໜອງ: ຂໍ້ມູນຕິດຕໍ່, ໜີ້ສິນ, ປະຫວັດການນຳເຂົ້າ...',
    order: 'ຄຳສັ່ງຊື້ຈະຖືກບັນທຶກວ່າສິນຄ້າຖືກຕັດອອກຈາກສະຕັອກ ແລະ ສົ່ງໃຫ້ລູກຄ້າທັນທີເມື່ອສ້າງແລ້ວ... ທ່ານສາມາດເພີ່ມໝາຍເຫດ ແລະ ແທັກໃສ່ຄຳສັ່ງຊື້ເພື່ອໃຫ້ການກັ່ນຕອງຄຳສັ່ງຊື້ສະດວກຂຶ້ນ.',
    category: 'ໝວດໝູ່ແມ່ນບ່ອນສຳລັບຈັດການກຸ່ມປະເພດສິນຄ້າ.',
    complete: 'ທ່ານເຂົ້າໃຈພື້ນຖານແລ້ວ. ຍັງມີຟີເຈີອີກຫຼາຍທີ່ aSeller ອອກແບບໄວ້ໃຫ້ທ່ານ, ສຳຫຼວດຕໍ່ໄປ!!'
  },
  productHistoryLog: {
    title: 'ປະຫວັດຄັງສິນຄ້າ',
    sale: 'ການສົ່ງອອກ',
    import: 'ນຳເຂົ້າຄັງສິນຄ້າ',
    update: 'ກວດນັບສິນຄ້າ',
    return: 'ຄືນສິນຄ້າເຂົ້າສະຕັອກ',
    delete: 'ຍົກເລີກການຄືນເງິນ',
    amount: 'ຈຳນວນທຸລະກຳ',
    result: 'ຈຳນວນຫຼັງທຸລະກຳ',
    importReturn: 'ສົ່ງຄືນ'
  },
  orderType: {
    sale: 'ການຂາຍ',
    return: 'ສົ່ງຄືນ',
    import: 'ນຳເຂົ້າ',
    receipt: 'ໃບຮັບເງິນ',
    payment: 'ການຊຳລະເງິນ',
    importReturn: 'ສົ່ງຄືນສິນຄ້າທີ່ນຳເຂົ້າ',
    debt: 'ໜີ້ສິນ'
  },
  newCodepush: {
    title: 'ມີເວີຊັນໃໝ່ກວ່າແລ້ວ',
    des: 'ມີເວີຊັນໃໝ່ກວ່າອອກມາແລ້ວ. ທ່ານຕ້ອງການອັບເດດດຽວນີ້ບໍ?',
    cancel: 'ພາຍຫຼັງ',
    ok: 'ອັບເດດ'
  },
  printSetting: {
    tearOffset: 'ໄລຍະຫ່າງຈາກໃບຕັດເຖິງຫົວພິມ (mm)',
    tearOffsetDetail: 'ພື້ນທີ່ນີ້ຈະໃຊ້ປ່ອຍເຈ້ຍໃຫ້ພໍສຳລັບການຕັດ ໂດຍບໍ່ເຮັດໃຫ້ເນື້ອຫາທີ່ພິມສູນເສຍ',
    title: 'ການຕັ້ງຄ່າເຄື່ອງພິມ',
    type: 'ປະເພດເຄື່ອງພິມ',
    typeDetail: 'ຖ້າເຄື່ອງພິມຂອງທ່ານພິມໄດ້ສະເພາະໃບຮັບເງິນ ໃຫ້ເລືອກເຄື່ອງພິມ ESC/POS. ຖ້າເຄື່ອງພິມຂອງທ່ານພິມໄດ້ທັງປ້າຍສິນຄ້າ ແລະ ໃບຮັບເງິນ ໃຫ້ເລືອກ ZPL ຫຼື TSPL.',
    connection: 'ເຄື່ອງພິມ',
    size: 'ຂະໜາດການພິມ',
    qrBank: 'ເພີ່ມຮູບພາບກຳນົດເອງໄວ້ທ້າຍໃບແຈ້ງໜີ້',
    qrBankDetail: 'ທ່ານສາມາດເພີ່ມ QR ທະນາຄານ ເຊິ່ງຈະສະແດງຢູ່ດ້ານລຸ່ມຂອງໃບແຈ້ງໜີ້',
    asellerLogo: 'ສະແດງໂລໂກ້ aSeller',
    bluetooth: 'ເຄື່ອງພິມ Bluetooth',
    wifi: 'ເຄື່ອງພິມ WIFI',
    deviceIp: 'ທີ່ຢູ່ IP ຂອງເຄື່ອງພິມ',
    deviceIpEx: 'ຕົວຢ່າງ: 192.168.1.100',
    invalidIP: 'ກະລຸນາປ້ອນ IP ທີ່ຖືກຕ້ອງ!',
    canNotConnectIP: 'ບໍ່ສາມາດເຊື່ອມຕໍ່ IP ນີ້ໄດ້. ກະລຸນາກວດສອບ IP ຂອງເຄື່ອງພິມອີກຄັ້ງ!',
    notReady: 'ເຄື່ອງພິມຍັງບໍ່ພ້ອມ. ກະລຸນາໄປທີ່ການຕັ້ງຄ່າເຄື່ອງພິມກ່ອນ!',
    support:
      'ຮອງຮັບເຄື່ອງພິມໃບບິນຄວາມຮ້ອນ ESC/POS ທີ່ເຊື່ອມຕໍ່ຜ່ານ WIFI, Bluetooth, USB.\nໝາຍເຫດ: ບໍ່ຮອງຮັບເຄື່ອງພິມສະຫຼາກ. \nຮອງຮັບພຽງ 1 ອຸປະກອນທີ່ເຊື່ອມຕໍ່ກັບເຄື່ອງພິມໃນເວລາດຽວ.\nເຄື່ອງພິມທີ່ທົດສອບແລ້ວ: xPrinter 58iiH (Bluetooth), GOOJPRT PT-210 (Bluetooth), xPrinter T80L (WIFI)',
    orientation: 'ຂະໜາດການພິມ',
    potrait: 'ແນວຕັ້ງ',
    landscape: 'ແນວນອນ',
    method: 'ພາສາທີ່ຮອງຮັບ',
    esc: 'ESC/POS, ESC...',
    escDetail: 'ເປັນເຄື່ອງພິມສຳລັບພິມໃບແຈ້ງໜີ້ໂດຍສະເພາະ',
    tsc: 'ZPL, EPL, TSPL...',
    tscDetail: 'ເຄື່ອງພິມສາມາດພິມໃບແຈ້ງໜີ້, ສະຫຼາກ, ບາໂຄດ...',
    threshold: 'ຄວາມໜາຂອງຕົວອັກສອນ',
    thresholdTypeList: ['ປານກາງ', 'ໜາ', 'ໜາພິເສດ'],
    speed: 'ຄວາມໄວການພິມ',
    speedTypeList: ['ອັດຕະໂນມັດ', 'ຊ້າ'],
    spacingBottom: 'ຊ່ອງວ່າງດ້ານລຸ່ມ'
  },
  homeOfflineWarning: {
    message: 'ທ່ານກຳລັງໃຊ້ງານແບບອອບໄລນ໌. ກະລຸນາສະຫຼັບໄປໃຊ້ງານແບບອອນໄລນ໌ເພື່ອໃຊ້ຟີເຈີເພີ່ມເຕີມ ແລະຂໍ້ມູນຈະບໍ່ສູນເສຍ.',
    helpButton: 'ວິທີສະຫຼັບໄປໃຊ້ງານແບບອອນໄລນ໌'
  },
  statStock: {
    typeChoice: 'ສະຖິຕິສິນຄ້າຄົງຄັງຕາມ',
    inventoryCapital: 'ສິນຄ້າຄົງຄັງ'
  },
  customerGroup: {
    title: 'ກຸ່ມລູກຄ້າ',
    search: 'ກອງຕາມຊື່ ຫຼື ລະຫັດ',
    id: 'ລະຫັດກຸ່ມ',
    prefix: 'ຄຳນຳໜ້າລະຫັດກຸ່ມ',
    create: 'ເພີ່ມກຸ່ມ',
    choice: 'ເລືອກກຸ່ມລູກຄ້າ',
    choiceCustomers: 'ເພີ່ມລູກຄ້າເຂົ້າກຸ່ມ',
    name: 'ຊື່ກຸ່ມ',
    tablePrice: 'ລາຍການລາຄາ',
    priceHint: 'ລາຍການລາຄາຈະຖືກນຳໃຊ້ກັບໃບສັ່ງຂາຍໂດຍອັດຕະໂນມັດ ເມື່ອລູກຄ້າຢູ່ໃນກຸ່ມນີ້',
    editNotice: 'ຢູ່ໃນໂໝດແກ້ໄຂ - ກົດ "ບັນທຶກ" ຢູ່ເທິງເພື່ອສຳເລັດ',
    removeCustomer: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການລຶບລູກຄ້ານີ້ອອກຈາກກຸ່ມ?'
  },
  settings: {
    title: 'ການຕັ້ງຄ່າ',
    garena: 'ການຕັ້ງຄ່າທົ່ວໄປ',
    home: 'ການຕັ້ງຄ່າໜ້າຫຼັກ',
    order: 'ການຕັ້ງຄ່າຄຳສັ່ງຊື້',
    product: 'ການຕັ້ງຄ່າສິນຄ້າ',
    invoice: 'ການຕັ້ງຄ່າໃບເກັບເງິນ',
    debt: 'ການຕັ້ງຄ່າຍອດຄົງເຫຼືອ',
    point: 'ການຕັ້ງຄ່າຄະແນນ',
    salesGroup: 'ການຂາຍ ແລະ ໃບບິນ',
    systemGroup: 'ລະບົບ ແລະ ໜ້າຕາ',
    businessGroup: 'ລູກຄ້າ ແລະ ທຸລະກິດ',
    accountGroup: 'ບັນຊີ ແລະ ຄວາມປອດໄພ',
    displayAndTheme: 'ການສະແດງຜົນ ແລະ ຮູບແບບ',
    currencyAndTime: 'ສະກຸນເງິນ ແລະ ເວລາ',
    security: 'ຄວາມປອດໄພ',
    stockSettings: 'ຕັ້ງຄ່າສາງສິນຄ້າ',
    homeWidgets: 'ວິດເຈັດໜ້າຫຼັກ',
    pointSettings: 'ຕັ້ງຄ່າຄະແນນສະສົມ',
    resetPointTitle: 'ຣີເຊັດການຕັ້ງຄ່າ',
    systemPermissions: 'ສິດທິລະບົບ',
    invoiceSettings: 'ຕັ້ງຄ່າໃບບິນ',
    debtSettings: 'ໜີ້ສິນ',
    orderSettings: 'ຕັ້ງຄ່າອໍເດີ',
    descOrder: 'ສະຖານະ, ປັດເສດ, ຄ່າທຳນຽມເພີ່ມ, ບໍລິການຄິດໄລ່ຊົ່ວໂມງ',
    descProduct: 'ສິນຄ້າໃນສາງ, ຕົ້ນທຶນ, ຈຳນວນເລີ່ມຕົ້ນ',
    descInvoice: 'ແບບໃບບິນ, ລະຫັດ VietQR, ບັນຊີທະນາຄານ',
    descPrinter: 'ຂະໜາດເຈ້ຍ, ເຄື່ອງພິມ Bluetooth, Wifi, USB',
    descShift: 'ເປີດກະ, ປິດກະ, ສົ່ງມອບເງິນສົດ',
    descGeneral: 'ຮູບແບບ, ພາສາ, ຂະໜາດຕົວໜັງສື, ສະກຸນເງິນ, ລະຫັດ PIN',
    descHome: 'ສະແດງຍອດຂາຍ, ແຜນພູມ, ລາຍງານການເງິນ',
    descPermission: 'ກ້ອງຖ່າຍຮູບ, ຄັງຮູບພາບ, Bluetooth, ການແຈ້ງເຕືອນ',
    descPoint: 'ຄະແນນສະສົມສະມາຊິກ, ອັດຕາການແລກປ່ຽນ',
    descShop: 'ຈັດການສາຂາ, ພະນັກງານ, ເວັບໄຊຂາຍສິນຄ້າ',
    descEInvoice: 'ຕັ້ງຄ່າ ແລະ ອອກໃບເກັບເງິນເອເລັກໂຕຣນິກ',
    descPassword: 'ປ່ຽນລະຫັດຜ່ານບັນຊີ',
    descDeleteAcc: 'ລຶບບັນຊີ ແລະ ຂໍ້ມູນຮ້ານຢ່າງຖາວອນ',
    shopManager: 'ຜູ້ຈັດການຮ້ານ',
    staffRole: 'ພະນັກງານ',
    granted: 'ອະນຸຍາດແລ້ວ',
    grantPermission: 'ໃຫ້ສິດ',
    noVietQRConfig: 'ຍັງບໍ່ໄດ້ກຳນົດຄ່າບັນຊີ VietQR',
    uploadQRImage: 'ອັບໂຫຼດຮູບ QR ໂຄດ',
    s2aHkdGroup: 'ກຸ່ມອາຊີບ S2A-HKD',
    s2aHkdGroupDetail: 'ກຸ່ມອາຊີບເລີ່ມຕົ້ນເມື່ອສົ່ງອອກປຶ້ມບັນຊີ S2A-HKD',
    s2aHkdTaxRate: 'ອັດຕາພາສີມູນຄ່າເພີ່ມເລີ່ມຕົ້ນ S2A-HKD (%)',
    s2aHkdTaxRateDetail: 'ໃຊ້ເມື່ອສິນຄ້າ/ອໍເດີບໍ່ມີ VAT ຊັດເຈນ',
    s2aHkdTncnRate: 'ອັດຕາພາສີລາຍໄດ້ສ່ວນບຸກຄົນ S2A-HKD (%)',
    s2aHkdTncnRateDetail: 'ອັດຕາພາສີລາຍໄດ້ສ່ວນບຸກຄົນ (%) ເມື່ອສົ່ງອອກ S2A-HKD',
    manualEnterIPDetail: 'ປ້ອນ IP ເຄື່ອງພິມໂດຍກົງຫາກບໍ່ພົບ',
    previewPrint: 'ສະແດງຕົວຢ່າງການພິມ'
  },
  customerPoint: {
    pointShort: 'ຄະແນນ',
    description: 'ການຈັດການລາງວັນລູກຄ້າ',
    point: 'ຄະແນນສະສົມ',
    history: 'ປະຫວັດການສະສົມ',
    use: 'ເປີດໃຊ້ຟັງຊັນສະສົມຄະແນນ',
    mtpRate: 'ອັດຕາການແປງເປັນຄະແນນ',
    mtpRateDetail: 'ມູນຄ່າຄຳສັ່ງຊື້ %s%s = 1 ຄະແນນສະສົມ',
    ptmRate: 'ອັດຕາການແປງເປັນເງິນ',
    ptmRateDetail: '1 ຄະແນນ = %s%s',
    allowPayment: 'ອະນຸຍາດໃຫ້ຊຳລະດ້ວຍຄະແນນ',
    allowForSaleProduct: 'ສະສົມຄະແນນສຳລັບສິນຄ້າລົດລາຄາ',
    allowForOrderPayByPoint: 'ສະສົມຄະແນນໃຫ້ຄຳສັ່ງຊື້ທີ່ຊຳລະດ້ວຍຄະແນນ',
    change: 'ອັບເດດຄະແນນສະສົມ',
    invalidPoint: 'ຄະແນນບໍ່ຖືກຕ້ອງ',
    invalidNote: 'ກະລຸນາໃສ່ໝາຍເຫດ',
    usePoint: 'ໃຊ້ຄະແນນ',
    showPointOnInvoice: 'ສະແດງຄະແນນໃນໃບເກັບເງິນ',
    reset: 'ລຶບຄະແນນສະສົມທັງໝົດ',
    resetWarning: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການລຶບຄະແນນສະສົມປັດຈຸບັນທັງໝົດຂອງລູກຄ້າ?'
  },
  shift: {
    title: 'ປິດກະ',
    end: 'ປິດກະ',
    totalOrder: 'ໃບເກັບເງິນທັງໝົດ',
    totalMoney: 'ຍອດເງິນລວມໃນກະ',
    paid: 'ຍອດເງິນສົ່ງມອບທັງໝົດ',
    staff: 'ພະນັກງານ',
    cash: 'ເງິນສົດ',
    bank: 'ໂອນເງິນ',
    emptyOrder: 'ຍັງບໍ່ມີຄຳສັ່ງຊື້ເກີດຂຶ້ນໃນກະນີ້.',
    shiftOrder: 'ຄຳສັ່ງຊື້ໃນກະ',
    open: 'ເປີດກະ',
    closed: 'ກະເປີດ',
    opening: 'ກະເປີດ',
    openingAmount: 'ເງິນເລີ່ມຕົ້ນ',
    handoverType: 'ຮູບແບບການສົ່ງມອບ',
    openingAmountDetail: 'ຈຳນວນເງິນທີ່ມີຕອນເລີ່ມຕົ້ນກະ',
    actualHandoverAmount: 'ຍອດສົ່ງມອບຕົວຈິງ',
    differenceAmount: 'ສ່ວນຕ່າງ',
    totalExpectedHandoverAmount: 'ຍອດເງິນລວມທີ່ຕ້ອງມອບໂອນ',
    orderUnit: 'ອໍເດີ',
    currencyUnit: '₫',
    endReport: 'ລາຍງານປິດກະ',
    ended: 'ປິດກະແລ້ວ',
    shift: 'ກະຂາຍສິນຄ້າ',
    shiftClosedDesc: 'ກະຖືກປິດ ແລະ ສົ່ງມອບແລ້ວ',
    actualHandoverDesc: 'ຈໍານວນເງິນຕົວຈິງທີ່ພະນັກງານສົ່ງມອບ',
    updatingOnClose: 'ຈະອັບເດດເມື່ອປິດກະ',
    matchedDiffDesc: 'ຈໍານວນເງິນຖືກຕ້ອງສົມບູນ',
    checkDiffDesc: 'ຕ້ອງກວດສອບສາເຫດທີ່ແຕກຕ່າງກັນ',
    diffCalculatedOnClose: 'ຄິດໄລ່ຫຼັງຈາກສົ່ງມອບກະ',
    searchOrdersPlaceholder: 'ຄົ້ນຫາຕາມລະຫັດ, ລູກຄ້າ, ເບີໂທ...',
    handoverTypeDetail: 'ວິທີການຊຳລະເງິນທີ່ໄດ້ຮັບເມື່ອພະນັກງານປິດ ແລະ ມອບ-ຮັບກະ',
    requireOpening: 'ບັງຄັບເປີດກະ',
    requireOpeningDetail: 'ສາມາດສ້າງຄຳສັ່ງຂາຍໄດ້ເມື່ອກະເປີດເທົ່ານັ້ນ',
    settings: 'ຕັ້ງຄ່າກະ',
    settingsDetail: 'ຕັ້ງຄ່າການເປີດແລະສົ່ງມອບກະ',
    openError: 'ບໍ່ສາມາດເປີດກະ',
    expectedHandoverAmount: 'ຍອດທີ່ຕ້ອງສົ່ງມອບ',
    totalMoneyInShift: 'ຍອດເງິນລວມໃນກະ',
    needHandover: 'ຕ້ອງມອບໂອນ',
    endConfirm: 'ທ່ານຢືນຢັນປິດກະບໍ?'
  },
  warehouse: {
    title: 'ສາງ',
    renew: 'ຕໍ່ອາຍຸສາງ',
    choice: 'ເລືອກສາງ',
    intro: 'ຄັງສິນຄ້າແຕ່ລະແຫ່ງຈະມີດັດຊະນີສິນຄ້າຄົງຄັງ, ການຂາຍ, ການເງິນ... ທີ່ແຕກຕ່າງກັນ. ໄປທີ່ "ການຈັດການສິນຄ້າຄົງຄັງ" ເພື່ອສ້າງຄັງສິນຄ້າໃໝ່.',
    stat: 'ສະຖານະສິນຄ້າຄົງຄັງ',
    createNew: 'ສ້າງໃບບັນທຶກ',
    create: 'ສ້າງຄັງສິນຄ້າ',
    checkId: 'ລະຫັດກວດນັບສິນຄ້າ',
    name: 'ຊື່ຄັງສິນຄ້າ',
    check: 'ກວດນັບສິນຄ້າຄົງຄັງ',
    createCheck: 'ສ້າງການກວດນັບສິນຄ້າ',
    history: 'ປະຫວັດສິນຄ້າຄົງຄັງ',
    noHistory: 'ຍັງບໍ່ມີປະຫວັດສິນຄ້າຄົງຄັງ. ກະລຸນາສ້າງໃບບັນທຶກໃໝ່',
    noTransferHistory: 'ຍັງບໍ່ມີປະຫວັດການໂອນຍ້າຍ!',
    totalProduct: 'ສິນຄ້າທັງໝົດ',
    tmpCheck: 'ໃບບັນທຶກຊົ່ວຄາວ',
    cancelCheckConfirm: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການຍົກເລີກການກວດນັບນີ້?',
    cancelTransferConfirm: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການຍົກເລີກການໂອນຍ້າຍນີ້?',
    default: 'ຄັງສິນຄ້າຫຼັກ',
    address: 'ທີ່ຢູ່ຄັງສິນຄ້າ',
    manager: 'ການຈັດການຄັງສິນຄ້າ',
    detail: 'ຂໍ້ມູນສິນຄ້າຄົງຄັງ',
    transfer: 'ໂອນຍ້າຍຄັງສິນຄ້າ',
    transferCard: 'ລາຍລະອຽດການໂອນຍ້າຍ',
    checkCard: 'ລາຍລະອຽດການກວດນັບ',
    exportTransferCard: 'ໃບໂອນຍ້າຍຄັງສິນຄ້າ',
    exportCheckCard: 'ໃບກວດນັບສິນຄ້າ',
    emptyTargetWarehouse: 'ຄັງສິນຄ້າປາຍທາງບໍ່ຖືກຕ້ອງ. ກະລຸນາເລືອກຄັງສິນຄ້າປາຍທາງ!',
    limit: 'ໝາຍເຫດ: ແຕ່ລະບັນຊີຈະໄດ້ໃຊ້ຄັງສິນຄ້າທີ 2 ຟຣີ 1 ເດືອນ. ຫຼັງຈາກໝົດອາຍຸ ທ່ານຕ້ອງຕໍ່ອາຍຸເພື່ອໃຊ້ງານ',
    expired: 'ຄັງສິນຄ້ານີ້ໝົດອາຍຸແລ້ວ. ກະລຸນາຕໍ່ອາຍຸເພື່ອໃຊ້ງານ!',
    package1Y: 'ຕໍ່ອາຍຸ 1 ປີ',
    importFromExcelHint: 'ນຳເຂົ້າສິນຄ້າຈາກໄຟລ໌ Excel ໄດ້ຢ່າງວ່ອງໄວ.',
    importFromExcelEmptyChange: 'ບໍ່ພົບການປ່ຽນແປງ.',
    stopActive: 'ປິດການໃຊ້ງານ',
    stopActiveWarning: 'ເມື່ອທ່ານປິດການໃຊ້ງານຄັງສິນຄ້າ, ມັນຈະຖືກເຊື່ອງຈາກລາຍການໃຫ້ເລືອກ. ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການປິດການໃຊ້ງານຄັງສິນຄ້ານີ້?',
    emptyTransferHint: 'ແຕະ "ສະແກນບາໂຄດ" ຫຼື "ສິນຄ້າ" ເພື່ອເລີ່ມຍ້າຍສາງ',
    emptyCheckHint: 'ແຕະ "ສະແກນບາໂຄດ" ຫຼື "ສິນຄ້າ" ເພື່ອເລີ່ມກວດສາງ',
    noProduct: 'ຍັງບໍ່ໄດ້ເລືອກສິນຄ້າ'
  },
  homeScreen: {
    support: 'ທ່ານຕ້ອງການຄວາມຊ່ວຍເຫຼືອບໍ?',
    supportDetail: 'ກະລຸນາເລືອກຊ່ອງທາງຕິດຕໍ່ຝ່າຍຊ່ວຍເຫຼືອດ້ານລຸ່ມ ເພື່ອໃຫ້ເຮົາຊ່ວຍທ່ານໄດ້.',
    hotlineSupportDetail: 'ສາຍດ່ວນຮອງຮັບສະເພາະໃນເວລາເຮັດການ, ຕັ້ງແຕ່ 09:00 - 17:00.',
    changelog: 'ບັນທຶກການປ່ຽນແປງ',
    changelogDetail: 'ຕິດຕາມບັນທຶກການປ່ຽນແປງ ແລະຟີເຈີໃໝ່ຫຼ້າສຸດຂອງແອັບ.',
    autoUpdate: 'ອັບເດດແພັດ',
    autoUpdateDetail: 'ລະບົບຈະອັບເດດແພັດຫຼ້າສຸດເພື່ອແກ້ໄຂຂໍ້ຜິດພາດເລັກນ້ອຍບາງຢ່າງ ໂດຍບໍ່ຕ້ອງຕິດຕັ້ງເວີຊັນຫຼ້າສຸດຈາກ app store.',
    autoUpdateNoAvailable: 'ທ່ານກຳລັງໃຊ້ເວີຊັນຫຼ້າສຸດແລ້ວ!',
    autoUpdateFailed: 'ມີຂໍ້ຜິດພາດລະຫວ່າງການອັບເດດ. ກະລຸນາລອງໃໝ່ພາຍຫຼັງ!',
    vipExpired: 'ແພັກເກດພຣີມຽມຂອງທ່ານໝົດອາຍຸແລ້ວ. ກະລຸນາຕໍ່ອາຍຸເພື່ອໃຊ້ງານໄດ້ຄົບທຸກຟັງຊັນ!',
    timeZoneNew: 'ອັບເດດເຂດເວລາ',
    timeZoneConfirm: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການອັບເດດລາຍງານເປັນເຂດເວລາໃໝ່? ທ່ານສາມາດຕັ້ງຄືນໄດ້ໃນ "ການຕັ້ງຄ່າທົ່ວໄປ"',
    timeZoneNewDetail:
      'ອຸປະກອນຂອງທ່ານກຳລັງໃຊ້ເຂດເວລາ %s. ພວກເຮົາໄດ້ອັບເດດລາຍງານໃຫ້ສະທ້ອນເຂດເວລາປັດຈຸບັນຂອງທ່ານຢ່າງຖືກຕ້ອງ. ລາຍງານທີ່ເຄີຍສົ່ງອອກກ່ອນໜ້ານີ້ອາດມີການປ່ຽນແປງ. ເພື່ອເບິ່ງລາຍງານເກົ່າ, ກະລຸນາໄປທີ່ "ສະຖິຕິ (ເກົ່າ)"'
  },
  productSetting: {
    sort: 'ຈັດລຳດັບລາຍການ',
    sortDetail: 'ຈັດລຳດັບສິນຄ້າຕາມ',
    sortTypes: ['ໃໝ່ສຸດກ່ອນ', 'ຕາມຊື່ຕົວອັກສອນ', 'ເກົ່າສຸດກ່ອນ', 'ວັນໝົດອາຍຸ']
  },
  intro: {
    shift: 'ຟັງຊັນນີ້ເໝາະສຳລັບທຸລະກິດປະເພດບໍລິການ. ພະນັກງານໃຊ້ແອັບພະນັກງານເພື່ອປິດກະ. ຂໍ້ມູນການປິດກະຂອງພະນັກງານຈະສະແດງຢູ່ບ່ອນນີ້.',
    customerGroup:
      'ຟີເຈີນີ້ໃຊ້ເພື່ອແບ່ງກຸ່ມລູກຄ້າ. ຕົວຢ່າງ: ຕົວແທນລະດັບ 1, ຕົວແທນລະດັບ 2... ທ່ານສາມາດສ້າງລາຍການລາຄາສິນຄ້າໃຫ້ແຕ່ລະກຸ່ມລູກຄ້າໄດ້. ເມື່ອສ້າງອໍເດີ, ຖ້າລູກຄ້າຢູ່ໃນກຸ່ມທີ່ມີລາຍການລາຄາ, ລາຍການລາຄານັ້ນຈະຖືກນຳໃຊ້ອັດຕະໂນມັດ!',
    emptyProduct: 'ຍັງບໍ່ມີສິນຄ້າ. ກະລຸນາເພີ່ມສິນຄ້າເພື່ອດຳເນີນການຕໍ່!',
    draftOrder:
      'ຟັງຊັນນີ້ເໝາະເມື່ອທ່ານຕ້ອງການສ້າງອໍເດີຫຼາຍລາຍການພ້ອມກັນ. ແລະທ່ານສາມາດສ້າງອໍເດີຂາຍໄດ້ເຖິງແມ່ນບໍ່ມີການເຊື່ອມຕໍ່ເຄືອຂ່າຍ. ມີປະໂຫຍດຫຼາຍໃນກໍລະນີການເຊື່ອມຕໍ່ມີບັນຫາ ຫຼື ເຊີບເວີກຳລັງບຳລຸງຮັກສາ.'
  },
  printBarcode: {
    print: 'ພິມບາໂຄດ',
    list: 'ລາຍການບາໂຄດ',
    config: 'ຕັ້ງຄ່າການພິມບາໂຄດ',
    size: 'ຂະໜາດສະຕິກເກີ 1 ອັນ (ຍາວ x ກວ້າງ) (mm)',
    note: 'ໝາຍເຫດ',
    column: 'ຈຳນວນຖັນຂອງຂະໜາດພິມ',
    paddingH: 'ໄລຍະຫ່າງແນວນອນລະຫວ່າງສະຕິກເກີ 2 ອັນ (mm)',
    paddingV: 'ໄລຍະຫ່າງແນວຕັ້ງລະຫວ່າງສະຕິກເກີ 2 ອັນ (mm)',
    noteDetail: 'ໃນກໍລະນີທີ່ສະແກນບາໂຄດບໍ່ໄດ້ ຫຼື ບາໂຄດຂາດບາງສ່ວນ. ກະລຸນາໃຊ້ຂະໜາດເຈ້ຍໃຫຍ່ຂຶ້ນ ຫຼື ຫຍໍ້ບາໂຄດໃຫ້ສັ້ນລົງ',
    dpi: 'Dpi ຂອງເຄື່ອງພິມ',
    multiUpdateQuantity: 'ອັບເດດຈຳນວນເປັນຊຸດ',
    invalidQuantity: 'ຈຳນວນບໍ່ຖືກຕ້ອງ!',
    barcodeWidth: 'ຄວາມກວ້າງຂອງບາໂຄດ',
    autoPrintWhenInBill: 'ພິມປ້າຍອັດຕະໂນມັດ',
    autoPrintWhenInBillDetail: 'ພິມປ້າຍອັດຕະໂນມັດຫຼັງຈາກພິມບິນ',
    printerNotRealdy: 'ເຄື່ອງພິມປ້າຍຍັງບໍ່ພ້ອມ. ກະລຸນາໄປທີ່ການຕັ້ງຄ່າການພິມລະຫັດເພື່ອອັບເດດ!',
    contentToDisplay: 'ເນື້ອຫາທີ່ຈະສະແດງຢູ່ໃນສະຕິກເກີ',
    parameters: 'ພາລາມິເຕີ',
    lengthXWidth: 'ຍາວ × ກວ້າງ (mm)',
    sampleProduct: 'ສິນຄ້າຕົວຢ່າງ'
  },
  draftOrder: {
    title: 'ໃບແຈ້ງໜີ້ຮ່າງ',
    manager: 'ຈັດການໃບແຈ້ງໜີ້ຮ່າງ',
    cancel: 'ຍົກເລີກຮ່າງ',
    cancelConfirm: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການຍົກເລີກໃບແຈ້ງໜີ້ຮ່າງນີ້?',
    noConnectionWarning: 'ອຸປະກອນຂອງທ່ານບໍ່ໄດ້ເຊື່ອມຕໍ່ເຄືອຂ່າຍ. ໄປທີ່ "ຈັດການໃບແຈ້ງໜີ້ຮ່າງ" ດ້ານລຸ່ມເພື່ອສ້າງໃບແຈ້ງໜີ້ຮ່າງໂດຍບໍ່ຕ້ອງໃຊ້ອິນເຕີເນັດ.',
    emergencyModeWarning: 'You are in emergency mode. Orders are only saved temporarily on your device and have not been recorded to the server.',
    exportInvoice: 'ໃບແຈ້ງໜີ້ຊົ່ວຄາວ'
  },
  deleteAcc: {
    title: 'ລຶບບັນຊີ',
    warning: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການລຶບບັນຊີນີ້? ເມື່ອລຶບແລ້ວ ທ່ານຈະບໍ່ສາມາດກູ້ຄືນຂໍ້ມູນໄດ້. ທ່ານຈະຕ້ອງໃຊ້ລະຫັດຢືນຢັນທີ່ສົ່ງໄປອີເມວຂອງທ່ານ!',
    confirmCode: 'ລະຫັດຢືນຢັນ',
    confirmCodeShort: 'ລະຫັດຢືນຢັນສັ້ນເກີນໄປ'
  },
  debtNotify: {
    name: 'ແຈ້ງເກັບໜີ້',
    title: 'ໜີ້ທີ່ຕ້ອງເກັບຈາກ ',
    money: 'ຈຳນວນເງິນ: '
  },
  restartApp: {
    title: 'ເລີ່ມແອັບໃໝ່',
    detail: 'ທ່ານຕ້ອງການເລີ່ມແອັບພລິເຄຊັນໃໝ່ເພື່ອໃຫ້ການປ່ຽນແປງຖືກອັບເດດບໍ?'
  },
  appError: {
    eyebrow: 'ເກີດບັນຫາຂຶ້ນ',
    title: 'ຈຳເປັນຕ້ອງເລີ່ມແອັບໃໝ່',
    detail: 'ເກີດຂໍ້ຜິດພາດທີ່ບໍ່ຄາດຄິດ. ກະລຸນາເລີ່ມແອັບໃໝ່ເພື່ອດຳເນີນຕໍ່.',
    reload: 'ເລີ່ມແອັບໃໝ່'
  },
  shopSetting: {
    link: 'ລິ້ງເວັບໄຊ',
    publicSetting: 'ຕັ້ງຄ່າເວັບໄຊຂາຍສິນຄ້າ',
    publicSettingHint: 'ລູກຄ້າສາມາດສັ່ງຊື້ໂດຍກົງຜ່ານລິ້ງທີ່ຮ້ານສົ່ງໃຫ້ລູກຄ້າ. ທ່ານຕ້ອງເປີດໃຊ້ແພັກເກດ VIP+ ເພື່ອໃຊ້ຟັງຊັນນີ້.',
    userName: 'ລະຫັດລະບຸຮ້ານ',
    userNameHint: 'ຊື່ນີ້ຈະສະແດງຢູ່ໃນລິ້ງທີ່ສົ່ງໃຫ້ລູກຄ້າ. ຫ້າມມີຊ່ອງວ່າງ ຫຼື ອັກຂະລະພິເສດ (ອະນຸຍາດໃຫ້ໃຊ້ຂີດກາງ ແລະ ຂີດລຸ່ມ).',
    staffRefLink: 'ລິ້ງອ້າງອີງສຳລັບພະນັກງານ',
    staffRefLinkHint: 'ລິ້ງຮ້ານຂອງພະນັກງານ. ເມື່ອລູກຄ້າຄລິກລິ້ງນີ້, ຄຳສັ່ງຊື້ຈະຖືກນັບໃຫ້ພະນັກງານຄົນນັ້ນ',
    customerCanRegister: 'ອະນຸຍາດໃຫ້ລູກຄ້າລົງທະບຽນບັນຊີ',
    customerCanRegisterDetail: 'ລູກຄ້າສາມາດລົງທະບຽນບັນຊີເອງໄດ້. ຖ້າເປີດໃຊ້, ລາຄາສິນຄ້າຈະຖືກສະແດງແບບສາທາລະນະໃຫ້ລູກຄ້າທຸກຄົນ.',
    retailPurchase: 'ອະນຸຍາດໃຫ້ລູກຄ້າປີກຊື້ໄດ້',
    retailPurchaseDetail: 'ລູກຄ້າສາມາດສ້າງຄຳສັ່ງຊື້ໂດຍບໍ່ມີບັນຊີ',
    theme: 'ອິນເຕີເຟດ',
    themeDetail: 'ເລືອກອິນເຕີເຟດເວັບໄຊເພື່ອສະແດງໃຫ້ລູກຄ້າ',
    shopName: 'ຊື່ຮ້ານ',
    banner: 'ຮູບແບນເນີຮ້ານ',
    bannerDetail: 'ຂະໜາດທີ່ແນະນຳສຳລັບຮູບແບນເນີຮ້ານ 1024x512px',
    color: 'ສີ',
    colorDetail: 'ແກ້ໄຂສີຂອງອິນເຕີເຟດເວັບໄຊຂາຍສິນຄ້າ',
    colorTextNormal: 'ສີຕົວອັກສອນປົກກະຕິ',
    colorTextActive: 'ສີຕົວອັກສອນເນັ້ນ',
    colorBackground: 'ສີພື້ນຫຼັງ',
    showPricePublic: 'ສະແດງລາຄາ',
    showPricePublicDetail: 'ສະແດງລາຄາສາທາລະນະໃຫ້ຜູ້ເຂົ້າຊົມທຸກຄົນ',
    initWebsite: 'ສ້າງເວັບໄຊ',
    moreSettingOnWeb: 'ກະລຸນາໃຊ້ເວີຊັນເວັບເພື່ອຕັ້ງຄ່າເວັບໄຊຂາຍສິນຄ້າໃຫ້ຄົບຖ້ວນກວ່າ.',
    productList: 'ລາຍການສິນຄ້າ',
    productListDetail: 'ຕັ້ງລາຍການສິນຄ້າທີ່ສະແດງໃນເວັບໄຊຂາຍສິນຄ້າ. ໂດຍຄ່າເລີ່ມຕົ້ນ ຈະສະແດງສິນຄ້າທັງໝົດ',
    promotionList: 'ລາຍການໂປຣໂມຊັນ',
    promotionListDetail: 'ຕັ້ງລາຍການໂປຣໂມຊັນໃຫ້ສະແດງໃນເວັບໄຊຂາຍສິນຄ້າ. ຄ່າເລີ່ມຕົ້ນບໍ່ສະແດງ',
    domain: 'ຊື່ໂດເມນກຳນົດເອງ',
    domainDetail: 'ຕັ້ງຄ່າຊື່ໂດເມນກຳນົດເອງສຳລັບຮ້ານຂອງທ່ານ',
    domainDetailWidthIP: 'ເພື່ອຕັ້ງຄ່າຊື່ໂດເມນກຳນົດເອງສຳລັບຮ້ານຂອງທ່ານ.\nກະລຸນາປິດໃຊ້ Cloudflare ແລະ ຊີ້ IP ໂດເມນຂອງທ່ານໄປທີ່ %s',
    requirePlus: 'ກະລຸນາເປີດໃຊ້ແພັກເກດ PLUS ກ່ອນໃຊ້ຟັງຊັນນີ້!'
  },
  promotion: {
    edit: 'ແກ້ໄຂໂປຣໂມຊັນ',
    create: 'ສ້າງໂປຣໂມຊັນ',
    choice: 'ເລືອກໂປຣໂມຊັນ',
    title: 'ໂປຣໂມຊັນ',
    manage: 'ຈັດການໂປຣໂມຊັນ',
    detail: 'ລາຍລະອຽດໂປຣໂມຊັນ',
    name: 'ຊື່ໂປຣໂມຊັນ',
    code: 'ລະຫັດໂປຣໂມຊັນ',
    type: 'ປະເພດໂປຣໂມຊັນ',
    info: 'ຂໍ້ມູນໂປຣໂມຊັນ',
    order: 'ສ່ວນຫຼຸດຄຳສັ່ງຊື້',
    product: 'ສ່ວນຫຼຸດສິນຄ້າ',
    orderGift: 'ຂອງຂວັນສຳລັບຄຳສັ່ງຊື້',
    productGift: 'ຂອງຂວັນສິນຄ້າ',
    minMoney: 'ຍອດເງິນຂັ້ນຕ່ຳ',
    minQuantity: 'ຈຳນວນຂັ້ນຕ່ຳ',
    value: 'ມູນຄ່າໂປຣໂມຊັນ',
    price: 'ລາຄາໂປຣໂມຊັນ',
    discountPercent: 'ເປີເຊັນສ່ວນຫຼຸດ',
    time: 'ເວລາໂປຣໂມຊັນ',
    choiceGift: 'ເລືອກຂອງຂວັນ',
    gift: 'ຂອງຂວັນ',
    originalPrice: 'ລາຄາເດີມ',
    delete: 'ລຶບໂປຣໂມຊັນ',
    deleteConfirm: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການລຶບໂປຣໂມຊັນນີ້?',
    uniqueQuantity: 'ຈຳນວນຂັ້ນຕ່ຳຂອງ %s ຕ້ອງແຕກຕ່າງກັນ!'
  },
  invalidField: {
    name: 'ກະລຸນາປ້ອນຊ່ອງຊື່ໃຫ້ຖືກຕ້ອງ!',
    timeFrom: 'ກະລຸນາປ້ອນເວລາເລີ່ມຕົ້ນໃຫ້ຖືກຕ້ອງ!',
    timeTo: 'ກະລຸນາປ້ອນເວລາສິ້ນສຸດໃຫ້ຖືກຕ້ອງ!'
  },
  serviceSale: {
    branch: 'ສາຂາ',
    found: 'ບໍ່ພົບລາຍການທີ່ກົງກັນ',
    clickDownload: 'ຄລິກເພື່ອດາວໂຫຼດ',
    use: 'ໃຊ້',
    empty: 'ວ່າງ',
    table: 'ໂຕະ',
    emptyTable: 'ຍັງບໍ່ມີໂຕະຖືກໃຊ້',
    createBranchWarning: 'ທ່ານສາມາດເພີ່ມສາຂາໃໝ່ໄດ້ໃນແອັບຈັດການ aSeller',
    addProduct: 'ເພີ່ມລາຍການ',
    addProduct1: 'ເພີ່ມລາຍການ',
    scanBarcode: 'ສະແກນ Barcode',
    changeTable: 'ປ່ຽນໂຕະ',
    orderNotCreate: 'ຍັງບໍ່ໄດ້ສ້າງອໍເດີ ຫຼື ຍັງບໍ່ມີສິນຄ້າ',
    changeTableInput: 'ປ້ອນເລກໂຕະທີ່ຕ້ອງການປ່ຽນ',
    error: 'ຂໍ້ຜິດພາດ',
    finish: 'ສຳເລັດ',
    selected: 'ເລືອກແລ້ວ',
    choiceProduct: 'ເລືອກສິນຄ້າ',
    choiceProduct1: 'ເລືອກສິນຄ້າ',
    addNewProduct1: 'ເພີ່ມສິນຄ້າໃໝ່',
    addNewProduct: 'ເພີ່ມໃໝ່',
    selectTable: 'ເລືອກໂຕະເພື່ອດຳເນີນຕໍ່',
    tableManagement: 'ຈັດການໂຕະ'
  },
  payment: {
    payment: 'ຊຳລະເງິນ',
    cash: 'ເງິນສົດ',
    transfer: 'ໂອນເງິນ',
    totalMoney: 'ຍອດເງິນລວມ',
    addOrder: 'ເພີ່ມໃສ່ກະຕ່າ',
    order: 'ສ້າງອໍເດີ',
    number: 'ຈຳນວນ',
    total: 'ລວມ',
    part: 'ສ່ວນ',
    client: 'ລູກຄ້າ',
    customRetail: 'ຂາຍຍ່ອຍ',
    detailPayment: 'ລາຍລະອຽດການຊຳລະເງິນ',
    detailClient: 'ລາຍລະອຽດລູກຄ້າ',
    nameUser: 'ຊື່ລູກຄ້າ',
    newCustomer: 'ລູກຄ້າໃໝ່',
    phone: 'ເບີໂທລະສັບ',
    email: 'Email',
    address: 'ທີ່ຢູ່',
    free: 'ຟຣີ',
    note: 'ໝາຍເຫດ',
    updateOrder: 'ອັບເດດອໍເດີ',
    discount: 'ສ່ວນຫຼຸດ',
    surcharge: 'ຄ່າເພີ່ມ',
    goodsMoney: 'ຄ່າສິນຄ້າ:',
    totalAmount: 'ຍອດເງິນທີ່ຕ້ອງຮັບລວມ:',
    notePayment: 'ເມື່ອຢືນຢັນແລ້ວ ຈະບໍ່ສາມາດປ່ຽນໄດ້'
  },
  button: {
    yes: 'ແມ່ນ',
    no: 'ບໍ່',
    ok: 'ຕົກລົງ',
    cancel: 'ຍົກເລີກ',
    save: 'ບັນທຶກ',
    delete: 'ລຶບ',
    edit: 'ແກ້ໄຂ',
    edit2: 'ປ່ຽນຊື່',
    login: 'ເຂົ້າລະບົບ',
    logout: 'ອອກຈາກລະບົບ',
    success: 'ສຳເລັດ',
    finish: 'ແລ້ວສຳເລັດ',
    confirm: 'ຢືນຢັນ'
  },
  alert: {
    orderNotCreate: 'ຍັງບໍ່ໄດ້ສ້າງອໍເດີ ຫຼືບໍ່ມີສິນຄ້າ',
    enterFullData: 'ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນໃນຊ່ອງທີ່ມີເຄື່ອງໝາຍດາວ',
    error: 'ຂໍ້ຜິດພາດ',
    emptyBranch: 'ຍັງບໍ່ມີສາຂາ. ກະລຸນາຕິດຕໍ່ເຈົ້າຂອງຮ້ານເພື່ອສ້າງ',
    messager: 'ແຈ້ງເຕືອນ',
    openingDay: 'ທ່ານບໍ່ສາມາດແກ້ໄຂໄດ້ເມື່ອວັນທີ່ເລີ່ມນ້ອຍກວ່າວັນທີ່ປັດຈຸບັນ',
    delete: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການລຶບການແກ້ໄຂນີ້',
    emptyInput: 'ຊື່ຜູ້ໃຊ້ ຫຼືລະຫັດຜ່ານຫ້າມເປັນຄ່າວ່າງ',
    success: 'ສຳເລັດ',
    textEmpty: (value) => {
      return `${value} ບໍ່ສາມາດວ່າງໄດ້`;
    },
    department: 'ທ່ານຍັງບໍ່ໄດ້ເລືອກສະຖານທີ່',
    score: 'ຄະແນນຫ້າມຫຼາຍກວ່າຈຳນວນຄຳຖາມ',
    logout: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການອອກຈາກ App?',
    expiredLessThan7Day: 'ບັນຊີຂອງທ່ານໝົດອາຍຸແລ້ວ. ທ່ານມີເວລາ 7 ມື້ເພື່ອຕໍ່ອາຍຸ',
    expiredGreaterThan7Day: 'ບັນຊີຂອງທ່ານໝົດອາຍຸແລ້ວ. ກະລຸນາຕິດຕໍ່ຝ່າຍຈັດການເພື່ອຕໍ່ອາຍຸ',
    userNameHasSpace: 'ຊື່ຜູ້ໃຊ້ຫ້າມມີຊ່ອງວ່າງ',
    userNameIsShort: 'ຊື່ຜູ້ໃຊ້ຕ້ອງມີຫຼາຍກວ່າ 5 ຕົວອັກສອນ',
    passwordIsShort: 'ລະຫັດຜ່ານຕ້ອງມີຫຼາຍກວ່າ 5 ຕົວອັກສອນ',
    emailInvalid: 'ອີເມວບໍ່ຖືກຕ້ອງ',
    productCreateOrUpdateFaild: 'ບັນທຶກສິນຄ້າບໍ່ສຳເລັດ. ກະລຸນາລອງລຶບຮູບພາບອອກ ຫຼືເລືອກຮູບພາບອື່ນ. ຖ້າບັນຫາຍັງຢູ່ ກະລຸນາຕິດຕໍ່ທີມສະໜັບສະໜູນຂອງພວກເຮົາ!'
  },
  composition: {
    create: 'ເພີ່ມສ່ວນປະກອບ',
    title: 'ສ່ວນປະກອບ',
    name: 'ຊື່ສ່ວນປະກອບ',
    intro: 'ວັດຖຸດິບແມ່ນສ່ວນໜຶ່ງຂອງສິນຄ້າ. ສິນຄ້າແຕ່ລະລາຍການສາມາດມີວັດຖຸດິບໄດ້ຫຼາຍຢ່າງ. ທ່ານສາມາດເພີ່ມຂໍ້ມູນວັດຖຸດິບໄດ້ໃນສ່ວນແກ້ໄຂ ຫຼືເພີ່ມສິນຄ້າ',
    search: 'ຄົ້ນຫາສ່ວນປະກອບ'
  },
  bussinessType: {
    title: 'ປະເພດທຸລະກິດ',
    detail: 'ເລືອກປະເພດທຸລະກິດທີ່ເໝາະກັບທຸລະກິດຂອງທ່ານ',
    type_0: 'ຂາຍຍ່ອຍ',
    type_1: 'ຮ້ານຂາຍຂອງຊຳ, ຊູເປີມາເກັດ',
    type_2: 'ຄາເຟ, ຊານົມ',
    type_3: 'ແຟຊັນ',
    type_4: 'ເຄື່ອງສຳອາງ',
    type_5: 'ແມ່ ແລະ ເດັກ',
    type_6: 'ຮ້ານເບເກີຣີ',
    type_7: 'ຮ້ານອາຫານ',
    type_8: 'ຄາຣາໂອເກະ, ບິລລຽດ',
    type_9: 'ຮ້ານຂາຍຢາ',
    type_10: 'ຂອງຫຼິ້ນ'
  },
  hourlyService: {
    name: 'ຊື່ລາຍການບໍລິການຄິດຄ່າຕາມຊົ່ວໂມງ',
    nameHint: 'ຊື່ລາຍການບໍລິການຄິດຄ່າຕາມຊົ່ວໂມງຈະສະແດງເປັນລາຍການໃນໃບແຈ້ງໜີ້',
    defaultName: 'ເວລາການໃຊ້ງານ',
    title: 'ການຄິດເງິນຕາມຊົ່ວໂມງ',
    detail: 'ຈ່າຍຕາມຊົ່ວໂມງການໃຊ້ບໍລິການ. \nຮອງຮັບສະເພາະໃນໜ້າຂາຍຍ່ອຍ ແລະ ບໍລິການເທົ່ານັ້ນ',
    tablePrice: 'ຕາຕະລາງລາຄາຕາມຊົ່ວໂມງ',
    errorData: 'ຂໍ້ມູນບໍ່ຖືກຕ້ອງ. ກະລຸນາປ້ອນຢ່າງໜ້ອຍ 1 ລາຍການ!',
    stopTime: 'ຢຸດຈັບເວລາ',
    stopTimeWarning: 'ທ່ານຕ້ອງການຢຸດຈັບເວລາບໍລິການເພື່ອຊຳລະເງິນບໍ?'
  },
  extraTopping: {
    errorSeparateProductNonTopping: 'ບໍ່ສາມາດແຍກສິນຄ້າທີ່ບໍ່ມີທັອບປິ້ງໄດ້',
    list: 'ລາຍການທັອບປິ້ງ',
    isTopping: 'ເປັນລາຍການເພີ່ມເຕີມ',
    detail: 'ເປັນລາຍການທີ່ແນບກັບລາຍການອື່ນ (ເຊັ່ນ ໄຂ່ມຸກສຳລັບຊານົມ...). \nທ່ານຈະບໍ່ສາມາດເພີ່ມລາຍການນີ້ເຂົ້າໃນອໍເດີໂດຍກົງໄດ້.\nລາຍການທັອບປິ້ງເພີ່ມຈະບໍ່ສາມາດຕິດຕາມສະຕັອກໄດ້ເຊັ່ນກັນ',
    choice: 'ເລືອກທັອບປິ້ງ',
    name: 'ທັອບປິ້ງເພີ່ມ',
    canNotAddToOrder: 'ບໍ່ສາມາດເພີ່ມທັອບປິ້ງເຂົ້າໃນອໍເດີໂດຍກົງໄດ້.'
  },
  comboVoucher: {
    voucher: 'ລະຫັດບັດສ່ວນຫຼຸດ',
    activeVoucher: 'ເປີດໃຊ້ລະຫັດບັດສ່ວນຫຼຸດ',
    activeVoucherDetail: 'ມີລະຫັດບັດສ່ວນຫຼຸດແລ້ວບໍ? ເປີດໃຊ້ລະຫັດຂອງທ່ານທີ່ນີ້.',
    emptyKey: 'ກະລຸນາປ້ອນລະຫັດບັດສ່ວນຫຼຸດຂອງທ່ານ!',
    choiceData: 'ກະລຸນາເລືອກບໍລິການທີ່ທ່ານຕ້ອງການເປີດໃຊ້ດ້ານລຸ່ມ ແລ້ວກົດເປີດໃຊ້ເພື່ອສຳເລັດ.',
    invalidKey: 'ລະຫັດບັດສ່ວນຫຼຸດບໍ່ຖືກຕ້ອງ!',
    activeVoucherConfirm: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການເປີດໃຊ້ລະຫັດນີ້? ການດຳເນີນການນີ້ບໍ່ສາມາດຍ້ອນກັບໄດ້. ກະລຸນາກວດສອບອີກຄັ້ງກ່ອນກົດຕົກລົງ.',
    activeSuccess: 'ເປີດໃຊ້ລະຫັດສຳເລັດແລ້ວ. ກະລຸນາໂຫຼດໜ້າໃໝ່ເພື່ອໃຫ້ມີຜົນ.'
  },
  protection: {
    active: 'ເປີດໃຊ້ຄວາມປອດໄພ',
    detail: 'ລັອກແອັບອັດຕະໂນມັດດ້ວຍ PIN ຫຼັງຈາກບໍ່ມີການໃຊ້ງານ',
    enterPass: 'ຕ້ອງປ້ອນລະຫັດຜ່ານ',
    pin: 'PIN',
    pinRequire: 'PIN ຕ້ອງເປັນ 4 ຕົວເລກ',
    wrongPass: 'ລະຫັດຜ່ານຜິດ',
    forgotPin: 'ລືມ PIN',
    forgotPinDetail: 'ເພື່ອຣີເຊັດ PIN, ທ່ານຕ້ອງປ້ອນລະຫັດຜ່ານບັນຊີອີກຄັ້ງ. ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການເຮັດແບບນີ້?'
  },
  extraFee: {
    name: 'ຄ່າທຳນຽມເພີ່ມເຕີມ',
    detail: 'ຄ່າທຳນຽມເພີ່ມສຳລັບໃບສັ່ງຂາຍ. ຈຳນວນເງິນນີ້ຈະຖືກເພີ່ມໃສ່ໃບສັ່ງຊື້. ຖ້າເປີດໃຊ້ງານ ຈະສະແດງໃນໜ້າຂາຍ.',
    table: 'ຕາຕະລາງຄ່າທຳນຽມເພີ່ມ',
    fields: ['ຊື່', 'ຄ່າເລີ່ມຕົ້ນ', 'ຫົວໜ່ວຍ', 'ສະຖານະ', 'ການດຳເນີນການ']
  },
  introData: [
    {
      title: 'ຍິນດີຕ້ອນຮັບສູ່ aSeller POS!',
      detail: 'ໂຊລູຊັນຈັດການການຂາຍອັດສະລິຍະ ຊ່ວຍໃຫ້ທ່ານຄວບຄຸມທຸກຢ່າງໄດ້ທຸກເວລາ ທຸກສະຖານທີ່.'
    },
    {
      title: 'ຈັດການອໍເດີ, ສິນຄ້າ ແລະ ລູກຄ້າໄດ້ງ່າຍ',
      detail: 'ຕິດຕາມລາຍຮັບ, ລາຍຈ່າຍ, ໜີ້ສິນ, ສະຕັອກ ແລະ ພິມໃບແຈ້ງໜີ້ໄດ້ດ້ວຍການແຕະບໍ່ກີ່ຄັ້ງ..'
    },
    {
      title: 'ຂໍ້ມູນຂອງທ່ານຖືກເກັບໄວ້ໃນຄລາວຢ່າງປອດໄພ ແລະ ຊິງຄ໌ຂ້າມຫຼາຍອຸປະກອນໄດ້ງ່າຍ.',
      detail: '📶 ເຂົ້າໃຊ້ໄດ້ທຸກເວລາ ໂດຍບໍ່ຕ້ອງກັງວົນເລື່ອງຂໍ້ມູນສູນເສຍ ແມ່ນແຕ່ເມື່ອປ່ຽນອຸປະກອນ!'
    },
    {
      title: 'ການຈັດການການຂາຍບໍ່ເຄີຍງ່າຍແບບນີ້ມາກ່ອນ!',
      detail: 'ຕັ້ງຄ່າຮ້ານຂອງທ່ານ, ເພີ່ມສິນຄ້າ ແລະ ເລີ່ມຂາຍກັບ aSeller POS ມື້ນີ້.'
    }
  ],
  errorSupport: {
    title: 'ຂໍ້ຜິດພາດລະບົບ',
    detail: 'ຂໍ້ຜິດພາດລະບົບ. ກະລຸນາສົ່ງຂໍ້ຄວາມນີ້ໃຫ້ທີມ aSeller ເພື່ອຮັບການຊ່ວຍເຫຼືອໄດ້ໄວທີ່ສຸດ!\nລະຫັດຂໍ້ຜິດພາດ: %s',
    support: 'ຂໍຮັບການຊ່ວຍເຫຼືອ'
  },
  otherApps: [
    {
      title: 'aSeller ພະນັກງານຂາຍ',
      detail: 'ແອັບນີ້ສຳລັບພະນັກງານ. ທ່ານສາມາດສ້າງບັນຊີພະນັກງານໄດ້ໃນສ່ວນ "ລາຍຊື່ພະນັກງານ - ເພີ່ມ"'
    },
    {
      title: 'aSeller POS Offline',
      detail: 'ແອັບຈັດການການຂາຍຟຣີ ທີ່ບໍ່ຕ້ອງໃຊ້ອິນເຕີເນັດ. ບໍ່ມີຄ່າບຳລຸງຮັກສາລາຍເດືອນ. ຂໍ້ມູນຖືກເກັບໄວ້ໃນອຸປະກອນ. ບໍ່ສາມາດໃຊ້ໃນຫຼາຍອຸປະກອນໄດ້'
    },
    {
      title: 'aSeller FNB',
      detail: 'ແອັບຈັດການສະເພາະທາງ ທີ່ອອກແບບມາໂດຍສະເພາະສຳລັບຮ້ານອາຫານ, ຄາເຟ ແລະ ຮ້ານຊາໄຂ່ມຸກ. ຊ່ວຍໃຫ້ເຈົ້າຂອງຮ້ານຈັດສັນເວລາໄດ້ດີຂຶ້ນ ແລະ ປະຢັດຄ່າໃຊ້ຈ່າຍ.'
    }
  ],
  appPermission: {
    title: 'ການເຂົ້າໃຊ້ແອັບ',
    photo: {
      title: 'ການເຂົ້າເຖິງຮູບພາບ',
      detail: 'ແອັບຕ້ອງການເຂົ້າເຖິງຮູບພາບໃນອຸປະກອນ ເພື່ອອັບເດດຮູບໂປຣໄຟລ໌, ສິນຄ້າ, ລູກຄ້າ...'
    },
    camera: {
      title: 'ການເຂົ້າເຖິງກ້ອງ',
      detail: 'ແອັບຕ້ອງການເຂົ້າເຖິງກ້ອງໃນອຸປະກອນ ເພື່ອຖ່າຍຮູບສຳລັບຮູບໂປຣໄຟລ໌, ສິນຄ້າ, ລູກຄ້າ...'
    },
    bluetooth: {
      title: 'ການເຂົ້າໃຊ້ Bluetooth',
      detail: 'ແອັບຕ້ອງການການເຂົ້າໃຊ້ Bluetooth ເພື່ອເຊື່ອມຕໍ່ກັບເຄື່ອງພິມຜ່ານ Bluetooth.'
    },
    notification: {
      title: 'ການເຂົ້າໃຊ້ການແຈ້ງເຕືອນ',
      detail: 'ແອັບຕ້ອງການການເຂົ້າໃຊ້ການແຈ້ງເຕືອນ ເພື່ອອັບເດດຂໍ້ມູນລ່າສຸດກ່ຽວກັບບໍລິການທີ່ທ່ານໃຊ້.'
    }
  },
  orderTemplate: {
    title: 'ໃບແຈ້ງໜີ້ຕົວຢ່າງ',
    save: 'ບັນທຶກແມ່ແບບ',
    list: 'ໃບແຈ້ງໜີ້ຕົວຢ່າງ',
    saved: 'ບັນທຶກຕົວຢ່າງສຳເລັດ!',
    name: 'ຊື່ສຳລັບຈື່ຈຳ',
    nameWarning: 'ກະລຸນາໃສ່ຊື່ສຳລັບຈື່ຈຳທີ່ຍາວກວ່າ 3 ຕົວອັກສອນ',
    delete: 'ລຶບອໍເດີຕົວຢ່າງ',
    deleteConfirm: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການລຶບອໍເດີຕົວຢ່າງນີ້?',
    hint: 'ອໍເດີຕົວຢ່າງຊ່ວຍໃຫ້ທ່ານສ້າງອໍເດີທີ່ຄ້າຍກັນໄດ້ຢ່າງໄວ. ກົດຄ້າງເພື່ອລຶບຕົວຢ່າງ'
  },
  printSetting2: {
    manualEnterIP: 'ປ້ອນ IP ດ້ວຍຕົນເອງ',
    bill: 'ເຄື່ອງພິມໃບຮັບເງິນ',
    billDetail: 'ເຄື່ອງພິມຄວາມຮ້ອນໃຊ້ສຳລັບພິມໃບບິນຂາຍ. ຮອງຮັບໂປຣໂຕຄອນ ESC/POS',
    label: 'ເຄື່ອງພິມປ້າຍ (ສະຕິກເກີ)',
    labelDetail: 'ເຄື່ອງພິມຄວາມຮ້ອນໃຊ້ສຳລັບພິມສະຕິກເກີສິນຄ້າ. ຮອງຮັບໂປຣໂຕຄອນ ZPL, EPL, TSPL, DPL, CPCL...',
    scan: 'ສະແກນ',
    rescan: 'ຄົ້ນຫາອີກຄັ້ງ',
    connect: 'ເຊື່ອມຕໍ່',
    disconnect: 'ຍົກເລີກການເຊື່ອມຕໍ່',
    connected: 'ເຊື່ອມຕໍ່ແລ້ວ',
    scanning: 'ກຳລັງຄົ້ນຫາ',
    disconnectConfirm: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການຕັດການເຊື່ອມຕໍ່ຈາກເຄື່ອງພິມນີ້?',
    printerNotFound: 'ບໍ່ພົບເຄື່ອງພິມອື່ນ!',
    sunmiConnectError: 'ບໍ່ສາມາດເຊື່ອມຕໍ່ກັບເຄື່ອງພິມ Sunmi ໄດ້. ກະລຸນາກວດສອບອຸປະກອນຂອງທ່ານ!',
    usbConnectError: 'ບໍ່ສາມາດເຊື່ອມຕໍ່ກັບເຄື່ອງພິມ USB ໄດ້. ກະລຸນາກວດສອບອຸປະກອນຂອງທ່ານ!',
    sunmiDevice: 'ອຸປະກອນ Sunmi POS',
    labelPrinter: 'ເຄື່ອງພິມສະຕິກເກີ',
    billPrinter: 'ເຄື່ອງພິມບິນ',
    chooseConnectionAndDevice: 'ກະລຸນາເລືອກປະເພດການເຊື່ອມຕໍ່ ແລະ ອຸປະກອນດ້ານລຸ່ມ',
    chooseWifiOrUsbForLabel: 'ກະລຸນາເລືອກ Wifi ຫຼື USB ດ້ານລຸ່ມເພື່ອເຊື່ອມຕໍ່ເຄື່ອງພິມ',
    printProtocol: 'ໂປຣໂຕຄໍການພິມ:',
    blankLinesAfterBill: 'ຍະຫວ່າງຫຼັງຈາກພິມບິນແລ້ວ',
    threshold: 'ຄວາມເຂັ້ມ (Threshold)',
    thresholdDetail: 'ປັບຄວາມເຂັ້ມຂອງຕົວໜັງສື',
    testPrint: 'ທົດລອງພິມ (Test)',
    alignContent: 'ຈັດລຽງເນື້ອຫາ ຊ້າຍ/ຂວາ'
  },
  eInvoice: {
    intro: 'ຕັ້ງຄ່າການເຊື່ອມຕໍ່ກັບຜູ້ໃຫ້ບໍລິການໃບກຳກັບພາສີອິເລັກໂທຣນິກ ແລະກຳນົດຄ່າການອອກໃບກຳກັບພາສີອິເລັກໂທຣນິກ',
    title: 'ໃບກຳກັບພາສີອິເລັກໂທຣນິກ',
    setting: 'ການຕັ້ງຄ່າໃບກຳກັບພາສີອິເລັກໂທຣນິກ',
    provider: 'ຜູ້ໃຫ້ບໍລິການໃບກຳກັບພາສີອິເລັກໂທຣນິກ',
    addConnect: 'ເພີ່ມການເຊື່ອມຕໍ່',
    updateConnect: 'ແກ້ໄຂການເຊື່ອມຕໍ່',
    reconnect: 'ເຊື່ອມຕໍ່ໃໝ່',
    disconnect: 'ຍົກເລີກການເຊື່ອມຕໍ່',
    disconnectWarning:
      'ຫຼັງຈາກຕັດການເຊື່ອມຕໍ່ ທ່ານຈະບໍ່ສາມາດສ້າງ ແລະເຂົ້າເຖິງໃບກຳກັບພາສີອິເລັກໂທຣນິກຈາກຜູ້ໃຫ້ບໍລິການນີ້ໄດ້. ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການຕັດການເຊື່ອມຕໍ່ຈາກຜູ້ໃຫ້ບໍລິການນີ້?',
    account: 'ບັນຊີ',
    userName: 'ຊື່ເຂົ້າລະບົບໃບກຳກັບພາສີອິເລັກໂທຣນິກ',
    password: 'ລະຫັດຜ່ານ',
    passwordDetail: 'ລະຫັດຜ່ານເຂົ້າລະບົບໃບກຳກັບພາສີອິເລັກໂທຣນິກ',
    linkApi: 'ລິ້ງເຊີບເວີ API',
    confirm: 'ໂດຍກົດບັນທຶກ ທ່ານໄດ້ຕົກລົງອະນຸຍາດໃຫ້ລະບົບຈັດການການຂາຍ aSeller ຊ່ວຍສົ່ງ/ຮັບໃບບິນຈາກ aSeller ໄປຫາຜູ້ໃຫ້ບໍລິການໃບກຳກັບພາສີອິເລັກໂທຣນິກທີ່ທ່ານໄດ້ເລືອກ.',
    taxCode: 'ເລກປະຈຳຕົວຜູ້ເສຍພາສີ',
    taxCodeDetail: 'ເລກປະຈຳຕົວຜູ້ເສຍພາສີຂອງວິສາຫະກິດ ຫຼືຄົວເຮືອນທຸລະກິດ',
    settingForEInvoice: 'ຕັ້ງຄ່າການອອກໃບກຳກັບພາສີອິເລັກໂທຣນິກ (e-invoice)',
    allowPublish: 'ອະນຸຍາດໃຫ້ອອກໃບກຳກັບພາສີອິເລັກໂທຣນິກ',
    autoPublish: 'ອອກໃບກຳກັບພາສີອິເລັກໂທຣນິກອັດຕະໂນມັດ',
    invoiceType: 'ປະເພດໃບກຳກັບພາສີ',
    invoiceTypeData: ['ໃບກຳກັບພາສີມູນຄ່າເພີ່ມ', 'ໃບແຈ້ງໜີ້ຈາກເຄື່ອງຄິດເງິນ'],
    invoiceTemSeri: 'ແບບໃບແຈ້ງໜີ້ ແລະ ສັນຍາລັກ',
    info: 'ປະເພດໃບແຈ້ງໜີ້ທີ່ອອກ',
    export: 'ການອອກໃບແຈ້ງໜີ້ອິເລັກໂທຣນິກ',
    infoDefaultHint: 'ປະເພດໃບແຈ້ງໜີ້ເລີ່ມຕົ້ນທີ່ອອກເມື່ອສ້າງຄຳສັ່ງຊື້',
    deleteInfoConfirm: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການລຶບເລກແບບໃບແຈ້ງໜີ້ນີ້?',
    addInfo: 'ເພີ່ມປະເພດໃບແຈ້ງໜີ້',
    updateInfo: 'ແກ້ໄຂໃບແຈ້ງໜີ້',
    infoName: 'ຊື່ໃບແຈ້ງໜີ້',
    infoNameIsShort: 'ຊື່ໃບແຈ້ງໜີ້ສັ້ນເກີນໄປ',
    templateInvalid: 'ແບບໃບແຈ້ງໜີ້ ແລະ ສັນຍາລັກບໍ່ຖືກຕ້ອງ',
    sellerInfo: 'ຂໍ້ມູນຜູ້ຂາຍໃນໃບແຈ້ງໜີ້ອິເລັກໂທຣນິກ',
    sellerInfoIntro: 'ຖ້າປ່ອຍໃຫ້ວ່າງ ລະບົບຈະໃຊ້ຂໍ້ມູນຮ້ານຄ້າໃນ aSeller',
    sellerName: 'ຊື່ຜູ້ຂາຍ',
    sellerAddress: 'ທີ່ຢູ່ຜູ້ຂາຍ',
    sellerEmail: 'ອີເມວຜູ້ຂາຍ',
    sellerPhone: 'ເບີໂທຜູ້ຂາຍ',
    sellerBankName: 'ຊື່ທະນາຄານ',
    sellerBankAccount: 'ເລກບັນຊີທະນາຄານ',
    invalidField: 'ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ ແລະ ຖືກຕ້ອງ',
    unauthorized: 'ຂໍ້ມູນການເຊື່ອມຕໍ່ບໍ່ຖືກຕ້ອງ. ກະລຸນາກວດບັນຊີ ແລະ ລະຫັດຜ່ານຂອງທ່ານ!',
    active: 'ເປີດໃຊ້ການອອກໃບແຈ້ງໜີ້ອິເລັກໂທຣນິກ',
    auto: 'ອອກໃບແຈ້ງໜີ້ອິເລັກໂທຣນິກອັດຕະໂນມັດ',
    autoHint: 'ທຸກຄັ້ງທີ່ບັນທຶກຄຳສັ່ງຂາຍ ລະບົບຈະສົ່ງໄປຍັງລະບົບຂອງຜູ້ໃຫ້ບໍລິການໃບແຈ້ງໜີ້ອິເລັກໂທຣນິກທີ່ເຊື່ອມຕໍ່ໄວ້ອັດຕະໂນມັດ',
    showOnBill: 'ສະແດງຂໍ້ມູນຄົ້ນຫາໃບແຈ້ງໜີ້ອິເລັກໂທຣນິກໃນໃບບິນຂາຍ',
    activeForOrderNotPay: 'ເປີດໃຊ້ການອອກໃບແຈ້ງໜີ້ອິເລັກໂທຣນິກສຳລັບທຸກຄຳສັ່ງຊື້',
    activeForOrderNotPayHint: 'ເມື່ອປິດໃຊ້ ຈະອອກໃບແຈ້ງໜີ້ອິເລັກໂທຣນິກສະເພາະຄຳສັ່ງຊື້ທີ່ຊຳລະແລ້ວເທົ່ານັ້ນ',
    invoiceNo: 'ເລກໃບແຈ້ງໜີ້',
    transactionID: 'ລະຫັດທຸລະກຳ',
    codeOfTax: 'ລະຫັດ CQT',
    reservationCode: 'ລະຫັດຄົ້ນຫາ',
    download: 'ດາວໂຫຼດໄຟລ໌',
    checkLink: 'ຄົ້ນຫາໃບແຈ້ງໜີ້ອິເລັກໂທຣນິກທີ່',
    create: 'ອອກໃບແຈ້ງໜີ້ອິເລັກໂທຣນິກ',
    createWarning: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການອອກໃບແຈ້ງໜີ້ສຳລັບຄຳສັ່ງຊື້ນີ້?',
    createAllWarning: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການອອກໃບແຈ້ງໜີ້ສຳລັບ %s ຄຳສັ່ງຊື້ທີ່ເລືອກ?',
    tryAgain: 'ອອກໃໝ່',
    creating: 'ກຳລັງອອກໃບແຈ້ງໜີ້',
    createError: 'ການອອກຜິດພາດ',
    reconciliation: 'ກວດທຽບໃບແຈ້ງໜີ້',
    createSuccess: 'ອອກໃບແຈ້ງໜີ້ສຳເລັດ',
    search: 'ປ້ອນເລກໃບແຈ້ງໜີ້, ລະຫັດ CQT, ລະຫັດຄົ້ນຫາ',
    providerHint:
      'ທ່ານຕ້ອງລົງທະບຽນໃຊ້ບໍລິການຈາກຜູ້ໃຫ້ບໍລິການໃບແຈ້ງໜີ້ອິເລັກໂທຣນິກ ແລະໄດ້ຮັບບັນຊີ ເພື່ອສາມາດອອກໃບແຈ້ງໜີ້ອິເລັກໂທຣນິກໄດ້. ຖ້າທ່ານບໍ່ມີບັນຊີ, ກະລຸນາຕິດຕໍ່ຝ່າຍຊ່ວຍເຫຼືອເພື່ອຂໍຄຳແນະນຳໃນການລົງທະບຽນໃຊ້ບໍລິການ.',
    emptyEInfoWarning: 'ກະລຸນາເພີ່ມປະເພດໃບແຈ້ງໜີ້ກ່ອນ',
    emptyEConnectWarning: 'ກະລຸນາເພີ່ມການເຊື່ອມຕໍ່ຜູ້ສະໜອງກ່ອນ',
    notSupportEditWarning: 'ໝາຍເຫດ: aSeller ບໍ່ຮອງຮັບການແກ້ໄຂໃບແຈ້ງໜີ້ອິເລັກໂທຣນິກຫຼັງຈາກອອກແລ້ວ. ເພື່ອແກ້ໄຂຄຳສັ່ງຊື້, ກະລຸນາແກ້ໄຂໃນລະບົບຂອງຜູ້ໃຫ້ບໍລິການໃບແຈ້ງໜີ້ອິເລັກໂທຣນິກ.',
    autoSign: 'ເຊັນດິຈິຕອນ ແລະສົ່ງໄປຫາໜ່ວຍງານພາສີໂດຍອັດຕະໂນມັດ',
    autoSignDetail:
      'ໃບແຈ້ງໜີ້ອິເລັກໂທຣນິກທີ່ສ້າງຂຶ້ນຈະຖືກເຊັນດິຈິຕອນ ແລະສົ່ງໄປຫາໜ່ວຍງານພາສີໂດຍອັດຕະໂນມັດ. ຖ້າປິດຟັງຊັນນີ້, ຮ້ານຄ້າຕ້ອງເຊັນໃບແຈ້ງໜີ້ດ້ວຍຕົນເອງກ່ອນຈຶ່ງຈະສົ່ງໄປຫາໜ່ວຍງານພາສີໄດ້',
    notSign: 'ຍັງບໍ່ໄດ້ເຊັນ',
    manualSign: 'ເຊັນໃບແຈ້ງໜີ້',
    manualSignWarning: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການເຊັນໃບແຈ້ງໜີ້ນີ້? ຫຼັງຈາກເຊັນແລ້ວ, ໃບແຈ້ງໜີ້ຈະຖືກສົ່ງໄປຫາອົງການພາສີ. aSeller ບໍ່ຮອງຮັບການແກ້ໄຂໃບແຈ້ງໜີ້ອິເລັກໂທຣນິກທີ່ອອກແລ້ວ'
  },
  servicesSetting: {
    slot: 'ຄວາມຈຸ',
    prefix: 'ຊື່ຄຳນຳໜ້າ',
    prefixDefault: 'ໂຕະ',
    prefixEx: 'ຕົວຢ່າງ: ໂຕະ, ຫ້ອງ...',
    title: 'ຕັ້ງຄ່າໜ້າຈໍບໍລິການ',
    area: 'ພື້ນທີ່',
    areaName: 'ຊື່ພື້ນທີ່',
    editArea: 'ແກ້ໄຂພື້ນທີ່',
    addArea: 'ເພີ່ມພື້ນທີ່',
    list: 'ລາຍການບໍລິການ',
    editName: 'ແກ້ໄຂຊື່ບໍລິການ',
    addAreaHint: 'ສາມາດເພີ່ມພື້ນທີ່ຂາຍໃໝ່ໄດ້ໃນ ຕັ້ງຄ່າ - ຕັ້ງຄ່າຮ້ານ',
    stopAreaActive: 'ປິດໃຊ້ງານພື້ນທີ່',
    stopAreaActiveWarning: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການປິດໃຊ້ງານພື້ນທີ່ນີ້?',
    notFoundArea: 'ຍັງບໍ່ມີພື້ນທີ່. ກະລຸນາສ້າງພື້ນທີ່ໃໝ່ໃນການຕັ້ງຄ່າຮ້ານຂອງທ່ານ.'
  },
  billSetting: {
    qrMoney: 'ຈຳນວນເງິນໃນ QR code',
    qrMoneyDetail: 'ຈຳນວນເງິນທາງເລືອກທີ່ຈະສະແດງໃນ QR code. ອາດເປັນໜີ້ລວມຂອງລູກຄ້າ ຫຼືຈຳນວນເງິນຄຳສັ່ງຊື້',
    qrMoneyType: ['ໜີ້ລວມຂອງລູກຄ້າ', 'ຈຳນວນເງິນຄຳສັ່ງຊື້']
  },
  stats: {
    contributionByStaff: 'ສັດສ່ວນຜົນງານຕາມພະນັກງານ',
    summaryByStaff: 'ສະຫຼຸບຕາມພະນັກງານ',
    saleByStaff: 'ຍອດຂາຍຕາມພະນັກງານ',
    revenue: 'ລາຍຮັບ',
    overview: 'ຜົນການດຳເນີນທຸລະກິດ',
    productReport: 'ລາຍງານສິນຄ້າ',
    orderCount: 'ຈຳນວນຄຳສັ່ງຊື້ທັງໝົດ',
    cashflow: 'ກະແສເງິນສົດ',
    cashInflow: 'ເງິນສົດເຂົ້າ',
    cashOutflow: 'ເງິນສົດອອກ',
    remainingCash: 'ກະແສເງິນສົດທີ່ຍັງເຫຼືອ',
    netCash: 'ກະແສເງິນສົດສຸດທິ',
    return: 'ຄືນເງິນ',
    customerAndSuppliers: 'ລູກຄ້າ ແລະ ຜູ້ສະໜອງ',
    salesChart: 'ແຜນພູມລາຍຮັບ',
    cashflowInThisMonth: 'ກະແສເງິນສົດເດືອນນີ້',
    cashflowIn30Days: 'ກະແສເງິນສົດ 30 ມື້ຜ່ານມາ',
    openBalance: 'ຍອດເງິນຕົ້ນງວດ',
    openBalanceDetail:
      'ຍອດເງິນຕົ້ນງວດແມ່ນຍອດເງິນລວມ (ເງິນເຂົ້າ - ເງິນອອກ) ຕັ້ງແຕ່ເລີ່ມດຳເນີນການຈົນຮອດຕົ້ນງວດ.\nຕົວຢ່າງ: ຖ້າເວລາທີ່ທ່ານເລືອກແມ່ນເດືອນນີ້, ຍອດເງິນຕົ້ນງວດແມ່ນຍອດເງິນກ່ອນວັນທີ 1 ຂອງເດືອນ',
    orderFee: 'ຄ່າທຳນຽມຄຳສັ່ງຊື້',
    orderFeeChart: 'ແຜນພູມຄ່າທຳນຽມຄຳສັ່ງຊື້',
    orderFeeDetails: 'ລາຍລະອຽດຄ່າທຳນຽມຕາມວັນທີ',
    totalVat: 'VAT',
    totalSurcharge: 'ຄ່າເພີ່ມ',
    totalSurchargeByCustomer: 'ຄ່າເພີ່ມຕາມລູກຄ້າ',
    totalSurchargeByShop: 'ຄ່າເພີ່ມຕາມຮ້ານ'
  },
  saleCounter: {
    weekChart: 'ແຜນພູມລາຍອາທິດ',
    invoice: 'ໃບແຈ້ງໜີ້',
    paymentSuccess: 'ຊຳລະເງິນສຳເລັດ!',
    error: 'ຂໍ້ຜິດພາດ',
    selectVariant: 'ກະລຸນາເລືອກຮຸ່ນສິນຄ້າ'
  },
  screenText: {
    staffLogin: {
      subtitle: 'ຍິນດີຕ້ອນຮັບກັບມາ, ພະນັກງານ!',
      backToOwnerLogin: 'ກັບໄປຫາການເຂົ້າລະບົບຂອງເຈົ້າຂອງທຸລະກິດ'
    },
    activeVoucher: {
      selectStaff: 'ເລືອກພະນັກງານ',
      selectWarehouse: 'ເລືອກສາງສິນຄ້າ',
      requireStaff: 'ກະລຸນາເລືອກພະນັກງານເພື່ອອັບເດດແພັກເກດ!',
      requireWarehouse: 'ກະລຸນາເລືອກສາງສິນຄ້າເພີ່ມເພື່ອອັບເດດແພັກເກດ!'
    },
    setting: {
      generalSubtitle: 'ຈັດການພາສາແລະສະກຸນເງິນຫຼັກ.',
      currencyDescription: 'ສັນຍາລັກສະກຸນເງິນທີ່ສະແດງໃນລາຍງານ.',
      prefixSubtitle: 'ກຳນົດຄຳນຳໜ້າລະຫັດສຳລັບຄຳສັ່ງຊື້ແລະໃບສຳຄັນ.',
      homeSubtitle: 'ປັບແຕ່ງຂໍ້ມູນທີ່ສະແດງໃນໜ້າຫຼັກ Dashboard.',
      aboutSubtitle: 'ລາຍລະອຽດເວີຊັນແລະການຊ່ວຍເຫຼືອດ້ານເຕັກນິກ.',
      aboutAppName: 'aSeller Sales Management',
      aboutAppDesc: 'ໂຊລູຊັນການຂາຍແບບມືອາຊີບສຳລັບທຸລະກິດຂະໜາດນ້ອຍ.'
    },
    shopSetting: {
      noWebsite: 'ລະບົບຍັງບໍ່ໄດ້ສ້າງ Website ໃຫ້ຮ້ານຂອງທ່ານເທື່ອ.',
      vipExpired: 'ບັນຊີ Pro ໝົດອາຍຸແລ້ວ',
      vipDuration: 'ໄລຍະເວລາແພັກເກດ VIP+',
      themeSampleTitle: 'ແມ່ແບບຮູບແບບໜ້າຕາ',
      themeSample1: 'ແມ່ແບບ 1',
      themeSample2: 'ແມ່ແບບ 2',
      advancedSubtitle: 'ຈັດການຟີເຈີການສະແດງຜົນຂັ້ນສູງຂອງ Website.'
    },
    eInvoiceSetting: {
      tabConnect: 'ການເຊື່ອມຕໍ່',
      tabSettings: 'ການຕັ້ງຄ່າ',
      connectTitle: 'ການເຊື່ອມຕໍ່ໃບແຈ້ງໜີ້ອິເລັກໂຕຣນິກ',
      settingsTitle: 'ການຕັ້ງຄ່າລະບົບ',
      settingsSubtitle: 'ຕັ້ງຄ່າການອອກໃບແຈ້ງໜີ້ອັດຕະໂນມັດ ແລະ ຂໍ້ມູນການສະແດງຜົນ.'
    },
    invoiceSetting: {
      bankTab: 'ບັນຊີທະນາຄານ',
      invoiceSubtitle: 'ຕັ້ງຄ່າຂໍ້ມູນການສະແດງຜົນ ແລະ ຕົວເລືອກສຳລັບໃບແຈ້ງໜີ້ການຂາຍ.',
      bankInfoTitle: 'ຂໍ້ມູນທະນາຄານ',
      bankInfoSubtitle: 'ຕັ້ງຄ່າລະຫັດ QR ແລະ ຂໍ້ມູນບັນຊີສຳລັບການຊຳລະເງິນໂອນຜ່ານທະນາຄານ.',
      bankQrTitle: 'ລະຫັດ QR ທະນາຄານ',
      noBankQr: 'ຍັງບໍ່ມີລະຫັດ QR',
      vietQrBankTitle: 'ບັນຊີທະນາຄານ VietQR'
    },
    orderSetting: {
      orderSubtitle: 'ຕັ້ງຄ່າຂັ້ນຕອນການຈັດການຄຳສັ່ງຊື້ ແລະ ການສະແດງຂໍ້ມູນການຂາຍ.',
      debtSubtitle: 'ຈັດການໜີ້ລູກຄ້າ ແລະ ບັນທຶກໜີ້ໃນໃບແຈ້ງໜີ້.',
      hourlySubtitle: 'ຕັ້ງຄ່າການຄິດເງິນບໍລິການຕາມເວລາ (ເຊັ່ນ ບິນລຽດ, ຊົ່ວໂມງຄາຣາໂອເກະ...).',
      extraTitle: 'ສາທາລະນູປະໂພກ ແລະ ຄ່າບວກເພີ່ມ',
      extraSubtitle: 'ຕັ້ງຄ່າບໍລິການເພີ່ມເຕີມ ແລະ ຄ່າບວກເພີ່ມອັດຕະໂນມັດສຳລັບຄຳສັ່ງຊື້.'
    },
    pointSetting: {
      subtitle: 'ຕັ້ງຄ່າລະບົບຄະແນນສະສົມ ແລະ ການແລກຄະແນນສຳລັບລູກຄ້າ.'
    },
    detail: {
      basicInfo: 'ຂໍ້ມູນພື້ນຖານ',
      attributesAndManagement: 'ຄຸນລັກສະນະ ແລະ ການຈັດການ',
      attributesAndTax: 'ຄຸນລັກສະນະ ແລະ ພາສີ',
      groupInfo: 'ຂໍ້ມູນກຸ່ມ'
    },
    detailCustomer: {
      changePasswordDetail: 'ປ່ຽນລະຫັດຜ່ານເຂົ້າລະບົບສຳລັບບັນຊີລູກຄ້ານີ້',
      passwordMinLength: 'ລະຫັດຜ່ານຕ້ອງຍາວກວ່າ 4 ຕົວອັກສອນ!'
    },
    customer: {
      taxCodeNotFound: 'ບໍ່ພົບຂໍ້ມູນເລກປະຈຳຕົວຜູ້ເສຍພາສີ'
    },
    receipt: {
      reason: 'ເຫດຜົນ',
      treasurer: 'ເຫຼົ່າພະນັກງານການເງິນ',
      payer: 'ຜູ້ຈ່າຍເງິນ',
      creator: 'ຜູ້ສ້າງໃບສຳຄັນ',
      signNameHint: '(ເຊັນຊື່, ຊື່ເຕັມ)'
    },
    dashboard: {
      top1BestSeller: '#1 ສິນຄ້າຂາຍດີທີ່ສຸດ',
      noData: 'ບໍ່ມີຂໍ້ມູນ',
      noDataHint: 'ເພີ່ມສິນຄ້າເພື່ອສະແດງສະຖິຕິນີ້'
    },
    uploader: {
      chooseImageFile: 'ເລືອກໄຟລ໌ຮູບພາບ',
      chooseExcelFile: 'ເລືອກໄຟລ໌ Excel'
    }
  },
  shipping: {
    title: 'ການຈັດສົ່ງ',
    subtitle: 'ຕັ້ງຄ່າຜູ້ໃຫ້ບໍລິການຈັດສົ່ງ ແລະ ວິທີການສົ່ງມອບ',
    info: 'ຂໍ້ມູນການຈັດສົ່ງ',
    infoDetail: 'ແຍກອອກຈາກສະຖານະຄຳສັ່ງຊື້ປັດຈຸບັນຢ່າງສິ້ນເຊີງ.',
    infoSub: 'ຈັດການສະຖານະການຈັດສົ່ງ, ການຕິດຕາມ ແລະ ຂໍ້ມູນການສົ່ງມອບ.',
    noActive: 'ບໍ່ມີປ້າຍຈັດສົ່ງທີ່ໃຊ້ງານຢູ່',
    noActiveDetail: 'ເລີ່ມການຈັດສົ່ງຫຼັງຈາກຄຳສັ່ງຊື້ມີທີ່ຢູ່ຈັດສົ່ງ ແລະ ຜູ້ຮັບ.',
    create: 'ສ້າງການຈັດສົ່ງ',
    bulkCreate: 'ສ້າງການຈັດສົ່ງເປັນຊຸດ',
    bulkCreateConfirm: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການສ້າງປ້າຍຈັດສົ່ງສຳລັບ %s ຄຳສັ່ງຊື້ດ້ວຍ %s?',
    bulkCreateSuccess: 'ສ້າງປ້າຍຈັດສົ່ງສຳເລັດສຳລັບ %s ຄຳສັ່ງຊື້.',
    bulkCreatePartial: 'ສ້າງປ້າຍຈັດສົ່ງແລ້ວສຳລັບ %s ຄຳສັ່ງຊື້, ລົ້ມເຫຼວ %s ຄຳສັ່ງຊື້.',
    bulkCreateFailed: 'ສ້າງການຈັດສົ່ງເປັນຊຸດລົ້ມເຫຼວ.',
    createHint: 'ທ່ານສາມາດສ້າງການຈັດສົ່ງແບບປ້ອນເອງ ຫຼື ເອີ້ນ API ຂອງຜູ້ໃຫ້ບໍລິການເມື່ອຕັ້ງຄ່າຜູ້ໃຫ້ບໍລິການແລ້ວ.',
    createMode: 'ໂໝດການສ້າງ',
    createModeHintManual: 'ສ້າງການຈັດສົ່ງພາຍໃນ ແລະ ໃຫ້ປ້ອນລະຫັດຕິດຕາມເອງ.',
    createModeHintProvider: 'ເອີ້ນ API ຂອງຜູ້ໃຫ້ບໍລິການເພື່ອສ້າງການຈັດສົ່ງ ແລະ ຮັບລະຫັດຕິດຕາມອັດຕະໂນມັດ.',
    providerModeUnavailable: 'ຜູ້ໃຫ້ບໍລິການນີ້ຍັງບໍ່ໄດ້ຕັ້ງຄ່າສຳລັບການສ້າງການຈັດສົ່ງຜ່ານ API, ຈະໃຊ້ໂໝດປ້ອນເອງ.',
    providerCodeAutoGenerated: 'ລະຫັດຕິດຕາມຈະຖືກສົ່ງກັບຈາກຜູ້ໃຫ້ບໍລິການຫຼັງຈາກເອີ້ນ API ສຳເລັດ.',
    providerCreateFailed: 'ບໍ່ສາມາດສ້າງການຈັດສົ່ງຈາກຜູ້ໃຫ້ບໍລິການໄດ້, ການຈັດສົ່ງພາຍໃນບໍ່ໄດ້ຖືກບັນທຶກ.',
    providerEstimateFailed: 'ບໍ່ສາມາດປະເມີນຄ່າຈັດສົ່ງຈາກຜູ້ໃຫ້ບໍລິການໄດ້.',
    estimateFee: 'ປະເມີນຄ່າທຳນຽມຈາກຜູ້ໃຫ້ບໍລິການ',
    feeEstimated: 'ອັບເດດຄ່າຈັດສົ່ງຈາກຜູ້ໃຫ້ບໍລິການແລ້ວ.',
    reCreate: 'ສ້າງໃໝ່',
    update: 'ອັບເດດ',
    updateStatus: 'ອັບເດດສະຖານະ',
    updateInfo: 'ແກ້ໄຂຂໍ້ມູນການຈັດສົ່ງ',
    updateInfoTitle: 'ອັບເດດຂໍ້ມູນການຈັດສົ່ງ',
    updateInfoHint: 'ອະນຸຍາດໃຫ້ແກ້ໄຂລະຫັດຕິດຕາມ, URL ຕິດຕາມ, ສະຖານະຈາກຜູ້ໃຫ້ບໍລິການ ແລະ ໝາຍເຫດ ໂດຍບໍ່ປ່ຽນສະຖານະຈັດສົ່ງພາຍໃນ.',
    updateStatusTitle: 'ອັບເດດສະຖານະການຈັດສົ່ງ',
    updateStatusHint: 'ໃຊ້ສະຖານະຈັດສົ່ງພາຍໃນເທົ່ານັ້ນ, ບໍ່ກະທົບຕໍ່ເມນູເລືອກ Orders.status ເກົ່າ.',
    cancel: 'ຍົກເລີກການຈັດສົ່ງ',
    cancelConfirm: 'ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການຍົກເລີກປ້າຍຈັດສົ່ງນີ້?',
    cancelWarning: 'ການດຳເນີນການນີ້ບໍ່ສາມາດຍ້ອນກັບໄດ້.',
    irregularTransitionConfirm: 'ສະຖານະທີ່ເລືອກບໍ່ຢູ່ໃນຂັ້ນຕອນປົກກະຕິ. ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການອັບເດດ?',
    status: 'ສະຖານະການຈັດສົ່ງ',
    newStatus: 'ສະຖານະໃໝ່',
    message: 'ຂໍ້ຄວາມ',
    note: 'ໝາຍເຫດ',
    tracking: 'ການຕິດຕາມ',
    trackingCode: 'ລະຫັດຕິດຕາມ',
    trackingUrl: 'URL ຕິດຕາມ',
    openTracking: 'ເປີດລິ້ງຕິດຕາມ',
    provider: 'ຜູ້ໃຫ້ບໍລິການຈັດສົ່ງ',
    providerStatusLabel: 'ສະຖານະຈາກຜູ້ໃຫ້ບໍລິການ',
    providerRequired: 'ກະລຸນາເລືອກຜູ້ໃຫ້ບໍລິການຈັດສົ່ງ.',
    providers: 'ຜູ້ໃຫ້ບໍລິການຈັດສົ່ງ',
    providersDetail: 'ຕັ້ງຄ່າ GHN/GHTK/J&T/Viettel Post ດ້ວຍຊ່ອງຟອມທີ່ລະບຸຊັດເຈນ. JSON ດິບຈະຢູ່ໃນສ່ວນຂັ້ນສູງສຳລັບ dev/support ເທົ່ານັ້ນ.',
    addConfig: 'ເພີ່ມການຕັ້ງຄ່າ',
    editConfig: 'ແກ້ໄຂການຕັ້ງຄ່າ',
    saveConfigTitle: 'ບັນທຶກການຕັ້ງຄ່າຜູ້ໃຫ້ບໍລິການ',
    saveConfig: 'ບັນທຶກການຕັ້ງຄ່າ',
    displayName: 'ຊື່ທີ່ສະແດງ',
    webhookSecret: 'ລະຫັດລັບ Webhook',
    notConfigured: 'ຍັງບໍ່ໄດ້ຕັ້ງຄ່າ',
    credentials: 'ຂໍ້ມູນຢືນຢັນ',
    credentialsJson: 'ຂໍ້ມູນຢືນຢັນ (JSON)',
    invalidCredentialsJson: 'JSON ຂອງຂໍ້ມູນຢືນຢັນບໍ່ຖືກຕ້ອງ',
    invalidProviderConfigJson: 'JSON ຂອງຂໍ້ມູນຢືນຢັນ ຫຼື ການຕັ້ງຄ່າບໍ່ຖືກຕ້ອງ',
    providerSettings: 'ການຕັ້ງຄ່າຜູ້ໃຫ້ບໍລິການ',
    providerSettingsJson: 'ການຕັ້ງຄ່າຜູ້ໃຫ້ບໍລິການ (JSON)',
    providerConfigGuide: 'ຊ່ອງຂໍ້ມູນທີ່ແນະນຳຕາມຜູ້ໃຫ້ບໍລິການ',
    providerAccountInfo: 'ຂໍ້ມູນບັນຊີຜູ້ໃຫ້ບໍລິການ',
    providerConfigFromAccount: 'ຄ່າເຫຼົ່ານີ້ມາຈາກບັນຊີ GHN/GHTK/J&T/Viettel Post ຫຼື ຂໍ້ມູນສາງຮັບສິນຄ້າຂອງຮ້ານ.',
    manualConfigDescription: 'ໃຊ້ສ່ວນນີ້ເມື່ອຮ້ານມີລະຫັດຕິດຕາມຈາກພາຍນອກແລ້ວ ແລະ ຕ້ອງການປ້ອນເອງ. ບໍ່ຈຳເປັນຕ້ອງມີ token ຫຼື ການຕັ້ງຄ່າ API.',
    providerSummary: 'ສະຫຼຸບການຕັ້ງຄ່າ',
    token: 'Token',
    newToken: 'Token ໃໝ່',
    newTokenPlaceholder: 'ປ້ອນ token ໃໝ່ເມື່ອຕ້ອງການແທນທີ່ token ປັດຈຸບັນເທົ່ານັ້ນ',
    tokenConfigured: 'ຕັ້ງຄ່າແລ້ວ',
    tokenNotConfigured: 'ຍັງບໍ່ໄດ້ຕັ້ງຄ່າ',
    configured: 'ຕັ້ງຄ່າແລ້ວ',
    environment: 'ສະພາບແວດລ້ອມ',
    environmentList: {
      sandbox: 'ສະພາບແວດລ້ອມທົດລອງ',
      production: 'ສະພາບແວດລ້ອມໃຊ້ງານຈິງ'
    },
    autoMappedBaseUrl: 'URL API ທີ່ຈັບຄູ່ອັດຕະໂນມັດ',
    customBaseUrl: 'baseUrl ກຳນົດເອງ',
    serviceTypeId: 'ປະເພດບໍລິການຄ່າເລີ່ມຕົ້ນ',
    paymentTypeId: 'ຜູ້ຈ່າຍຄ່າສົ່ງຄ່າເລີ່ມຕົ້ນ',
    paymentTypeList: {
      shop: 'ຮ້ານຈ່າຍ',
      customer: 'ລູກຄ້າຈ່າຍ'
    },
    shopId: 'Shop ID',
    partnerCode: 'ລະຫັດພາດເນີ',
    customerCode: 'ລະຫັດລູກຄ້າ',
    jtApiKey: 'J&T API Key',
    viettelUsername: 'ຊື່ຜູ້ໃຊ້ Viettel',
    viettelPassword: 'ລະຫັດຜ່ານ Viettel',
    viettelCredential: 'Viettel token ຫຼື ບັນຊີ',
    originCode: 'ລະຫັດຕົ້ນທາງ',
    destinationCode: 'ລະຫັດປາຍທາງ',
    receiverArea: 'ລະຫັດພື້ນທີ່ຜູ້ຮັບ',
    orderPrefix: 'ຄຳນຳໜ້າລະຫັດຄຳສັ່ງຊື້',
    createEndpoint: 'ຈຸດປາຍທາງສຳລັບສ້າງ',
    trackEndpoint: 'ຈຸດປາຍທາງສຳລັບຕິດຕາມ',
    payloadKey: 'ຄີຂໍ້ມູນສຳລັບຕິດຕາມ',
    pickupWarehouseInfo: 'ຂໍ້ມູນສາງຮັບສິນຄ້າ',
    pickupWarehouseHint: 'ປ້ອນຂໍ້ມູນສາງ ຫຼື ຮ້ານທີ່ໃຊ້ໃຫ້ GHTK ມາຮັບສິນຄ້າເພື່ອສ້າງການຈັດສົ່ງອັດຕະໂນມັດ.',
    jtSenderHint: 'J&T ຕ້ອງການຂໍ້ມູນຜູ້ສົ່ງຄົບຖ້ວນເພື່ອສ້າງການຈັດສົ່ງຜ່ານ API.',
    viettelSenderHint: 'Viettel Post ຕ້ອງການຂໍ້ມູນຜູ້ສົ່ງຄົບຖ້ວນ; ທ່ານສາມາດໃຊ້ token ຫຼື ຊື່ຜູ້ໃຊ້/ລະຫັດຜ່ານ.',
    pickupName: 'ຊື່ສາງຮັບສິນຄ້າ',
    pickupPhone: 'ເບີໂທສາງຮັບສິນຄ້າ',
    pickupAddress: 'ທີ່ຢູ່ສາງຮັບສິນຄ້າ',
    pickupProvince: 'ແຂວງທີ່ຮັບສິນຄ້າ',
    pickupDistrict: 'ເມືອງທີ່ຮັບສິນຄ້າ',
    pickupWard: 'ບ້ານທີ່ຮັບສິນຄ້າ',
    ghnProvince: 'ແຂວງ (GHN)',
    ghnDistrict: 'ເມືອງ (GHN)',
    ghnWard: 'ບ້ານ (GHN)',
    ghnAddressHint: 'ກະລຸນາເລືອກທີ່ຢູ່ມາດຕະຖານຂອງ GHN ເພື່ອສ້າງການຈັດສົ່ງ.',
    ghnMasterDataError: 'ຜິດພາດໃນການດຶງຂໍ້ມູນທີ່ຢູ່ GHN. ກະລຸນາລອງໃໝ່.',
    advancedSettings: 'ຂັ້ນສູງ',
    advancedSettingsHint: 'ໃຊ້ເມື່ອຕ້ອງການປ່ຽນ baseUrl ຫຼື ປ້ອນ JSON ດິບສຳລັບການພັດທະນາ/ສະໜັບສະໜູນເທົ່ານັ້ນ.',
    credentialsJsonAdvanced: 'JSON ຂໍ້ມູນຢືນຢັນຕົວຕົນ (ຂັ້ນສູງ)',
    providerSettingsJsonAdvanced: 'JSON ການຕັ້ງຄ່າ (ຂັ້ນສູງ)',
    requiredFieldMissing: 'ກະລຸນາຕັ້ງຄ່າ %s ກ່ອນບັນທຶກ.',
    hasData: 'ມີຂໍ້ມູນ',
    empty: 'ຫວ່າງ',
    none: 'ບໍ່ມີ',
    activeThisProvider: 'ເປີດໃຊ້ຜູ້ໃຫ້ບໍລິການນີ້',
    code: 'ລະຫັດຕິດຕາມ',
    receiver: 'ຜູ້ຮັບ',
    phone: 'ເບີໂທ',
    address: 'ທີ່ຢູ່ຈັດສົ່ງ',
    fee: 'ຄ່າຈັດສົ່ງ',
    cod: 'ຈຳນວນເງິນ COD',
    lastWebhook: 'Webhook ລ່າສຸດ',
    notUpdate: 'ຍັງບໍ່ໄດ້ອັບເດດ',
    timeline: 'ໄທມ໌ລາຍການຈັດສົ່ງ',
    history: 'ລຳດັບເວລາການຈັດສົ່ງ',
    timelineDetail: 'ປະຫວັດການອັບເດດຈາກ webhook ຫຼືການດຳເນີນການດ້ວຍຕົນເອງ.',
    noLogs: 'ຍັງບໍ່ມີບັນທຶກການຈັດສົ່ງ.',
    waitSync: 'ກຳລັງລໍຖ້າຊິງຂໍ້ມູນ',
    updateHint: 'ອັບເດດສະຖານະການຈັດສົ່ງແລ້ວ.',
    currentStatusHint: 'ສະຖານະປັດຈຸບັນຂອງໃບປ້າຍຈັດສົ່ງ.',
    updatedBy: 'ອັບເດດໂດຍ',
    statusList: {
      none: 'ຍັງບໍ່ໄດ້ສ້າງ',
      draft: 'ຮ່າງ',
      awaiting_pickup: 'ລໍຖ້າຮັບພັດສະດຸ',
      pickup_in_progress: 'ກຳລັງຮັບພັດສະດຸ',
      picked_up: 'ຮັບພັດສະດຸແລ້ວ',
      sorting: 'ກຳລັງຄັດແຍກ',
      in_transit: 'ກຳລັງຂົນສົ່ງ',
      out_for_delivery: 'ກຳລັງນຳສົ່ງ',
      delivered: 'ຈັດສົ່ງສຳເລັດ',
      delivery_failed: 'ຈັດສົ່ງບໍ່ສຳເລັດ',
      canceled: 'ຍົກເລີກແລ້ວ',
      return_requested: 'ມີຄຳຂໍສົ່ງຄືນ',
      return_in_transit: 'ກຳລັງສົ່ງຄືນ',
      returned: 'ສົ່ງຄືນແລ້ວ',
      exception: 'ຂໍ້ຜິດປົກກະຕິ'
    },
    providerList: {
      manual: 'ດ້ວຍຕົນເອງ',
      manualDetail: 'ປ້ອນແລະອັບເດດດ້ວຍຕົນເອງ',
      ghn: 'GHN',
      ghnDetail: 'ເຊື່ອມຕໍ່ GHN API',
      ghtk: 'GHTK',
      ghtkDetail: 'ເຊື່ອມຕໍ່ GHTK API',
      jt: 'J&T Express',
      jtDetail: 'ເຊື່ອມຕໍ່ J&T API',
      viettel_post: 'Viettel Post',
      viettel_postDetail: 'ເຊື່ອມຕໍ່ Viettel Post API'
    },
    createModeList: {
      manual: 'ສ້າງດ້ວຍຕົນເອງ',
      provider: 'ສ້າງຜ່ານຜູ້ໃຫ້ບໍລິການ'
    },
    configFieldLabels: {
      token: 'Token',
      environment: 'ສະພາບແວດລ້ອມ',
      baseUrl: 'API URL',
      serviceTypeId: 'ປະເພດບໍລິການເລີ່ມຕົ້ນ',
      paymentTypeId: 'ຜູ້ຊຳລະເງິນເລີ່ມຕົ້ນ',
      webhookSecret: 'Webhook Secret',
      shopId: 'ລະຫັດຮ້ານຄ້າ',
      key: 'J&T API Key',
      customerCode: 'ລະຫັດລູກຄ້າ',
      username: 'ຊື່ຜູ້ໃຊ້ Viettel',
      password: 'ລະຫັດຜ່ານ Viettel',
      originCode: 'ລະຫັດຕົ້ນທາງ',
      destinationCode: 'ລະຫັດປາຍທາງ',
      receiverArea: 'ລະຫັດເຂດພື້ນທີ່ຜູ້ຮັບ',
      pickupName: 'ຊື່ສາງຮັບສິນຄ້າ',
      pickupPhone: 'ເບີໂທສາງຮັບສິນຄ້າ',
      pickupAddress: 'ທີ່ຢູ່ສາງຮັບສິນຄ້າ',
      pickupProvince: 'ແຂວງຮັບສິນຄ້າ',
      pickupDistrict: 'ເມືອງຮັບສິນຄ້າ',
      pickupWard: 'ບ້ານຮັບສິນຄ້າ'
    }
  }
};
